module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId])
      /******/
      return installedModules[moduleId].exports;
    /******/

    /******/
    // Create a new module (and put it into the cache)

    /******/

    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // identity function for calling harmory imports with the correct context

  /******/

  __webpack_require__.i = function (value) {
    return value;
  };
  /******/

  /******/
  // define getter function for harmory exports

  /******/


  __webpack_require__.d = function (exports, name, getter) {
    /******/
    Object.defineProperty(exports, name, {
      /******/
      configurable: false,

      /******/
      enumerable: true,

      /******/
      get: getter
      /******/

    });
    /******/
  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 56);
  /******/
}(
/************************************************************************/

/******/
[
/* 0 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var undefined;
  var $SyntaxError = SyntaxError;
  var $Function = Function;
  var $TypeError = TypeError; // eslint-disable-next-line consistent-return

  var getEvalledConstructor = function getEvalledConstructor(expressionSyntax) {
    try {
      return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
  };

  var $gOPD = Object.getOwnPropertyDescriptor;

  if ($gOPD) {
    try {
      $gOPD({}, '');
    } catch (e) {
      $gOPD = null; // this is IE 8, which has a broken gOPD
    }
  }

  var throwTypeError = function throwTypeError() {
    throw new $TypeError();
  };

  var ThrowTypeError = $gOPD ? function () {
    try {
      // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
      arguments.callee; // IE 8 does not throw here

      return throwTypeError;
    } catch (calleeThrows) {
      try {
        // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
        return $gOPD(arguments, 'callee').get;
      } catch (gOPDthrows) {
        return throwTypeError;
      }
    }
  }() : throwTypeError;

  var hasSymbols = __webpack_require__(44)();

  var hasProto = __webpack_require__(43)();

  var getProto = Object.getPrototypeOf || (hasProto ? function (x) {
    return x.__proto__;
  } // eslint-disable-line no-proto
  : null);
  var needsEval = {};
  var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
  var INTRINSICS = {
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': needsEval,
    '%AsyncGenerator%': needsEval,
    '%AsyncGeneratorFunction%': needsEval,
    '%AsyncIteratorPrototype%': needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%eval%': eval,
    // eslint-disable-line no-eval
    '%EvalError%': EvalError,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $Function,
    '%GeneratorFunction%': needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': Object,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': RangeError,
    '%ReferenceError%': ReferenceError,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
    '%Symbol%': hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $SyntaxError,
    '%ThrowTypeError%': ThrowTypeError,
    '%TypedArray%': TypedArray,
    '%TypeError%': $TypeError,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': URIError,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
  };

  if (getProto) {
    try {
      null.error; // eslint-disable-line no-unused-expressions
    } catch (e) {
      // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
      var errorProto = getProto(getProto(e));
      INTRINSICS['%Error.prototype%'] = errorProto;
    }
  }

  var doEval = function doEval(name) {
    var value;

    if (name === '%AsyncFunction%') {
      value = getEvalledConstructor('async function () {}');
    } else if (name === '%GeneratorFunction%') {
      value = getEvalledConstructor('function* () {}');
    } else if (name === '%AsyncGeneratorFunction%') {
      value = getEvalledConstructor('async function* () {}');
    } else if (name === '%AsyncGenerator%') {
      var fn = doEval('%AsyncGeneratorFunction%');

      if (fn) {
        value = fn.prototype;
      }
    } else if (name === '%AsyncIteratorPrototype%') {
      var gen = doEval('%AsyncGenerator%');

      if (gen && getProto) {
        value = getProto(gen.prototype);
      }
    }

    INTRINSICS[name] = value;
    return value;
  };

  var LEGACY_ALIASES = {
    '%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
    '%ArrayPrototype%': ['Array', 'prototype'],
    '%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
    '%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
    '%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
    '%ArrayProto_values%': ['Array', 'prototype', 'values'],
    '%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
    '%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
    '%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
    '%BooleanPrototype%': ['Boolean', 'prototype'],
    '%DataViewPrototype%': ['DataView', 'prototype'],
    '%DatePrototype%': ['Date', 'prototype'],
    '%ErrorPrototype%': ['Error', 'prototype'],
    '%EvalErrorPrototype%': ['EvalError', 'prototype'],
    '%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
    '%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
    '%FunctionPrototype%': ['Function', 'prototype'],
    '%Generator%': ['GeneratorFunction', 'prototype'],
    '%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
    '%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
    '%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
    '%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
    '%JSONParse%': ['JSON', 'parse'],
    '%JSONStringify%': ['JSON', 'stringify'],
    '%MapPrototype%': ['Map', 'prototype'],
    '%NumberPrototype%': ['Number', 'prototype'],
    '%ObjectPrototype%': ['Object', 'prototype'],
    '%ObjProto_toString%': ['Object', 'prototype', 'toString'],
    '%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
    '%PromisePrototype%': ['Promise', 'prototype'],
    '%PromiseProto_then%': ['Promise', 'prototype', 'then'],
    '%Promise_all%': ['Promise', 'all'],
    '%Promise_reject%': ['Promise', 'reject'],
    '%Promise_resolve%': ['Promise', 'resolve'],
    '%RangeErrorPrototype%': ['RangeError', 'prototype'],
    '%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
    '%RegExpPrototype%': ['RegExp', 'prototype'],
    '%SetPrototype%': ['Set', 'prototype'],
    '%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
    '%StringPrototype%': ['String', 'prototype'],
    '%SymbolPrototype%': ['Symbol', 'prototype'],
    '%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
    '%TypedArrayPrototype%': ['TypedArray', 'prototype'],
    '%TypeErrorPrototype%': ['TypeError', 'prototype'],
    '%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
    '%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
    '%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
    '%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
    '%URIErrorPrototype%': ['URIError', 'prototype'],
    '%WeakMapPrototype%': ['WeakMap', 'prototype'],
    '%WeakSetPrototype%': ['WeakSet', 'prototype']
  };

  var bind = __webpack_require__(12);

  var hasOwn = __webpack_require__(46);

  var $concat = bind.call(Function.call, Array.prototype.concat);
  var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
  var $replace = bind.call(Function.call, String.prototype.replace);
  var $strSlice = bind.call(Function.call, String.prototype.slice);
  var $exec = bind.call(Function.call, RegExp.prototype.exec);
  /* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */

  var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
  var reEscapeChar = /\\(\\)?/g;
  /** Used to match backslashes in property paths. */

  var stringToPath = function stringToPath(string) {
    var first = $strSlice(string, 0, 1);
    var last = $strSlice(string, -1);

    if (first === '%' && last !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
    } else if (last === '%' && first !== '%') {
      throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
    }

    var result = [];
    $replace(string, rePropName, function (match, number, quote, subString) {
      result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
    });
    return result;
  };
  /* end adaptation */


  var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;

    if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
      alias = LEGACY_ALIASES[intrinsicName];
      intrinsicName = '%' + alias[0] + '%';
    }

    if (hasOwn(INTRINSICS, intrinsicName)) {
      var value = INTRINSICS[intrinsicName];

      if (value === needsEval) {
        value = doEval(intrinsicName);
      }

      if (typeof value === 'undefined' && !allowMissing) {
        throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
      }

      return {
        alias: alias,
        name: intrinsicName,
        value: value
      };
    }

    throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
  };

  module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) {
      throw new $TypeError('intrinsic name must be a non-empty string');
    }

    if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
      throw new $TypeError('"allowMissing" argument must be a boolean');
    }

    if ($exec(/^%?[^%]*%?$/, name) === null) {
      throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    }

    var parts = stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;

    if (alias) {
      intrinsicBaseName = alias[0];
      $spliceApply(parts, $concat([0, 1], alias));
    }

    for (var i = 1, isOwn = true; i < parts.length; i += 1) {
      var part = parts[i];
      var first = $strSlice(part, 0, 1);
      var last = $strSlice(part, -1);

      if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) {
        throw new $SyntaxError('property names with quotes must have matching quotes');
      }

      if (part === 'constructor' || !isOwn) {
        skipFurtherCaching = true;
      }

      intrinsicBaseName += '.' + part;
      intrinsicRealName = '%' + intrinsicBaseName + '%';

      if (hasOwn(INTRINSICS, intrinsicRealName)) {
        value = INTRINSICS[intrinsicRealName];
      } else if (value != null) {
        if (!(part in value)) {
          if (!allowMissing) {
            throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
          }

          return void undefined;
        }

        if ($gOPD && i + 1 >= parts.length) {
          var desc = $gOPD(value, part);
          isOwn = !!desc; // By convention, when a data property is converted to an accessor
          // property to emulate a data property that does not suffer from
          // the override mistake, that accessor's getter is marked with
          // an `originalValue` property. Here, when we detect this, we
          // uphold the illusion by pretending to see that original data
          // property, i.e., returning the value rather than the getter
          // itself.

          if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
            value = desc.get;
          } else {
            value = value[part];
          }
        } else {
          isOwn = hasOwn(value, part);
          value = value[part];
        }

        if (isOwn && !skipFurtherCaching) {
          INTRINSICS[intrinsicRealName] = value;
        }
      }
    }

    return value;
  };
  /***/

},
/* 1 */

/***/
function (module, exports) {
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 2 */

/***/
function (module, exports, __webpack_require__) {
  var toPropertyKey = __webpack_require__(17);

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }

  module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 3 */

/***/
function (module, exports) {
  function _getPrototypeOf(o) {
    module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _getPrototypeOf(o);
  }

  module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 4 */

/***/
function (module, exports, __webpack_require__) {
  var setPrototypeOf = __webpack_require__(30);

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) setPrototypeOf(subClass, superClass);
  }

  module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 5 */

/***/
function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(10)["default"];

  var assertThisInitialized = __webpack_require__(16);

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }

    return assertThisInitialized(self);
  }

  module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 6 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (process, global, setImmediate) {
    /* @preserve
    * The MIT License (MIT)
    * 
    * Copyright (c) 2013-2018 Petka Antonov
    * 
    * Permission is hereby granted, free of charge, to any person obtaining a copy
    * of this software and associated documentation files (the "Software"), to deal
    * in the Software without restriction, including without limitation the rights
    * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    * copies of the Software, and to permit persons to whom the Software is
    * furnished to do so, subject to the following conditions:
    * 
    * The above copyright notice and this permission notice shall be included in
    * all copies or substantial portions of the Software.
    * 
    * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
    * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
    * THE SOFTWARE.
    * 
    */

    /**
     * bluebird build version 3.7.2
     * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
    */
    !function (e) {
      if (true) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
        var f;
        "undefined" != typeof window ? f = window : "undefined" != typeof global ? f = global : "undefined" != typeof self && (f = self), f.Promise = e();
      }
    }(function () {
      var define, module, exports;
      return function e(t, n, r) {
        function s(o, u) {
          if (!n[o]) {
            if (!t[o]) {
              var a = typeof _dereq_ == "function" && _dereq_;
              if (!u && a) return a(o, !0);
              if (i) return i(o, !0);
              var f = new Error("Cannot find module '" + o + "'");
              throw f.code = "MODULE_NOT_FOUND", f;
            }

            var l = n[o] = {
              exports: {}
            };
            t[o][0].call(l.exports, function (e) {
              var n = t[o][1][e];
              return s(n ? n : e);
            }, l, l.exports, e, t, n, r);
          }

          return n[o].exports;
        }

        var i = typeof _dereq_ == "function" && _dereq_;

        for (var o = 0; o < r.length; o++) {
          s(r[o]);
        }

        return s;
      }({
        1: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise) {
            var SomePromiseArray = Promise._SomePromiseArray;

            function any(promises) {
              var ret = new SomePromiseArray(promises);
              var promise = ret.promise();
              ret.setHowMany(1);
              ret.setUnwrap();
              ret.init();
              return promise;
            }

            Promise.any = function (promises) {
              return any(promises);
            };

            Promise.prototype.any = function () {
              return any(this);
            };
          };
        }, {}],
        2: [function (_dereq_, module, exports) {
          "use strict";

          var firstLineError;

          try {
            throw new Error();
          } catch (e) {
            firstLineError = e;
          }

          var schedule = _dereq_("./schedule");

          var Queue = _dereq_("./queue");

          function Async() {
            this._customScheduler = false;
            this._isTickUsed = false;
            this._lateQueue = new Queue(16);
            this._normalQueue = new Queue(16);
            this._haveDrainedQueues = false;
            var self = this;

            this.drainQueues = function () {
              self._drainQueues();
            };

            this._schedule = schedule;
          }

          Async.prototype.setScheduler = function (fn) {
            var prev = this._schedule;
            this._schedule = fn;
            this._customScheduler = true;
            return prev;
          };

          Async.prototype.hasCustomScheduler = function () {
            return this._customScheduler;
          };

          Async.prototype.haveItemsQueued = function () {
            return this._isTickUsed || this._haveDrainedQueues;
          };

          Async.prototype.fatalError = function (e, isNode) {
            if (isNode) {
              process.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
              process.exit(2);
            } else {
              this.throwLater(e);
            }
          };

          Async.prototype.throwLater = function (fn, arg) {
            if (arguments.length === 1) {
              arg = fn;

              fn = function fn() {
                throw arg;
              };
            }

            if (typeof setTimeout !== "undefined") {
              setTimeout(function () {
                fn(arg);
              }, 0);
            } else try {
              this._schedule(function () {
                fn(arg);
              });
            } catch (e) {
              throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
            }
          };

          function AsyncInvokeLater(fn, receiver, arg) {
            this._lateQueue.push(fn, receiver, arg);

            this._queueTick();
          }

          function AsyncInvoke(fn, receiver, arg) {
            this._normalQueue.push(fn, receiver, arg);

            this._queueTick();
          }

          function AsyncSettlePromises(promise) {
            this._normalQueue._pushOne(promise);

            this._queueTick();
          }

          Async.prototype.invokeLater = AsyncInvokeLater;
          Async.prototype.invoke = AsyncInvoke;
          Async.prototype.settlePromises = AsyncSettlePromises;

          function _drainQueue(queue) {
            while (queue.length() > 0) {
              _drainQueueStep(queue);
            }
          }

          function _drainQueueStep(queue) {
            var fn = queue.shift();

            if (typeof fn !== "function") {
              fn._settlePromises();
            } else {
              var receiver = queue.shift();
              var arg = queue.shift();
              fn.call(receiver, arg);
            }
          }

          Async.prototype._drainQueues = function () {
            _drainQueue(this._normalQueue);

            this._reset();

            this._haveDrainedQueues = true;

            _drainQueue(this._lateQueue);
          };

          Async.prototype._queueTick = function () {
            if (!this._isTickUsed) {
              this._isTickUsed = true;

              this._schedule(this.drainQueues);
            }
          };

          Async.prototype._reset = function () {
            this._isTickUsed = false;
          };

          module.exports = Async;
          module.exports.firstLineError = firstLineError;
        }, {
          "./queue": 26,
          "./schedule": 29
        }],
        3: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL, tryConvertToPromise, debug) {
            var calledBind = false;

            var rejectThis = function rejectThis(_, e) {
              this._reject(e);
            };

            var targetRejected = function targetRejected(e, context) {
              context.promiseRejectionQueued = true;

              context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
            };

            var bindingResolved = function bindingResolved(thisArg, context) {
              if ((this._bitField & 50397184) === 0) {
                this._resolveCallback(context.target);
              }
            };

            var bindingRejected = function bindingRejected(e, context) {
              if (!context.promiseRejectionQueued) this._reject(e);
            };

            Promise.prototype.bind = function (thisArg) {
              if (!calledBind) {
                calledBind = true;
                Promise.prototype._propagateFrom = debug.propagateFromFunction();
                Promise.prototype._boundValue = debug.boundValueFunction();
              }

              var maybePromise = tryConvertToPromise(thisArg);
              var ret = new Promise(INTERNAL);

              ret._propagateFrom(this, 1);

              var target = this._target();

              ret._setBoundTo(maybePromise);

              if (maybePromise instanceof Promise) {
                var context = {
                  promiseRejectionQueued: false,
                  promise: ret,
                  target: target,
                  bindingPromise: maybePromise
                };

                target._then(INTERNAL, targetRejected, undefined, ret, context);

                maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);

                ret._setOnCancel(maybePromise);
              } else {
                ret._resolveCallback(target);
              }

              return ret;
            };

            Promise.prototype._setBoundTo = function (obj) {
              if (obj !== undefined) {
                this._bitField = this._bitField | 2097152;
                this._boundTo = obj;
              } else {
                this._bitField = this._bitField & ~2097152;
              }
            };

            Promise.prototype._isBound = function () {
              return (this._bitField & 2097152) === 2097152;
            };

            Promise.bind = function (thisArg, value) {
              return Promise.resolve(value).bind(thisArg);
            };
          };
        }, {}],
        4: [function (_dereq_, module, exports) {
          "use strict";

          var old;
          if (typeof Promise !== "undefined") old = Promise;

          function noConflict() {
            try {
              if (Promise === bluebird) Promise = old;
            } catch (e) {}

            return bluebird;
          }

          var bluebird = _dereq_("./promise")();

          bluebird.noConflict = noConflict;
          module.exports = bluebird;
        }, {
          "./promise": 22
        }],
        5: [function (_dereq_, module, exports) {
          "use strict";

          var cr = Object.create;

          if (cr) {
            var callerCache = cr(null);
            var getterCache = cr(null);
            callerCache[" size"] = getterCache[" size"] = 0;
          }

          module.exports = function (Promise) {
            var util = _dereq_("./util");

            var canEvaluate = util.canEvaluate;
            var isIdentifier = util.isIdentifier;
            var getMethodCaller;
            var getGetter;

            if (false) {
              var makeMethodCaller = function makeMethodCaller(methodName) {
                return new Function("ensureMethod", "                                    \n\
        return function(obj) {                                               \n\
            'use strict'                                                     \n\
            var len = this.length;                                           \n\
            ensureMethod(obj, 'methodName');                                 \n\
            switch(len) {                                                    \n\
                case 1: return obj.methodName(this[0]);                      \n\
                case 2: return obj.methodName(this[0], this[1]);             \n\
                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
                case 0: return obj.methodName();                             \n\
                default:                                                     \n\
                    return obj.methodName.apply(obj, this);                  \n\
            }                                                                \n\
        };                                                                   \n\
        ".replace(/methodName/g, methodName))(ensureMethod);
              };

              var makeGetter = function makeGetter(propertyName) {
                return new Function("obj", "                                             \n\
        'use strict';                                                        \n\
        return obj.propertyName;                                             \n\
        ".replace("propertyName", propertyName));
              };

              var getCompiled = function getCompiled(name, compiler, cache) {
                var ret = cache[name];

                if (typeof ret !== "function") {
                  if (!isIdentifier(name)) {
                    return null;
                  }

                  ret = compiler(name);
                  cache[name] = ret;
                  cache[" size"]++;

                  if (cache[" size"] > 512) {
                    var keys = Object.keys(cache);

                    for (var i = 0; i < 256; ++i) {
                      delete cache[keys[i]];
                    }

                    cache[" size"] = keys.length - 256;
                  }
                }

                return ret;
              };

              getMethodCaller = function getMethodCaller(name) {
                return getCompiled(name, makeMethodCaller, callerCache);
              };

              getGetter = function getGetter(name) {
                return getCompiled(name, makeGetter, getterCache);
              };
            }

            function ensureMethod(obj, methodName) {
              var fn;
              if (obj != null) fn = obj[methodName];

              if (typeof fn !== "function") {
                var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                throw new Promise.TypeError(message);
              }

              return fn;
            }

            function caller(obj) {
              var methodName = this.pop();
              var fn = ensureMethod(obj, methodName);
              return fn.apply(obj, this);
            }

            Promise.prototype.call = function (methodName) {
              var args = [].slice.call(arguments, 1);
              ;

              if (false) {
                if (canEvaluate) {
                  var maybeCaller = getMethodCaller(methodName);

                  if (maybeCaller !== null) {
                    return this._then(maybeCaller, undefined, undefined, args, undefined);
                  }
                }
              }

              args.push(methodName);
              return this._then(caller, undefined, undefined, args, undefined);
            };

            function namedGetter(obj) {
              return obj[this];
            }

            function indexedGetter(obj) {
              var index = +this;
              if (index < 0) index = Math.max(0, index + obj.length);
              return obj[index];
            }

            Promise.prototype.get = function (propertyName) {
              var isIndex = typeof propertyName === "number";
              var getter;

              if (!isIndex) {
                if (canEvaluate) {
                  var maybeGetter = getGetter(propertyName);
                  getter = maybeGetter !== null ? maybeGetter : namedGetter;
                } else {
                  getter = namedGetter;
                }
              } else {
                getter = indexedGetter;
              }

              return this._then(getter, undefined, undefined, propertyName, undefined);
            };
          };
        }, {
          "./util": 36
        }],
        6: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, apiRejection, debug) {
            var util = _dereq_("./util");

            var tryCatch = util.tryCatch;
            var errorObj = util.errorObj;
            var async = Promise._async;

            Promise.prototype["break"] = Promise.prototype.cancel = function () {
              if (!debug.cancellation()) return this._warn("cancellation is disabled");
              var promise = this;
              var child = promise;

              while (promise._isCancellable()) {
                if (!promise._cancelBy(child)) {
                  if (child._isFollowing()) {
                    child._followee().cancel();
                  } else {
                    child._cancelBranched();
                  }

                  break;
                }

                var parent = promise._cancellationParent;

                if (parent == null || !parent._isCancellable()) {
                  if (promise._isFollowing()) {
                    promise._followee().cancel();
                  } else {
                    promise._cancelBranched();
                  }

                  break;
                } else {
                  if (promise._isFollowing()) promise._followee().cancel();

                  promise._setWillBeCancelled();

                  child = promise;
                  promise = parent;
                }
              }
            };

            Promise.prototype._branchHasCancelled = function () {
              this._branchesRemainingToCancel--;
            };

            Promise.prototype._enoughBranchesHaveCancelled = function () {
              return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
            };

            Promise.prototype._cancelBy = function (canceller) {
              if (canceller === this) {
                this._branchesRemainingToCancel = 0;

                this._invokeOnCancel();

                return true;
              } else {
                this._branchHasCancelled();

                if (this._enoughBranchesHaveCancelled()) {
                  this._invokeOnCancel();

                  return true;
                }
              }

              return false;
            };

            Promise.prototype._cancelBranched = function () {
              if (this._enoughBranchesHaveCancelled()) {
                this._cancel();
              }
            };

            Promise.prototype._cancel = function () {
              if (!this._isCancellable()) return;

              this._setCancelled();

              async.invoke(this._cancelPromises, this, undefined);
            };

            Promise.prototype._cancelPromises = function () {
              if (this._length() > 0) this._settlePromises();
            };

            Promise.prototype._unsetOnCancel = function () {
              this._onCancelField = undefined;
            };

            Promise.prototype._isCancellable = function () {
              return this.isPending() && !this._isCancelled();
            };

            Promise.prototype.isCancellable = function () {
              return this.isPending() && !this.isCancelled();
            };

            Promise.prototype._doInvokeOnCancel = function (onCancelCallback, internalOnly) {
              if (util.isArray(onCancelCallback)) {
                for (var i = 0; i < onCancelCallback.length; ++i) {
                  this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                }
              } else if (onCancelCallback !== undefined) {
                if (typeof onCancelCallback === "function") {
                  if (!internalOnly) {
                    var e = tryCatch(onCancelCallback).call(this._boundValue());

                    if (e === errorObj) {
                      this._attachExtraTrace(e.e);

                      async.throwLater(e.e);
                    }
                  }
                } else {
                  onCancelCallback._resultCancelled(this);
                }
              }
            };

            Promise.prototype._invokeOnCancel = function () {
              var onCancelCallback = this._onCancel();

              this._unsetOnCancel();

              async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
            };

            Promise.prototype._invokeInternalOnCancel = function () {
              if (this._isCancellable()) {
                this._doInvokeOnCancel(this._onCancel(), true);

                this._unsetOnCancel();
              }
            };

            Promise.prototype._resultCancelled = function () {
              this.cancel();
            };
          };
        }, {
          "./util": 36
        }],
        7: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (NEXT_FILTER) {
            var util = _dereq_("./util");

            var getKeys = _dereq_("./es5").keys;

            var tryCatch = util.tryCatch;
            var errorObj = util.errorObj;

            function catchFilter(instances, cb, promise) {
              return function (e) {
                var boundTo = promise._boundValue();

                predicateLoop: for (var i = 0; i < instances.length; ++i) {
                  var item = instances[i];

                  if (item === Error || item != null && item.prototype instanceof Error) {
                    if (e instanceof item) {
                      return tryCatch(cb).call(boundTo, e);
                    }
                  } else if (typeof item === "function") {
                    var matchesPredicate = tryCatch(item).call(boundTo, e);

                    if (matchesPredicate === errorObj) {
                      return matchesPredicate;
                    } else if (matchesPredicate) {
                      return tryCatch(cb).call(boundTo, e);
                    }
                  } else if (util.isObject(e)) {
                    var keys = getKeys(item);

                    for (var j = 0; j < keys.length; ++j) {
                      var key = keys[j];

                      if (item[key] != e[key]) {
                        continue predicateLoop;
                      }
                    }

                    return tryCatch(cb).call(boundTo, e);
                  }
                }

                return NEXT_FILTER;
              };
            }

            return catchFilter;
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        8: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise) {
            var longStackTraces = false;
            var contextStack = [];

            Promise.prototype._promiseCreated = function () {};

            Promise.prototype._pushContext = function () {};

            Promise.prototype._popContext = function () {
              return null;
            };

            Promise._peekContext = Promise.prototype._peekContext = function () {};

            function Context() {
              this._trace = new Context.CapturedTrace(peekContext());
            }

            Context.prototype._pushContext = function () {
              if (this._trace !== undefined) {
                this._trace._promiseCreated = null;
                contextStack.push(this._trace);
              }
            };

            Context.prototype._popContext = function () {
              if (this._trace !== undefined) {
                var trace = contextStack.pop();
                var ret = trace._promiseCreated;
                trace._promiseCreated = null;
                return ret;
              }

              return null;
            };

            function createContext() {
              if (longStackTraces) return new Context();
            }

            function peekContext() {
              var lastIndex = contextStack.length - 1;

              if (lastIndex >= 0) {
                return contextStack[lastIndex];
              }

              return undefined;
            }

            Context.CapturedTrace = null;
            Context.create = createContext;

            Context.deactivateLongStackTraces = function () {};

            Context.activateLongStackTraces = function () {
              var Promise_pushContext = Promise.prototype._pushContext;
              var Promise_popContext = Promise.prototype._popContext;
              var Promise_PeekContext = Promise._peekContext;
              var Promise_peekContext = Promise.prototype._peekContext;
              var Promise_promiseCreated = Promise.prototype._promiseCreated;

              Context.deactivateLongStackTraces = function () {
                Promise.prototype._pushContext = Promise_pushContext;
                Promise.prototype._popContext = Promise_popContext;
                Promise._peekContext = Promise_PeekContext;
                Promise.prototype._peekContext = Promise_peekContext;
                Promise.prototype._promiseCreated = Promise_promiseCreated;
                longStackTraces = false;
              };

              longStackTraces = true;
              Promise.prototype._pushContext = Context.prototype._pushContext;
              Promise.prototype._popContext = Context.prototype._popContext;
              Promise._peekContext = Promise.prototype._peekContext = peekContext;

              Promise.prototype._promiseCreated = function () {
                var ctx = this._peekContext();

                if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
              };
            };

            return Context;
          };
        }, {}],
        9: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, Context, enableAsyncHooks, disableAsyncHooks) {
            var async = Promise._async;

            var Warning = _dereq_("./errors").Warning;

            var util = _dereq_("./util");

            var es5 = _dereq_("./es5");

            var canAttachTrace = util.canAttachTrace;
            var unhandledRejectionHandled;
            var possiblyUnhandledRejection;
            var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
            var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
            var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
            var stackFramePattern = null;
            var formatStack = null;
            var indentStackFrames = false;
            var printWarning;
            var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && (true || util.env("BLUEBIRD_DEBUG") || util.env("NODE_ENV") === "development"));
            var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
            var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
            var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
            var deferUnhandledRejectionCheck;

            (function () {
              var promises = [];

              function unhandledRejectionCheck() {
                for (var i = 0; i < promises.length; ++i) {
                  promises[i]._notifyUnhandledRejection();
                }

                unhandledRejectionClear();
              }

              function unhandledRejectionClear() {
                promises.length = 0;
              }

              deferUnhandledRejectionCheck = function deferUnhandledRejectionCheck(promise) {
                promises.push(promise);
                setTimeout(unhandledRejectionCheck, 1);
              };

              es5.defineProperty(Promise, "_unhandledRejectionCheck", {
                value: unhandledRejectionCheck
              });
              es5.defineProperty(Promise, "_unhandledRejectionClear", {
                value: unhandledRejectionClear
              });
            })();

            Promise.prototype.suppressUnhandledRejections = function () {
              var target = this._target();

              target._bitField = target._bitField & ~1048576 | 524288;
            };

            Promise.prototype._ensurePossibleRejectionHandled = function () {
              if ((this._bitField & 524288) !== 0) return;

              this._setRejectionIsUnhandled();

              deferUnhandledRejectionCheck(this);
            };

            Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
              fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
            };

            Promise.prototype._setReturnedNonUndefined = function () {
              this._bitField = this._bitField | 268435456;
            };

            Promise.prototype._returnedNonUndefined = function () {
              return (this._bitField & 268435456) !== 0;
            };

            Promise.prototype._notifyUnhandledRejection = function () {
              if (this._isRejectionUnhandled()) {
                var reason = this._settledValue();

                this._setUnhandledRejectionIsNotified();

                fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
              }
            };

            Promise.prototype._setUnhandledRejectionIsNotified = function () {
              this._bitField = this._bitField | 262144;
            };

            Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
              this._bitField = this._bitField & ~262144;
            };

            Promise.prototype._isUnhandledRejectionNotified = function () {
              return (this._bitField & 262144) > 0;
            };

            Promise.prototype._setRejectionIsUnhandled = function () {
              this._bitField = this._bitField | 1048576;
            };

            Promise.prototype._unsetRejectionIsUnhandled = function () {
              this._bitField = this._bitField & ~1048576;

              if (this._isUnhandledRejectionNotified()) {
                this._unsetUnhandledRejectionIsNotified();

                this._notifyUnhandledRejectionIsHandled();
              }
            };

            Promise.prototype._isRejectionUnhandled = function () {
              return (this._bitField & 1048576) > 0;
            };

            Promise.prototype._warn = function (message, shouldUseOwnTrace, promise) {
              return warn(message, shouldUseOwnTrace, promise || this);
            };

            Promise.onPossiblyUnhandledRejection = function (fn) {
              var context = Promise._getContext();

              possiblyUnhandledRejection = util.contextBind(context, fn);
            };

            Promise.onUnhandledRejectionHandled = function (fn) {
              var context = Promise._getContext();

              unhandledRejectionHandled = util.contextBind(context, fn);
            };

            var disableLongStackTraces = function disableLongStackTraces() {};

            Promise.longStackTraces = function () {
              if (async.haveItemsQueued() && !config.longStackTraces) {
                throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
              }

              if (!config.longStackTraces && longStackTracesIsSupported()) {
                var Promise_captureStackTrace = Promise.prototype._captureStackTrace;
                var Promise_attachExtraTrace = Promise.prototype._attachExtraTrace;
                var Promise_dereferenceTrace = Promise.prototype._dereferenceTrace;
                config.longStackTraces = true;

                disableLongStackTraces = function disableLongStackTraces() {
                  if (async.haveItemsQueued() && !config.longStackTraces) {
                    throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");
                  }

                  Promise.prototype._captureStackTrace = Promise_captureStackTrace;
                  Promise.prototype._attachExtraTrace = Promise_attachExtraTrace;
                  Promise.prototype._dereferenceTrace = Promise_dereferenceTrace;
                  Context.deactivateLongStackTraces();
                  config.longStackTraces = false;
                };

                Promise.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                Promise.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                Promise.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                Context.activateLongStackTraces();
              }
            };

            Promise.hasLongStackTraces = function () {
              return config.longStackTraces && longStackTracesIsSupported();
            };

            var legacyHandlers = {
              unhandledrejection: {
                before: function before() {
                  var ret = util.global.onunhandledrejection;
                  util.global.onunhandledrejection = null;
                  return ret;
                },
                after: function after(fn) {
                  util.global.onunhandledrejection = fn;
                }
              },
              rejectionhandled: {
                before: function before() {
                  var ret = util.global.onrejectionhandled;
                  util.global.onrejectionhandled = null;
                  return ret;
                },
                after: function after(fn) {
                  util.global.onrejectionhandled = fn;
                }
              }
            };

            var fireDomEvent = function () {
              var dispatch = function dispatch(legacy, e) {
                if (legacy) {
                  var fn;

                  try {
                    fn = legacy.before();
                    return !util.global.dispatchEvent(e);
                  } finally {
                    legacy.after(fn);
                  }
                } else {
                  return !util.global.dispatchEvent(e);
                }
              };

              try {
                if (typeof CustomEvent === "function") {
                  var event = new CustomEvent("CustomEvent");
                  util.global.dispatchEvent(event);
                  return function (name, event) {
                    name = name.toLowerCase();
                    var eventData = {
                      detail: event,
                      cancelable: true
                    };
                    var domEvent = new CustomEvent(name, eventData);
                    es5.defineProperty(domEvent, "promise", {
                      value: event.promise
                    });
                    es5.defineProperty(domEvent, "reason", {
                      value: event.reason
                    });
                    return dispatch(legacyHandlers[name], domEvent);
                  };
                } else if (typeof Event === "function") {
                  var event = new Event("CustomEvent");
                  util.global.dispatchEvent(event);
                  return function (name, event) {
                    name = name.toLowerCase();
                    var domEvent = new Event(name, {
                      cancelable: true
                    });
                    domEvent.detail = event;
                    es5.defineProperty(domEvent, "promise", {
                      value: event.promise
                    });
                    es5.defineProperty(domEvent, "reason", {
                      value: event.reason
                    });
                    return dispatch(legacyHandlers[name], domEvent);
                  };
                } else {
                  var event = document.createEvent("CustomEvent");
                  event.initCustomEvent("testingtheevent", false, true, {});
                  util.global.dispatchEvent(event);
                  return function (name, event) {
                    name = name.toLowerCase();
                    var domEvent = document.createEvent("CustomEvent");
                    domEvent.initCustomEvent(name, false, true, event);
                    return dispatch(legacyHandlers[name], domEvent);
                  };
                }
              } catch (e) {}

              return function () {
                return false;
              };
            }();

            var fireGlobalEvent = function () {
              if (util.isNode) {
                return function () {
                  return process.emit.apply(process, arguments);
                };
              } else {
                if (!util.global) {
                  return function () {
                    return false;
                  };
                }

                return function (name) {
                  var methodName = "on" + name.toLowerCase();
                  var method = util.global[methodName];
                  if (!method) return false;
                  method.apply(util.global, [].slice.call(arguments, 1));
                  return true;
                };
              }
            }();

            function generatePromiseLifecycleEventObject(name, promise) {
              return {
                promise: promise
              };
            }

            var eventToObjectGenerator = {
              promiseCreated: generatePromiseLifecycleEventObject,
              promiseFulfilled: generatePromiseLifecycleEventObject,
              promiseRejected: generatePromiseLifecycleEventObject,
              promiseResolved: generatePromiseLifecycleEventObject,
              promiseCancelled: generatePromiseLifecycleEventObject,
              promiseChained: function promiseChained(name, promise, child) {
                return {
                  promise: promise,
                  child: child
                };
              },
              warning: function warning(name, _warning) {
                return {
                  warning: _warning
                };
              },
              unhandledRejection: function unhandledRejection(name, reason, promise) {
                return {
                  reason: reason,
                  promise: promise
                };
              },
              rejectionHandled: generatePromiseLifecycleEventObject
            };

            var activeFireEvent = function activeFireEvent(name) {
              var globalEventFired = false;

              try {
                globalEventFired = fireGlobalEvent.apply(null, arguments);
              } catch (e) {
                async.throwLater(e);
                globalEventFired = true;
              }

              var domEventFired = false;

              try {
                domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
              } catch (e) {
                async.throwLater(e);
                domEventFired = true;
              }

              return domEventFired || globalEventFired;
            };

            Promise.config = function (opts) {
              opts = Object(opts);

              if ("longStackTraces" in opts) {
                if (opts.longStackTraces) {
                  Promise.longStackTraces();
                } else if (!opts.longStackTraces && Promise.hasLongStackTraces()) {
                  disableLongStackTraces();
                }
              }

              if ("warnings" in opts) {
                var warningsOption = opts.warnings;
                config.warnings = !!warningsOption;
                wForgottenReturn = config.warnings;

                if (util.isObject(warningsOption)) {
                  if ("wForgottenReturn" in warningsOption) {
                    wForgottenReturn = !!warningsOption.wForgottenReturn;
                  }
                }
              }

              if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                if (async.haveItemsQueued()) {
                  throw new Error("cannot enable cancellation after promises are in use");
                }

                Promise.prototype._clearCancellationData = cancellationClearCancellationData;
                Promise.prototype._propagateFrom = cancellationPropagateFrom;
                Promise.prototype._onCancel = cancellationOnCancel;
                Promise.prototype._setOnCancel = cancellationSetOnCancel;
                Promise.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                Promise.prototype._execute = cancellationExecute;
                _propagateFromFunction = cancellationPropagateFrom;
                config.cancellation = true;
              }

              if ("monitoring" in opts) {
                if (opts.monitoring && !config.monitoring) {
                  config.monitoring = true;
                  Promise.prototype._fireEvent = activeFireEvent;
                } else if (!opts.monitoring && config.monitoring) {
                  config.monitoring = false;
                  Promise.prototype._fireEvent = defaultFireEvent;
                }
              }

              if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                var prev = config.asyncHooks;
                var cur = !!opts.asyncHooks;

                if (prev !== cur) {
                  config.asyncHooks = cur;

                  if (cur) {
                    enableAsyncHooks();
                  } else {
                    disableAsyncHooks();
                  }
                }
              }

              return Promise;
            };

            function defaultFireEvent() {
              return false;
            }

            Promise.prototype._fireEvent = defaultFireEvent;

            Promise.prototype._execute = function (executor, resolve, reject) {
              try {
                executor(resolve, reject);
              } catch (e) {
                return e;
              }
            };

            Promise.prototype._onCancel = function () {};

            Promise.prototype._setOnCancel = function (handler) {
              ;
            };

            Promise.prototype._attachCancellationCallback = function (onCancel) {
              ;
            };

            Promise.prototype._captureStackTrace = function () {};

            Promise.prototype._attachExtraTrace = function () {};

            Promise.prototype._dereferenceTrace = function () {};

            Promise.prototype._clearCancellationData = function () {};

            Promise.prototype._propagateFrom = function (parent, flags) {
              ;
              ;
            };

            function cancellationExecute(executor, resolve, reject) {
              var promise = this;

              try {
                executor(resolve, reject, function (onCancel) {
                  if (typeof onCancel !== "function") {
                    throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                  }

                  promise._attachCancellationCallback(onCancel);
                });
              } catch (e) {
                return e;
              }
            }

            function cancellationAttachCancellationCallback(onCancel) {
              if (!this._isCancellable()) return this;

              var previousOnCancel = this._onCancel();

              if (previousOnCancel !== undefined) {
                if (util.isArray(previousOnCancel)) {
                  previousOnCancel.push(onCancel);
                } else {
                  this._setOnCancel([previousOnCancel, onCancel]);
                }
              } else {
                this._setOnCancel(onCancel);
              }
            }

            function cancellationOnCancel() {
              return this._onCancelField;
            }

            function cancellationSetOnCancel(onCancel) {
              this._onCancelField = onCancel;
            }

            function cancellationClearCancellationData() {
              this._cancellationParent = undefined;
              this._onCancelField = undefined;
            }

            function cancellationPropagateFrom(parent, flags) {
              if ((flags & 1) !== 0) {
                this._cancellationParent = parent;
                var branchesRemainingToCancel = parent._branchesRemainingToCancel;

                if (branchesRemainingToCancel === undefined) {
                  branchesRemainingToCancel = 0;
                }

                parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
              }

              if ((flags & 2) !== 0 && parent._isBound()) {
                this._setBoundTo(parent._boundTo);
              }
            }

            function bindingPropagateFrom(parent, flags) {
              if ((flags & 2) !== 0 && parent._isBound()) {
                this._setBoundTo(parent._boundTo);
              }
            }

            var _propagateFromFunction = bindingPropagateFrom;

            function _boundValueFunction() {
              var ret = this._boundTo;

              if (ret !== undefined) {
                if (ret instanceof Promise) {
                  if (ret.isFulfilled()) {
                    return ret.value();
                  } else {
                    return undefined;
                  }
                }
              }

              return ret;
            }

            function longStackTracesCaptureStackTrace() {
              this._trace = new CapturedTrace(this._peekContext());
            }

            function longStackTracesAttachExtraTrace(error, ignoreSelf) {
              if (canAttachTrace(error)) {
                var trace = this._trace;

                if (trace !== undefined) {
                  if (ignoreSelf) trace = trace._parent;
                }

                if (trace !== undefined) {
                  trace.attachExtraTrace(error);
                } else if (!error.__stackCleaned__) {
                  var parsed = parseStackAndMessage(error);
                  util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                  util.notEnumerableProp(error, "__stackCleaned__", true);
                }
              }
            }

            function longStackTracesDereferenceTrace() {
              this._trace = undefined;
            }

            function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
              if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                if (parent !== undefined && parent._returnedNonUndefined()) return;
                if ((promise._bitField & 65535) === 0) return;
                if (name) name = name + " ";
                var handlerLine = "";
                var creatorLine = "";

                if (promiseCreated._trace) {
                  var traceLines = promiseCreated._trace.stack.split("\n");

                  var stack = cleanStack(traceLines);

                  for (var i = stack.length - 1; i >= 0; --i) {
                    var line = stack[i];

                    if (!nodeFramePattern.test(line)) {
                      var lineMatches = line.match(parseLinePattern);

                      if (lineMatches) {
                        handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                      }

                      break;
                    }
                  }

                  if (stack.length > 0) {
                    var firstUserLine = stack[0];

                    for (var i = 0; i < traceLines.length; ++i) {
                      if (traceLines[i] === firstUserLine) {
                        if (i > 0) {
                          creatorLine = "\n" + traceLines[i - 1];
                        }

                        break;
                      }
                    }
                  }
                }

                var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;

                promise._warn(msg, true, promiseCreated);
              }
            }

            function deprecated(name, replacement) {
              var message = name + " is deprecated and will be removed in a future version.";
              if (replacement) message += " Use " + replacement + " instead.";
              return warn(message);
            }

            function warn(message, shouldUseOwnTrace, promise) {
              if (!config.warnings) return;
              var warning = new Warning(message);
              var ctx;

              if (shouldUseOwnTrace) {
                promise._attachExtraTrace(warning);
              } else if (config.longStackTraces && (ctx = Promise._peekContext())) {
                ctx.attachExtraTrace(warning);
              } else {
                var parsed = parseStackAndMessage(warning);
                warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
              }

              if (!activeFireEvent("warning", warning)) {
                formatAndLogError(warning, "", true);
              }
            }

            function reconstructStack(message, stacks) {
              for (var i = 0; i < stacks.length - 1; ++i) {
                stacks[i].push("From previous event:");
                stacks[i] = stacks[i].join("\n");
              }

              if (i < stacks.length) {
                stacks[i] = stacks[i].join("\n");
              }

              return message + "\n" + stacks.join("\n");
            }

            function removeDuplicateOrEmptyJumps(stacks) {
              for (var i = 0; i < stacks.length; ++i) {
                if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                  stacks.splice(i, 1);
                  i--;
                }
              }
            }

            function removeCommonRoots(stacks) {
              var current = stacks[0];

              for (var i = 1; i < stacks.length; ++i) {
                var prev = stacks[i];
                var currentLastIndex = current.length - 1;
                var currentLastLine = current[currentLastIndex];
                var commonRootMeetPoint = -1;

                for (var j = prev.length - 1; j >= 0; --j) {
                  if (prev[j] === currentLastLine) {
                    commonRootMeetPoint = j;
                    break;
                  }
                }

                for (var j = commonRootMeetPoint; j >= 0; --j) {
                  var line = prev[j];

                  if (current[currentLastIndex] === line) {
                    current.pop();
                    currentLastIndex--;
                  } else {
                    break;
                  }
                }

                current = prev;
              }
            }

            function cleanStack(stack) {
              var ret = [];

              for (var i = 0; i < stack.length; ++i) {
                var line = stack[i];
                var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                var isInternalFrame = isTraceLine && shouldIgnore(line);

                if (isTraceLine && !isInternalFrame) {
                  if (indentStackFrames && line.charAt(0) !== " ") {
                    line = "    " + line;
                  }

                  ret.push(line);
                }
              }

              return ret;
            }

            function stackFramesAsArray(error) {
              var stack = error.stack.replace(/\s+$/g, "").split("\n");

              for (var i = 0; i < stack.length; ++i) {
                var line = stack[i];

                if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
                  break;
                }
              }

              if (i > 0 && error.name != "SyntaxError") {
                stack = stack.slice(i);
              }

              return stack;
            }

            function parseStackAndMessage(error) {
              var stack = error.stack;
              var message = error.toString();
              stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : ["    (No stack trace)"];
              return {
                message: message,
                stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
              };
            }

            function formatAndLogError(error, title, isSoft) {
              if (typeof console !== "undefined") {
                var message;

                if (util.isObject(error)) {
                  var stack = error.stack;
                  message = title + formatStack(stack, error);
                } else {
                  message = title + String(error);
                }

                if (typeof printWarning === "function") {
                  printWarning(message, isSoft);
                } else if (typeof console.log === "function" || typeof console.log === "object") {
                  console.log(message);
                }
              }
            }

            function fireRejectionEvent(name, localHandler, reason, promise) {
              var localEventFired = false;

              try {
                if (typeof localHandler === "function") {
                  localEventFired = true;

                  if (name === "rejectionHandled") {
                    localHandler(promise);
                  } else {
                    localHandler(reason, promise);
                  }
                }
              } catch (e) {
                async.throwLater(e);
              }

              if (name === "unhandledRejection") {
                if (!activeFireEvent(name, reason, promise) && !localEventFired) {
                  formatAndLogError(reason, "Unhandled rejection ");
                }
              } else {
                activeFireEvent(name, promise);
              }
            }

            function formatNonError(obj) {
              var str;

              if (typeof obj === "function") {
                str = "[function " + (obj.name || "anonymous") + "]";
              } else {
                str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;

                if (ruselessToString.test(str)) {
                  try {
                    var newStr = JSON.stringify(obj);
                    str = newStr;
                  } catch (e) {}
                }

                if (str.length === 0) {
                  str = "(empty array)";
                }
              }

              return "(<" + snip(str) + ">, no stack trace)";
            }

            function snip(str) {
              var maxChars = 41;

              if (str.length < maxChars) {
                return str;
              }

              return str.substr(0, maxChars - 3) + "...";
            }

            function longStackTracesIsSupported() {
              return typeof captureStackTrace === "function";
            }

            var shouldIgnore = function shouldIgnore() {
              return false;
            };

            var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;

            function parseLineInfo(line) {
              var matches = line.match(parseLineInfoRegex);

              if (matches) {
                return {
                  fileName: matches[1],
                  line: parseInt(matches[2], 10)
                };
              }
            }

            function setBounds(firstLineError, lastLineError) {
              if (!longStackTracesIsSupported()) return;
              var firstStackLines = (firstLineError.stack || "").split("\n");
              var lastStackLines = (lastLineError.stack || "").split("\n");
              var firstIndex = -1;
              var lastIndex = -1;
              var firstFileName;
              var lastFileName;

              for (var i = 0; i < firstStackLines.length; ++i) {
                var result = parseLineInfo(firstStackLines[i]);

                if (result) {
                  firstFileName = result.fileName;
                  firstIndex = result.line;
                  break;
                }
              }

              for (var i = 0; i < lastStackLines.length; ++i) {
                var result = parseLineInfo(lastStackLines[i]);

                if (result) {
                  lastFileName = result.fileName;
                  lastIndex = result.line;
                  break;
                }
              }

              if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) {
                return;
              }

              shouldIgnore = function shouldIgnore(line) {
                if (bluebirdFramePattern.test(line)) return true;
                var info = parseLineInfo(line);

                if (info) {
                  if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) {
                    return true;
                  }
                }

                return false;
              };
            }

            function CapturedTrace(parent) {
              this._parent = parent;
              this._promisesCreated = 0;
              var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
              captureStackTrace(this, CapturedTrace);
              if (length > 32) this.uncycle();
            }

            util.inherits(CapturedTrace, Error);
            Context.CapturedTrace = CapturedTrace;

            CapturedTrace.prototype.uncycle = function () {
              var length = this._length;
              if (length < 2) return;
              var nodes = [];
              var stackToIndex = {};

              for (var i = 0, node = this; node !== undefined; ++i) {
                nodes.push(node);
                node = node._parent;
              }

              length = this._length = i;

              for (var i = length - 1; i >= 0; --i) {
                var stack = nodes[i].stack;

                if (stackToIndex[stack] === undefined) {
                  stackToIndex[stack] = i;
                }
              }

              for (var i = 0; i < length; ++i) {
                var currentStack = nodes[i].stack;
                var index = stackToIndex[currentStack];

                if (index !== undefined && index !== i) {
                  if (index > 0) {
                    nodes[index - 1]._parent = undefined;
                    nodes[index - 1]._length = 1;
                  }

                  nodes[i]._parent = undefined;
                  nodes[i]._length = 1;
                  var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

                  if (index < length - 1) {
                    cycleEdgeNode._parent = nodes[index + 1];

                    cycleEdgeNode._parent.uncycle();

                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                  } else {
                    cycleEdgeNode._parent = undefined;
                    cycleEdgeNode._length = 1;
                  }

                  var currentChildLength = cycleEdgeNode._length + 1;

                  for (var j = i - 2; j >= 0; --j) {
                    nodes[j]._length = currentChildLength;
                    currentChildLength++;
                  }

                  return;
                }
              }
            };

            CapturedTrace.prototype.attachExtraTrace = function (error) {
              if (error.__stackCleaned__) return;
              this.uncycle();
              var parsed = parseStackAndMessage(error);
              var message = parsed.message;
              var stacks = [parsed.stack];
              var trace = this;

              while (trace !== undefined) {
                stacks.push(cleanStack(trace.stack.split("\n")));
                trace = trace._parent;
              }

              removeCommonRoots(stacks);
              removeDuplicateOrEmptyJumps(stacks);
              util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
              util.notEnumerableProp(error, "__stackCleaned__", true);
            };

            var captureStackTrace = function stackDetection() {
              var v8stackFramePattern = /^\s*at\s*/;

              var v8stackFormatter = function v8stackFormatter(stack, error) {
                if (typeof stack === "string") return stack;

                if (error.name !== undefined && error.message !== undefined) {
                  return error.toString();
                }

                return formatNonError(error);
              };

              if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                Error.stackTraceLimit += 6;
                stackFramePattern = v8stackFramePattern;
                formatStack = v8stackFormatter;
                var captureStackTrace = Error.captureStackTrace;

                shouldIgnore = function shouldIgnore(line) {
                  return bluebirdFramePattern.test(line);
                };

                return function (receiver, ignoreUntil) {
                  Error.stackTraceLimit += 6;
                  captureStackTrace(receiver, ignoreUntil);
                  Error.stackTraceLimit -= 6;
                };
              }

              var err = new Error();

              if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                stackFramePattern = /@/;
                formatStack = v8stackFormatter;
                indentStackFrames = true;
                return function captureStackTrace(o) {
                  o.stack = new Error().stack;
                };
              }

              var hasStackAfterThrow;

              try {
                throw new Error();
              } catch (e) {
                hasStackAfterThrow = "stack" in e;
              }

              if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                stackFramePattern = v8stackFramePattern;
                formatStack = v8stackFormatter;
                return function captureStackTrace(o) {
                  Error.stackTraceLimit += 6;

                  try {
                    throw new Error();
                  } catch (e) {
                    o.stack = e.stack;
                  }

                  Error.stackTraceLimit -= 6;
                };
              }

              formatStack = function formatStack(stack, error) {
                if (typeof stack === "string") return stack;

                if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) {
                  return error.toString();
                }

                return formatNonError(error);
              };

              return null;
            }([]);

            if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
              printWarning = function printWarning(message) {
                console.warn(message);
              };

              if (util.isNode && process.stderr.isTTY) {
                printWarning = function printWarning(message, isSoft) {
                  var color = isSoft ? "\x1B[33m" : "\x1B[31m";
                  console.warn(color + message + "\x1B[0m\n");
                };
              } else if (!util.isNode && typeof new Error().stack === "string") {
                printWarning = function printWarning(message, isSoft) {
                  console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                };
              }
            }

            var config = {
              warnings: warnings,
              longStackTraces: false,
              cancellation: false,
              monitoring: false,
              asyncHooks: false
            };
            if (longStackTraces) Promise.longStackTraces();
            return {
              asyncHooks: function asyncHooks() {
                return config.asyncHooks;
              },
              longStackTraces: function longStackTraces() {
                return config.longStackTraces;
              },
              warnings: function warnings() {
                return config.warnings;
              },
              cancellation: function cancellation() {
                return config.cancellation;
              },
              monitoring: function monitoring() {
                return config.monitoring;
              },
              propagateFromFunction: function propagateFromFunction() {
                return _propagateFromFunction;
              },
              boundValueFunction: function boundValueFunction() {
                return _boundValueFunction;
              },
              checkForgottenReturns: checkForgottenReturns,
              setBounds: setBounds,
              warn: warn,
              deprecated: deprecated,
              CapturedTrace: CapturedTrace,
              fireDomEvent: fireDomEvent,
              fireGlobalEvent: fireGlobalEvent
            };
          };
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        10: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise) {
            function returner() {
              return this.value;
            }

            function thrower() {
              throw this.reason;
            }

            Promise.prototype["return"] = Promise.prototype.thenReturn = function (value) {
              if (value instanceof Promise) value.suppressUnhandledRejections();
              return this._then(returner, undefined, undefined, {
                value: value
              }, undefined);
            };

            Promise.prototype["throw"] = Promise.prototype.thenThrow = function (reason) {
              return this._then(thrower, undefined, undefined, {
                reason: reason
              }, undefined);
            };

            Promise.prototype.catchThrow = function (reason) {
              if (arguments.length <= 1) {
                return this._then(undefined, thrower, undefined, {
                  reason: reason
                }, undefined);
              } else {
                var _reason = arguments[1];

                var handler = function handler() {
                  throw _reason;
                };

                return this.caught(reason, handler);
              }
            };

            Promise.prototype.catchReturn = function (value) {
              if (arguments.length <= 1) {
                if (value instanceof Promise) value.suppressUnhandledRejections();
                return this._then(undefined, returner, undefined, {
                  value: value
                }, undefined);
              } else {
                var _value = arguments[1];
                if (_value instanceof Promise) _value.suppressUnhandledRejections();

                var handler = function handler() {
                  return _value;
                };

                return this.caught(value, handler);
              }
            };
          };
        }, {}],
        11: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL) {
            var PromiseReduce = Promise.reduce;
            var PromiseAll = Promise.all;

            function promiseAllThis() {
              return PromiseAll(this);
            }

            function PromiseMapSeries(promises, fn) {
              return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
            }

            Promise.prototype.each = function (fn) {
              return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
            };

            Promise.prototype.mapSeries = function (fn) {
              return PromiseReduce(this, fn, INTERNAL, INTERNAL);
            };

            Promise.each = function (promises, fn) {
              return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
            };

            Promise.mapSeries = PromiseMapSeries;
          };
        }, {}],
        12: [function (_dereq_, module, exports) {
          "use strict";

          var es5 = _dereq_("./es5");

          var Objectfreeze = es5.freeze;

          var util = _dereq_("./util");

          var inherits = util.inherits;
          var notEnumerableProp = util.notEnumerableProp;

          function subError(nameProperty, defaultMessage) {
            function SubError(message) {
              if (!(this instanceof SubError)) return new SubError(message);
              notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
              notEnumerableProp(this, "name", nameProperty);

              if (Error.captureStackTrace) {
                Error.captureStackTrace(this, this.constructor);
              } else {
                Error.call(this);
              }
            }

            inherits(SubError, Error);
            return SubError;
          }

          var _TypeError, _RangeError;

          var Warning = subError("Warning", "warning");
          var CancellationError = subError("CancellationError", "cancellation error");
          var TimeoutError = subError("TimeoutError", "timeout error");
          var AggregateError = subError("AggregateError", "aggregate error");

          try {
            _TypeError = TypeError;
            _RangeError = RangeError;
          } catch (e) {
            _TypeError = subError("TypeError", "type error");
            _RangeError = subError("RangeError", "range error");
          }

          var methods = ("join pop push shift unshift slice filter forEach some " + "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

          for (var i = 0; i < methods.length; ++i) {
            if (typeof Array.prototype[methods[i]] === "function") {
              AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
            }
          }

          es5.defineProperty(AggregateError.prototype, "length", {
            value: 0,
            configurable: false,
            writable: true,
            enumerable: true
          });
          AggregateError.prototype["isOperational"] = true;
          var level = 0;

          AggregateError.prototype.toString = function () {
            var indent = Array(level * 4 + 1).join(" ");
            var ret = "\n" + indent + "AggregateError of:" + "\n";
            level++;
            indent = Array(level * 4 + 1).join(" ");

            for (var i = 0; i < this.length; ++i) {
              var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
              var lines = str.split("\n");

              for (var j = 0; j < lines.length; ++j) {
                lines[j] = indent + lines[j];
              }

              str = lines.join("\n");
              ret += str + "\n";
            }

            level--;
            return ret;
          };

          function OperationalError(message) {
            if (!(this instanceof OperationalError)) return new OperationalError(message);
            notEnumerableProp(this, "name", "OperationalError");
            notEnumerableProp(this, "message", message);
            this.cause = message;
            this["isOperational"] = true;

            if (message instanceof Error) {
              notEnumerableProp(this, "message", message.message);
              notEnumerableProp(this, "stack", message.stack);
            } else if (Error.captureStackTrace) {
              Error.captureStackTrace(this, this.constructor);
            }
          }

          inherits(OperationalError, Error);
          var errorTypes = Error["__BluebirdErrorTypes__"];

          if (!errorTypes) {
            errorTypes = Objectfreeze({
              CancellationError: CancellationError,
              TimeoutError: TimeoutError,
              OperationalError: OperationalError,
              RejectionError: OperationalError,
              AggregateError: AggregateError
            });
            es5.defineProperty(Error, "__BluebirdErrorTypes__", {
              value: errorTypes,
              writable: false,
              enumerable: false,
              configurable: false
            });
          }

          module.exports = {
            Error: Error,
            TypeError: _TypeError,
            RangeError: _RangeError,
            CancellationError: errorTypes.CancellationError,
            OperationalError: errorTypes.OperationalError,
            TimeoutError: errorTypes.TimeoutError,
            AggregateError: errorTypes.AggregateError,
            Warning: Warning
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        13: [function (_dereq_, module, exports) {
          var isES5 = function () {
            "use strict";

            return this === undefined;
          }();

          if (isES5) {
            module.exports = {
              freeze: Object.freeze,
              defineProperty: Object.defineProperty,
              getDescriptor: Object.getOwnPropertyDescriptor,
              keys: Object.keys,
              names: Object.getOwnPropertyNames,
              getPrototypeOf: Object.getPrototypeOf,
              isArray: Array.isArray,
              isES5: isES5,
              propertyIsWritable: function propertyIsWritable(obj, prop) {
                var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                return !!(!descriptor || descriptor.writable || descriptor.set);
              }
            };
          } else {
            var has = {}.hasOwnProperty;
            var str = {}.toString;
            var proto = {}.constructor.prototype;

            var ObjectKeys = function ObjectKeys(o) {
              var ret = [];

              for (var key in o) {
                if (has.call(o, key)) {
                  ret.push(key);
                }
              }

              return ret;
            };

            var ObjectGetDescriptor = function ObjectGetDescriptor(o, key) {
              return {
                value: o[key]
              };
            };

            var ObjectDefineProperty = function ObjectDefineProperty(o, key, desc) {
              o[key] = desc.value;
              return o;
            };

            var ObjectFreeze = function ObjectFreeze(obj) {
              return obj;
            };

            var ObjectGetPrototypeOf = function ObjectGetPrototypeOf(obj) {
              try {
                return Object(obj).constructor.prototype;
              } catch (e) {
                return proto;
              }
            };

            var ArrayIsArray = function ArrayIsArray(obj) {
              try {
                return str.call(obj) === "[object Array]";
              } catch (e) {
                return false;
              }
            };

            module.exports = {
              isArray: ArrayIsArray,
              keys: ObjectKeys,
              names: ObjectKeys,
              defineProperty: ObjectDefineProperty,
              getDescriptor: ObjectGetDescriptor,
              freeze: ObjectFreeze,
              getPrototypeOf: ObjectGetPrototypeOf,
              isES5: isES5,
              propertyIsWritable: function propertyIsWritable() {
                return true;
              }
            };
          }
        }, {}],
        14: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL) {
            var PromiseMap = Promise.map;

            Promise.prototype.filter = function (fn, options) {
              return PromiseMap(this, fn, options, INTERNAL);
            };

            Promise.filter = function (promises, fn, options) {
              return PromiseMap(promises, fn, options, INTERNAL);
            };
          };
        }, {}],
        15: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, tryConvertToPromise, NEXT_FILTER) {
            var util = _dereq_("./util");

            var CancellationError = Promise.CancellationError;
            var errorObj = util.errorObj;

            var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

            function PassThroughHandlerContext(promise, type, handler) {
              this.promise = promise;
              this.type = type;
              this.handler = handler;
              this.called = false;
              this.cancelPromise = null;
            }

            PassThroughHandlerContext.prototype.isFinallyHandler = function () {
              return this.type === 0;
            };

            function FinallyHandlerCancelReaction(finallyHandler) {
              this.finallyHandler = finallyHandler;
            }

            FinallyHandlerCancelReaction.prototype._resultCancelled = function () {
              checkCancel(this.finallyHandler);
            };

            function checkCancel(ctx, reason) {
              if (ctx.cancelPromise != null) {
                if (arguments.length > 1) {
                  ctx.cancelPromise._reject(reason);
                } else {
                  ctx.cancelPromise._cancel();
                }

                ctx.cancelPromise = null;
                return true;
              }

              return false;
            }

            function succeed() {
              return finallyHandler.call(this, this.promise._target()._settledValue());
            }

            function fail(reason) {
              if (checkCancel(this, reason)) return;
              errorObj.e = reason;
              return errorObj;
            }

            function finallyHandler(reasonOrValue) {
              var promise = this.promise;
              var handler = this.handler;

              if (!this.called) {
                this.called = true;
                var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);

                if (ret === NEXT_FILTER) {
                  return ret;
                } else if (ret !== undefined) {
                  promise._setReturnedNonUndefined();

                  var maybePromise = tryConvertToPromise(ret, promise);

                  if (maybePromise instanceof Promise) {
                    if (this.cancelPromise != null) {
                      if (maybePromise._isCancelled()) {
                        var reason = new CancellationError("late cancellation observer");

                        promise._attachExtraTrace(reason);

                        errorObj.e = reason;
                        return errorObj;
                      } else if (maybePromise.isPending()) {
                        maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                      }
                    }

                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                  }
                }
              }

              if (promise.isRejected()) {
                checkCancel(this);
                errorObj.e = reasonOrValue;
                return errorObj;
              } else {
                checkCancel(this);
                return reasonOrValue;
              }
            }

            Promise.prototype._passThrough = function (handler, type, success, fail) {
              if (typeof handler !== "function") return this.then();
              return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
            };

            Promise.prototype.lastly = Promise.prototype["finally"] = function (handler) {
              return this._passThrough(handler, 0, finallyHandler, finallyHandler);
            };

            Promise.prototype.tap = function (handler) {
              return this._passThrough(handler, 1, finallyHandler);
            };

            Promise.prototype.tapCatch = function (handlerOrPredicate) {
              var len = arguments.length;

              if (len === 1) {
                return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
              } else {
                var catchInstances = new Array(len - 1),
                    j = 0,
                    i;

                for (i = 0; i < len - 1; ++i) {
                  var item = arguments[i];

                  if (util.isObject(item)) {
                    catchInstances[j++] = item;
                  } else {
                    return Promise.reject(new TypeError("tapCatch statement predicate: " + "expecting an object but got " + util.classString(item)));
                  }
                }

                catchInstances.length = j;
                var handler = arguments[i];
                return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
              }
            };

            return PassThroughHandlerContext;
          };
        }, {
          "./catch_filter": 7,
          "./util": 36
        }],
        16: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
            var errors = _dereq_("./errors");

            var TypeError = errors.TypeError;

            var util = _dereq_("./util");

            var errorObj = util.errorObj;
            var tryCatch = util.tryCatch;
            var yieldHandlers = [];

            function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
              for (var i = 0; i < yieldHandlers.length; ++i) {
                traceParent._pushContext();

                var result = tryCatch(yieldHandlers[i])(value);

                traceParent._popContext();

                if (result === errorObj) {
                  traceParent._pushContext();

                  var ret = Promise.reject(errorObj.e);

                  traceParent._popContext();

                  return ret;
                }

                var maybePromise = tryConvertToPromise(result, traceParent);
                if (maybePromise instanceof Promise) return maybePromise;
              }

              return null;
            }

            function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
              if (debug.cancellation()) {
                var internal = new Promise(INTERNAL);

                var _finallyPromise = this._finallyPromise = new Promise(INTERNAL);

                this._promise = internal.lastly(function () {
                  return _finallyPromise;
                });

                internal._captureStackTrace();

                internal._setOnCancel(this);
              } else {
                var promise = this._promise = new Promise(INTERNAL);

                promise._captureStackTrace();
              }

              this._stack = stack;
              this._generatorFunction = generatorFunction;
              this._receiver = receiver;
              this._generator = undefined;
              this._yieldHandlers = typeof yieldHandler === "function" ? [yieldHandler].concat(yieldHandlers) : yieldHandlers;
              this._yieldedPromise = null;
              this._cancellationPhase = false;
            }

            util.inherits(PromiseSpawn, Proxyable);

            PromiseSpawn.prototype._isResolved = function () {
              return this._promise === null;
            };

            PromiseSpawn.prototype._cleanup = function () {
              this._promise = this._generator = null;

              if (debug.cancellation() && this._finallyPromise !== null) {
                this._finallyPromise._fulfill();

                this._finallyPromise = null;
              }
            };

            PromiseSpawn.prototype._promiseCancelled = function () {
              if (this._isResolved()) return;
              var implementsReturn = typeof this._generator["return"] !== "undefined";
              var result;

              if (!implementsReturn) {
                var reason = new Promise.CancellationError("generator .return() sentinel");
                Promise.coroutine.returnSentinel = reason;

                this._promise._attachExtraTrace(reason);

                this._promise._pushContext();

                result = tryCatch(this._generator["throw"]).call(this._generator, reason);

                this._promise._popContext();
              } else {
                this._promise._pushContext();

                result = tryCatch(this._generator["return"]).call(this._generator, undefined);

                this._promise._popContext();
              }

              this._cancellationPhase = true;
              this._yieldedPromise = null;

              this._continue(result);
            };

            PromiseSpawn.prototype._promiseFulfilled = function (value) {
              this._yieldedPromise = null;

              this._promise._pushContext();

              var result = tryCatch(this._generator.next).call(this._generator, value);

              this._promise._popContext();

              this._continue(result);
            };

            PromiseSpawn.prototype._promiseRejected = function (reason) {
              this._yieldedPromise = null;

              this._promise._attachExtraTrace(reason);

              this._promise._pushContext();

              var result = tryCatch(this._generator["throw"]).call(this._generator, reason);

              this._promise._popContext();

              this._continue(result);
            };

            PromiseSpawn.prototype._resultCancelled = function () {
              if (this._yieldedPromise instanceof Promise) {
                var promise = this._yieldedPromise;
                this._yieldedPromise = null;
                promise.cancel();
              }
            };

            PromiseSpawn.prototype.promise = function () {
              return this._promise;
            };

            PromiseSpawn.prototype._run = function () {
              this._generator = this._generatorFunction.call(this._receiver);
              this._receiver = this._generatorFunction = undefined;

              this._promiseFulfilled(undefined);
            };

            PromiseSpawn.prototype._continue = function (result) {
              var promise = this._promise;

              if (result === errorObj) {
                this._cleanup();

                if (this._cancellationPhase) {
                  return promise.cancel();
                } else {
                  return promise._rejectCallback(result.e, false);
                }
              }

              var value = result.value;

              if (result.done === true) {
                this._cleanup();

                if (this._cancellationPhase) {
                  return promise.cancel();
                } else {
                  return promise._resolveCallback(value);
                }
              } else {
                var maybePromise = tryConvertToPromise(value, this._promise);

                if (!(maybePromise instanceof Promise)) {
                  maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);

                  if (maybePromise === null) {
                    this._promiseRejected(new TypeError("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s", String(value)) + "From coroutine:\n" + this._stack.split("\n").slice(1, -7).join("\n")));

                    return;
                  }
                }

                maybePromise = maybePromise._target();
                var bitField = maybePromise._bitField;
                ;

                if ((bitField & 50397184) === 0) {
                  this._yieldedPromise = maybePromise;

                  maybePromise._proxy(this, null);
                } else if ((bitField & 33554432) !== 0) {
                  Promise._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                } else if ((bitField & 16777216) !== 0) {
                  Promise._async.invoke(this._promiseRejected, this, maybePromise._reason());
                } else {
                  this._promiseCancelled();
                }
              }
            };

            Promise.coroutine = function (generatorFunction, options) {
              if (typeof generatorFunction !== "function") {
                throw new TypeError("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              }

              var yieldHandler = Object(options).yieldHandler;
              var PromiseSpawn$ = PromiseSpawn;
              var stack = new Error().stack;
              return function () {
                var generator = generatorFunction.apply(this, arguments);
                var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                var ret = spawn.promise();
                spawn._generator = generator;

                spawn._promiseFulfilled(undefined);

                return ret;
              };
            };

            Promise.coroutine.addYieldHandler = function (fn) {
              if (typeof fn !== "function") {
                throw new TypeError("expecting a function but got " + util.classString(fn));
              }

              yieldHandlers.push(fn);
            };

            Promise.spawn = function (generatorFunction) {
              debug.deprecated("Promise.spawn()", "Promise.coroutine()");

              if (typeof generatorFunction !== "function") {
                return apiRejection("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");
              }

              var spawn = new PromiseSpawn(generatorFunction, this);
              var ret = spawn.promise();

              spawn._run(Promise.spawn);

              return ret;
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        17: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, tryConvertToPromise, INTERNAL, async) {
            var util = _dereq_("./util");

            var canEvaluate = util.canEvaluate;
            var tryCatch = util.tryCatch;
            var errorObj = util.errorObj;
            var reject;

            if (false) {
              if (canEvaluate) {
                var thenCallback = function thenCallback(i) {
                  return new Function("value", "holder", "                             \n\
            'use strict';                                                    \n\
            holder.pIndex = value;                                           \n\
            holder.checkFulfillment(this);                                   \n\
            ".replace(/Index/g, i));
                };

                var promiseSetter = function promiseSetter(i) {
                  return new Function("promise", "holder", "                           \n\
            'use strict';                                                    \n\
            holder.pIndex = promise;                                         \n\
            ".replace(/Index/g, i));
                };

                var generateHolderClass = function generateHolderClass(total) {
                  var props = new Array(total);

                  for (var i = 0; i < props.length; ++i) {
                    props[i] = "this.p" + (i + 1);
                  }

                  var assignment = props.join(" = ") + " = null;";
                  var cancellationCode = "var promise;\n" + props.map(function (prop) {
                    return "                                                         \n\
                promise = " + prop + ";                                      \n\
                if (promise instanceof Promise) {                            \n\
                    promise.cancel();                                        \n\
                }                                                            \n\
            ";
                  }).join("\n");
                  var passedArguments = props.join(", ");
                  var name = "Holder$" + total;
                  var code = "return function(tryCatch, errorObj, Promise, async) {    \n\
            'use strict';                                                    \n\
            function [TheName](fn) {                                         \n\
                [TheProperties]                                              \n\
                this.fn = fn;                                                \n\
                this.asyncNeeded = true;                                     \n\
                this.now = 0;                                                \n\
            }                                                                \n\
                                                                             \n\
            [TheName].prototype._callFunction = function(promise) {          \n\
                promise._pushContext();                                      \n\
                var ret = tryCatch(this.fn)([ThePassedArguments]);           \n\
                promise._popContext();                                       \n\
                if (ret === errorObj) {                                      \n\
                    promise._rejectCallback(ret.e, false);                   \n\
                } else {                                                     \n\
                    promise._resolveCallback(ret);                           \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype.checkFulfillment = function(promise) {       \n\
                var now = ++this.now;                                        \n\
                if (now === [TheTotal]) {                                    \n\
                    if (this.asyncNeeded) {                                  \n\
                        async.invoke(this._callFunction, this, promise);     \n\
                    } else {                                                 \n\
                        this._callFunction(promise);                         \n\
                    }                                                        \n\
                                                                             \n\
                }                                                            \n\
            };                                                               \n\
                                                                             \n\
            [TheName].prototype._resultCancelled = function() {              \n\
                [CancellationCode]                                           \n\
            };                                                               \n\
                                                                             \n\
            return [TheName];                                                \n\
        }(tryCatch, errorObj, Promise, async);                               \n\
        ";
                  code = code.replace(/\[TheName\]/g, name).replace(/\[TheTotal\]/g, total).replace(/\[ThePassedArguments\]/g, passedArguments).replace(/\[TheProperties\]/g, assignment).replace(/\[CancellationCode\]/g, cancellationCode);
                  return new Function("tryCatch", "errorObj", "Promise", "async", code)(tryCatch, errorObj, Promise, async);
                };

                var holderClasses = [];
                var thenCallbacks = [];
                var promiseSetters = [];

                for (var i = 0; i < 8; ++i) {
                  holderClasses.push(generateHolderClass(i + 1));
                  thenCallbacks.push(thenCallback(i + 1));
                  promiseSetters.push(promiseSetter(i + 1));
                }

                reject = function reject(reason) {
                  this._reject(reason);
                };
              }
            }

            Promise.join = function () {
              var last = arguments.length - 1;
              var fn;

              if (last > 0 && typeof arguments[last] === "function") {
                fn = arguments[last];

                if (false) {
                  if (last <= 8 && canEvaluate) {
                    var ret = new Promise(INTERNAL);

                    ret._captureStackTrace();

                    var HolderClass = holderClasses[last - 1];
                    var holder = new HolderClass(fn);
                    var callbacks = thenCallbacks;

                    for (var i = 0; i < last; ++i) {
                      var maybePromise = tryConvertToPromise(arguments[i], ret);

                      if (maybePromise instanceof Promise) {
                        maybePromise = maybePromise._target();
                        var bitField = maybePromise._bitField;
                        ;

                        if ((bitField & 50397184) === 0) {
                          maybePromise._then(callbacks[i], reject, undefined, ret, holder);

                          promiseSetters[i](maybePromise, holder);
                          holder.asyncNeeded = false;
                        } else if ((bitField & 33554432) !== 0) {
                          callbacks[i].call(ret, maybePromise._value(), holder);
                        } else if ((bitField & 16777216) !== 0) {
                          ret._reject(maybePromise._reason());
                        } else {
                          ret._cancel();
                        }
                      } else {
                        callbacks[i].call(ret, maybePromise, holder);
                      }
                    }

                    if (!ret._isFateSealed()) {
                      if (holder.asyncNeeded) {
                        var context = Promise._getContext();

                        holder.fn = util.contextBind(context, holder.fn);
                      }

                      ret._setAsyncGuaranteed();

                      ret._setOnCancel(holder);
                    }

                    return ret;
                  }
                }
              }

              var args = [].slice.call(arguments);
              ;
              if (fn) args.pop();
              var ret = new PromiseArray(args).promise();
              return fn !== undefined ? ret.spread(fn) : ret;
            };
          };
        }, {
          "./util": 36
        }],
        18: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
            var util = _dereq_("./util");

            var tryCatch = util.tryCatch;
            var errorObj = util.errorObj;
            var async = Promise._async;

            function MappingPromiseArray(promises, fn, limit, _filter) {
              this.constructor$(promises);

              this._promise._captureStackTrace();

              var context = Promise._getContext();

              this._callback = util.contextBind(context, fn);
              this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
              this._limit = limit;
              this._inFlight = 0;
              this._queue = [];
              async.invoke(this._asyncInit, this, undefined);

              if (util.isArray(promises)) {
                for (var i = 0; i < promises.length; ++i) {
                  var maybePromise = promises[i];

                  if (maybePromise instanceof Promise) {
                    maybePromise.suppressUnhandledRejections();
                  }
                }
              }
            }

            util.inherits(MappingPromiseArray, PromiseArray);

            MappingPromiseArray.prototype._asyncInit = function () {
              this._init$(undefined, -2);
            };

            MappingPromiseArray.prototype._init = function () {};

            MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
              var values = this._values;
              var length = this.length();
              var preservedValues = this._preservedValues;
              var limit = this._limit;

              if (index < 0) {
                index = index * -1 - 1;
                values[index] = value;

                if (limit >= 1) {
                  this._inFlight--;

                  this._drainQueue();

                  if (this._isResolved()) return true;
                }
              } else {
                if (limit >= 1 && this._inFlight >= limit) {
                  values[index] = value;

                  this._queue.push(index);

                  return false;
                }

                if (preservedValues !== null) preservedValues[index] = value;
                var promise = this._promise;
                var callback = this._callback;

                var receiver = promise._boundValue();

                promise._pushContext();

                var ret = tryCatch(callback).call(receiver, value, index, length);

                var promiseCreated = promise._popContext();

                debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);

                if (ret === errorObj) {
                  this._reject(ret.e);

                  return true;
                }

                var maybePromise = tryConvertToPromise(ret, this._promise);

                if (maybePromise instanceof Promise) {
                  maybePromise = maybePromise._target();
                  var bitField = maybePromise._bitField;
                  ;

                  if ((bitField & 50397184) === 0) {
                    if (limit >= 1) this._inFlight++;
                    values[index] = maybePromise;

                    maybePromise._proxy(this, (index + 1) * -1);

                    return false;
                  } else if ((bitField & 33554432) !== 0) {
                    ret = maybePromise._value();
                  } else if ((bitField & 16777216) !== 0) {
                    this._reject(maybePromise._reason());

                    return true;
                  } else {
                    this._cancel();

                    return true;
                  }
                }

                values[index] = ret;
              }

              var totalResolved = ++this._totalResolved;

              if (totalResolved >= length) {
                if (preservedValues !== null) {
                  this._filter(values, preservedValues);
                } else {
                  this._resolve(values);
                }

                return true;
              }

              return false;
            };

            MappingPromiseArray.prototype._drainQueue = function () {
              var queue = this._queue;
              var limit = this._limit;
              var values = this._values;

              while (queue.length > 0 && this._inFlight < limit) {
                if (this._isResolved()) return;
                var index = queue.pop();

                this._promiseFulfilled(values[index], index);
              }
            };

            MappingPromiseArray.prototype._filter = function (booleans, values) {
              var len = values.length;
              var ret = new Array(len);
              var j = 0;

              for (var i = 0; i < len; ++i) {
                if (booleans[i]) ret[j++] = values[i];
              }

              ret.length = j;

              this._resolve(ret);
            };

            MappingPromiseArray.prototype.preservedValues = function () {
              return this._preservedValues;
            };

            function map(promises, fn, options, _filter) {
              if (typeof fn !== "function") {
                return apiRejection("expecting a function but got " + util.classString(fn));
              }

              var limit = 0;

              if (options !== undefined) {
                if (typeof options === "object" && options !== null) {
                  if (typeof options.concurrency !== "number") {
                    return Promise.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                  }

                  limit = options.concurrency;
                } else {
                  return Promise.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                }
              }

              limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
              return new MappingPromiseArray(promises, fn, limit, _filter).promise();
            }

            Promise.prototype.map = function (fn, options) {
              return map(this, fn, options, null);
            };

            Promise.map = function (promises, fn, options, _filter) {
              return map(promises, fn, options, _filter);
            };
          };
        }, {
          "./util": 36
        }],
        19: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, debug) {
            var util = _dereq_("./util");

            var tryCatch = util.tryCatch;

            Promise.method = function (fn) {
              if (typeof fn !== "function") {
                throw new Promise.TypeError("expecting a function but got " + util.classString(fn));
              }

              return function () {
                var ret = new Promise(INTERNAL);

                ret._captureStackTrace();

                ret._pushContext();

                var value = tryCatch(fn).apply(this, arguments);

                var promiseCreated = ret._popContext();

                debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);

                ret._resolveFromSyncValue(value);

                return ret;
              };
            };

            Promise.attempt = Promise["try"] = function (fn) {
              if (typeof fn !== "function") {
                return apiRejection("expecting a function but got " + util.classString(fn));
              }

              var ret = new Promise(INTERNAL);

              ret._captureStackTrace();

              ret._pushContext();

              var value;

              if (arguments.length > 1) {
                debug.deprecated("calling Promise.try with more than 1 argument");
                var arg = arguments[1];
                var ctx = arguments[2];
                value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
              } else {
                value = tryCatch(fn)();
              }

              var promiseCreated = ret._popContext();

              debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);

              ret._resolveFromSyncValue(value);

              return ret;
            };

            Promise.prototype._resolveFromSyncValue = function (value) {
              if (value === util.errorObj) {
                this._rejectCallback(value.e, false);
              } else {
                this._resolveCallback(value, true);
              }
            };
          };
        }, {
          "./util": 36
        }],
        20: [function (_dereq_, module, exports) {
          "use strict";

          var util = _dereq_("./util");

          var maybeWrapAsError = util.maybeWrapAsError;

          var errors = _dereq_("./errors");

          var OperationalError = errors.OperationalError;

          var es5 = _dereq_("./es5");

          function isUntypedError(obj) {
            return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
          }

          var rErrorKey = /^(?:name|message|stack|cause)$/;

          function wrapAsOperationalError(obj) {
            var ret;

            if (isUntypedError(obj)) {
              ret = new OperationalError(obj);
              ret.name = obj.name;
              ret.message = obj.message;
              ret.stack = obj.stack;
              var keys = es5.keys(obj);

              for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];

                if (!rErrorKey.test(key)) {
                  ret[key] = obj[key];
                }
              }

              return ret;
            }

            util.markAsOriginatingFromRejection(obj);
            return obj;
          }

          function nodebackForPromise(promise, multiArgs) {
            return function (err, value) {
              if (promise === null) return;

              if (err) {
                var wrapped = wrapAsOperationalError(maybeWrapAsError(err));

                promise._attachExtraTrace(wrapped);

                promise._reject(wrapped);
              } else if (!multiArgs) {
                promise._fulfill(value);
              } else {
                var args = [].slice.call(arguments, 1);
                ;

                promise._fulfill(args);
              }

              promise = null;
            };
          }

          module.exports = nodebackForPromise;
        }, {
          "./errors": 12,
          "./es5": 13,
          "./util": 36
        }],
        21: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise) {
            var util = _dereq_("./util");

            var async = Promise._async;
            var tryCatch = util.tryCatch;
            var errorObj = util.errorObj;

            function spreadAdapter(val, nodeback) {
              var promise = this;
              if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
              var ret = tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));

              if (ret === errorObj) {
                async.throwLater(ret.e);
              }
            }

            function successAdapter(val, nodeback) {
              var promise = this;

              var receiver = promise._boundValue();

              var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);

              if (ret === errorObj) {
                async.throwLater(ret.e);
              }
            }

            function errorAdapter(reason, nodeback) {
              var promise = this;

              if (!reason) {
                var newReason = new Error(reason + "");
                newReason.cause = reason;
                reason = newReason;
              }

              var ret = tryCatch(nodeback).call(promise._boundValue(), reason);

              if (ret === errorObj) {
                async.throwLater(ret.e);
              }
            }

            Promise.prototype.asCallback = Promise.prototype.nodeify = function (nodeback, options) {
              if (typeof nodeback == "function") {
                var adapter = successAdapter;

                if (options !== undefined && Object(options).spread) {
                  adapter = spreadAdapter;
                }

                this._then(adapter, errorAdapter, undefined, this, nodeback);
              }

              return this;
            };
          };
        }, {
          "./util": 36
        }],
        22: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function () {
            var makeSelfResolutionError = function makeSelfResolutionError() {
              return new TypeError("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n");
            };

            var reflectHandler = function reflectHandler() {
              return new Promise.PromiseInspection(this._target());
            };

            var apiRejection = function apiRejection(msg) {
              return Promise.reject(new TypeError(msg));
            };

            function Proxyable() {}

            var UNDEFINED_BINDING = {};

            var util = _dereq_("./util");

            util.setReflectHandler(reflectHandler);

            var getDomain = function getDomain() {
              var domain = process.domain;

              if (domain === undefined) {
                return null;
              }

              return domain;
            };

            var getContextDefault = function getContextDefault() {
              return null;
            };

            var getContextDomain = function getContextDomain() {
              return {
                domain: getDomain(),
                async: null
              };
            };

            var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_("async_hooks").AsyncResource : null;

            var getContextAsyncHooks = function getContextAsyncHooks() {
              return {
                domain: getDomain(),
                async: new AsyncResource("Bluebird::Promise")
              };
            };

            var getContext = util.isNode ? getContextDomain : getContextDefault;
            util.notEnumerableProp(Promise, "_getContext", getContext);

            var enableAsyncHooks = function enableAsyncHooks() {
              getContext = getContextAsyncHooks;
              util.notEnumerableProp(Promise, "_getContext", getContextAsyncHooks);
            };

            var disableAsyncHooks = function disableAsyncHooks() {
              getContext = getContextDomain;
              util.notEnumerableProp(Promise, "_getContext", getContextDomain);
            };

            var es5 = _dereq_("./es5");

            var Async = _dereq_("./async");

            var async = new Async();
            es5.defineProperty(Promise, "_async", {
              value: async
            });

            var errors = _dereq_("./errors");

            var TypeError = Promise.TypeError = errors.TypeError;
            Promise.RangeError = errors.RangeError;
            var CancellationError = Promise.CancellationError = errors.CancellationError;
            Promise.TimeoutError = errors.TimeoutError;
            Promise.OperationalError = errors.OperationalError;
            Promise.RejectionError = errors.OperationalError;
            Promise.AggregateError = errors.AggregateError;

            var INTERNAL = function INTERNAL() {};

            var APPLY = {};
            var NEXT_FILTER = {};

            var tryConvertToPromise = _dereq_("./thenables")(Promise, INTERNAL);

            var PromiseArray = _dereq_("./promise_array")(Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);

            var Context = _dereq_("./context")(Promise);
            /*jshint unused:false*/


            var createContext = Context.create;

            var debug = _dereq_("./debuggability")(Promise, Context, enableAsyncHooks, disableAsyncHooks);

            var CapturedTrace = debug.CapturedTrace;

            var PassThroughHandlerContext = _dereq_("./finally")(Promise, tryConvertToPromise, NEXT_FILTER);

            var catchFilter = _dereq_("./catch_filter")(NEXT_FILTER);

            var nodebackForPromise = _dereq_("./nodeback");

            var errorObj = util.errorObj;
            var tryCatch = util.tryCatch;

            function check(self, executor) {
              if (self == null || self.constructor !== Promise) {
                throw new TypeError("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");
              }

              if (typeof executor !== "function") {
                throw new TypeError("expecting a function but got " + util.classString(executor));
              }
            }

            function Promise(executor) {
              if (executor !== INTERNAL) {
                check(this, executor);
              }

              this._bitField = 0;
              this._fulfillmentHandler0 = undefined;
              this._rejectionHandler0 = undefined;
              this._promise0 = undefined;
              this._receiver0 = undefined;

              this._resolveFromExecutor(executor);

              this._promiseCreated();

              this._fireEvent("promiseCreated", this);
            }

            Promise.prototype.toString = function () {
              return "[object Promise]";
            };

            Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
              var len = arguments.length;

              if (len > 1) {
                var catchInstances = new Array(len - 1),
                    j = 0,
                    i;

                for (i = 0; i < len - 1; ++i) {
                  var item = arguments[i];

                  if (util.isObject(item)) {
                    catchInstances[j++] = item;
                  } else {
                    return apiRejection("Catch statement predicate: " + "expecting an object but got " + util.classString(item));
                  }
                }

                catchInstances.length = j;
                fn = arguments[i];

                if (typeof fn !== "function") {
                  throw new TypeError("The last argument to .catch() " + "must be a function, got " + util.toString(fn));
                }

                return this.then(undefined, catchFilter(catchInstances, fn, this));
              }

              return this.then(undefined, fn);
            };

            Promise.prototype.reflect = function () {
              return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
            };

            Promise.prototype.then = function (didFulfill, didReject) {
              if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);

                if (arguments.length > 1) {
                  msg += ", " + util.classString(didReject);
                }

                this._warn(msg);
              }

              return this._then(didFulfill, didReject, undefined, undefined, undefined);
            };

            Promise.prototype.done = function (didFulfill, didReject) {
              var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);

              promise._setIsFinal();
            };

            Promise.prototype.spread = function (fn) {
              if (typeof fn !== "function") {
                return apiRejection("expecting a function but got " + util.classString(fn));
              }

              return this.all()._then(fn, undefined, undefined, APPLY, undefined);
            };

            Promise.prototype.toJSON = function () {
              var ret = {
                isFulfilled: false,
                isRejected: false,
                fulfillmentValue: undefined,
                rejectionReason: undefined
              };

              if (this.isFulfilled()) {
                ret.fulfillmentValue = this.value();
                ret.isFulfilled = true;
              } else if (this.isRejected()) {
                ret.rejectionReason = this.reason();
                ret.isRejected = true;
              }

              return ret;
            };

            Promise.prototype.all = function () {
              if (arguments.length > 0) {
                this._warn(".all() was passed arguments but it does not take any");
              }

              return new PromiseArray(this).promise();
            };

            Promise.prototype.error = function (fn) {
              return this.caught(util.originatesFromRejection, fn);
            };

            Promise.getNewLibraryCopy = module.exports;

            Promise.is = function (val) {
              return val instanceof Promise;
            };

            Promise.fromNode = Promise.fromCallback = function (fn) {
              var ret = new Promise(INTERNAL);

              ret._captureStackTrace();

              var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
              var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));

              if (result === errorObj) {
                ret._rejectCallback(result.e, true);
              }

              if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
              return ret;
            };

            Promise.all = function (promises) {
              return new PromiseArray(promises).promise();
            };

            Promise.cast = function (obj) {
              var ret = tryConvertToPromise(obj);

              if (!(ret instanceof Promise)) {
                ret = new Promise(INTERNAL);

                ret._captureStackTrace();

                ret._setFulfilled();

                ret._rejectionHandler0 = obj;
              }

              return ret;
            };

            Promise.resolve = Promise.fulfilled = Promise.cast;

            Promise.reject = Promise.rejected = function (reason) {
              var ret = new Promise(INTERNAL);

              ret._captureStackTrace();

              ret._rejectCallback(reason, true);

              return ret;
            };

            Promise.setScheduler = function (fn) {
              if (typeof fn !== "function") {
                throw new TypeError("expecting a function but got " + util.classString(fn));
              }

              return async.setScheduler(fn);
            };

            Promise.prototype._then = function (didFulfill, didReject, _, receiver, internalData) {
              var haveInternalData = internalData !== undefined;
              var promise = haveInternalData ? internalData : new Promise(INTERNAL);

              var target = this._target();

              var bitField = target._bitField;

              if (!haveInternalData) {
                promise._propagateFrom(this, 3);

                promise._captureStackTrace();

                if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                  if (!((bitField & 50397184) === 0)) {
                    receiver = this._boundValue();
                  } else {
                    receiver = target === this ? undefined : this._boundTo;
                  }
                }

                this._fireEvent("promiseChained", this, promise);
              }

              var context = getContext();

              if (!((bitField & 50397184) === 0)) {
                var handler,
                    value,
                    settler = target._settlePromiseCtx;

                if ((bitField & 33554432) !== 0) {
                  value = target._rejectionHandler0;
                  handler = didFulfill;
                } else if ((bitField & 16777216) !== 0) {
                  value = target._fulfillmentHandler0;
                  handler = didReject;

                  target._unsetRejectionIsUnhandled();
                } else {
                  settler = target._settlePromiseLateCancellationObserver;
                  value = new CancellationError("late cancellation observer");

                  target._attachExtraTrace(value);

                  handler = didReject;
                }

                async.invoke(settler, target, {
                  handler: util.contextBind(context, handler),
                  promise: promise,
                  receiver: receiver,
                  value: value
                });
              } else {
                target._addCallbacks(didFulfill, didReject, promise, receiver, context);
              }

              return promise;
            };

            Promise.prototype._length = function () {
              return this._bitField & 65535;
            };

            Promise.prototype._isFateSealed = function () {
              return (this._bitField & 117506048) !== 0;
            };

            Promise.prototype._isFollowing = function () {
              return (this._bitField & 67108864) === 67108864;
            };

            Promise.prototype._setLength = function (len) {
              this._bitField = this._bitField & -65536 | len & 65535;
            };

            Promise.prototype._setFulfilled = function () {
              this._bitField = this._bitField | 33554432;

              this._fireEvent("promiseFulfilled", this);
            };

            Promise.prototype._setRejected = function () {
              this._bitField = this._bitField | 16777216;

              this._fireEvent("promiseRejected", this);
            };

            Promise.prototype._setFollowing = function () {
              this._bitField = this._bitField | 67108864;

              this._fireEvent("promiseResolved", this);
            };

            Promise.prototype._setIsFinal = function () {
              this._bitField = this._bitField | 4194304;
            };

            Promise.prototype._isFinal = function () {
              return (this._bitField & 4194304) > 0;
            };

            Promise.prototype._unsetCancelled = function () {
              this._bitField = this._bitField & ~65536;
            };

            Promise.prototype._setCancelled = function () {
              this._bitField = this._bitField | 65536;

              this._fireEvent("promiseCancelled", this);
            };

            Promise.prototype._setWillBeCancelled = function () {
              this._bitField = this._bitField | 8388608;
            };

            Promise.prototype._setAsyncGuaranteed = function () {
              if (async.hasCustomScheduler()) return;
              var bitField = this._bitField;
              this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
            };

            Promise.prototype._setNoAsyncGuarantee = function () {
              this._bitField = (this._bitField | 536870912) & ~134217728;
            };

            Promise.prototype._receiverAt = function (index) {
              var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];

              if (ret === UNDEFINED_BINDING) {
                return undefined;
              } else if (ret === undefined && this._isBound()) {
                return this._boundValue();
              }

              return ret;
            };

            Promise.prototype._promiseAt = function (index) {
              return this[index * 4 - 4 + 2];
            };

            Promise.prototype._fulfillmentHandlerAt = function (index) {
              return this[index * 4 - 4 + 0];
            };

            Promise.prototype._rejectionHandlerAt = function (index) {
              return this[index * 4 - 4 + 1];
            };

            Promise.prototype._boundValue = function () {};

            Promise.prototype._migrateCallback0 = function (follower) {
              var bitField = follower._bitField;
              var fulfill = follower._fulfillmentHandler0;
              var reject = follower._rejectionHandler0;
              var promise = follower._promise0;

              var receiver = follower._receiverAt(0);

              if (receiver === undefined) receiver = UNDEFINED_BINDING;

              this._addCallbacks(fulfill, reject, promise, receiver, null);
            };

            Promise.prototype._migrateCallbackAt = function (follower, index) {
              var fulfill = follower._fulfillmentHandlerAt(index);

              var reject = follower._rejectionHandlerAt(index);

              var promise = follower._promiseAt(index);

              var receiver = follower._receiverAt(index);

              if (receiver === undefined) receiver = UNDEFINED_BINDING;

              this._addCallbacks(fulfill, reject, promise, receiver, null);
            };

            Promise.prototype._addCallbacks = function (fulfill, reject, promise, receiver, context) {
              var index = this._length();

              if (index >= 65535 - 4) {
                index = 0;

                this._setLength(0);
              }

              if (index === 0) {
                this._promise0 = promise;
                this._receiver0 = receiver;

                if (typeof fulfill === "function") {
                  this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                }

                if (typeof reject === "function") {
                  this._rejectionHandler0 = util.contextBind(context, reject);
                }
              } else {
                var base = index * 4 - 4;
                this[base + 2] = promise;
                this[base + 3] = receiver;

                if (typeof fulfill === "function") {
                  this[base + 0] = util.contextBind(context, fulfill);
                }

                if (typeof reject === "function") {
                  this[base + 1] = util.contextBind(context, reject);
                }
              }

              this._setLength(index + 1);

              return index;
            };

            Promise.prototype._proxy = function (proxyable, arg) {
              this._addCallbacks(undefined, undefined, arg, proxyable, null);
            };

            Promise.prototype._resolveCallback = function (value, shouldBind) {
              if ((this._bitField & 117506048) !== 0) return;
              if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
              var maybePromise = tryConvertToPromise(value, this);
              if (!(maybePromise instanceof Promise)) return this._fulfill(value);
              if (shouldBind) this._propagateFrom(maybePromise, 2);

              var promise = maybePromise._target();

              if (promise === this) {
                this._reject(makeSelfResolutionError());

                return;
              }

              var bitField = promise._bitField;

              if ((bitField & 50397184) === 0) {
                var len = this._length();

                if (len > 0) promise._migrateCallback0(this);

                for (var i = 1; i < len; ++i) {
                  promise._migrateCallbackAt(this, i);
                }

                this._setFollowing();

                this._setLength(0);

                this._setFollowee(maybePromise);
              } else if ((bitField & 33554432) !== 0) {
                this._fulfill(promise._value());
              } else if ((bitField & 16777216) !== 0) {
                this._reject(promise._reason());
              } else {
                var reason = new CancellationError("late cancellation observer");

                promise._attachExtraTrace(reason);

                this._reject(reason);
              }
            };

            Promise.prototype._rejectCallback = function (reason, synchronous, ignoreNonErrorWarnings) {
              var trace = util.ensureErrorObject(reason);
              var hasStack = trace === reason;

              if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                var message = "a promise was rejected with a non-error: " + util.classString(reason);

                this._warn(message, true);
              }

              this._attachExtraTrace(trace, synchronous ? hasStack : false);

              this._reject(reason);
            };

            Promise.prototype._resolveFromExecutor = function (executor) {
              if (executor === INTERNAL) return;
              var promise = this;

              this._captureStackTrace();

              this._pushContext();

              var synchronous = true;

              var r = this._execute(executor, function (value) {
                promise._resolveCallback(value);
              }, function (reason) {
                promise._rejectCallback(reason, synchronous);
              });

              synchronous = false;

              this._popContext();

              if (r !== undefined) {
                promise._rejectCallback(r, true);
              }
            };

            Promise.prototype._settlePromiseFromHandler = function (handler, receiver, value, promise) {
              var bitField = promise._bitField;
              if ((bitField & 65536) !== 0) return;

              promise._pushContext();

              var x;

              if (receiver === APPLY) {
                if (!value || typeof value.length !== "number") {
                  x = errorObj;
                  x.e = new TypeError("cannot .spread() a non-array: " + util.classString(value));
                } else {
                  x = tryCatch(handler).apply(this._boundValue(), value);
                }
              } else {
                x = tryCatch(handler).call(receiver, value);
              }

              var promiseCreated = promise._popContext();

              bitField = promise._bitField;
              if ((bitField & 65536) !== 0) return;

              if (x === NEXT_FILTER) {
                promise._reject(value);
              } else if (x === errorObj) {
                promise._rejectCallback(x.e, false);
              } else {
                debug.checkForgottenReturns(x, promiseCreated, "", promise, this);

                promise._resolveCallback(x);
              }
            };

            Promise.prototype._target = function () {
              var ret = this;

              while (ret._isFollowing()) {
                ret = ret._followee();
              }

              return ret;
            };

            Promise.prototype._followee = function () {
              return this._rejectionHandler0;
            };

            Promise.prototype._setFollowee = function (promise) {
              this._rejectionHandler0 = promise;
            };

            Promise.prototype._settlePromise = function (promise, handler, receiver, value) {
              var isPromise = promise instanceof Promise;
              var bitField = this._bitField;
              var asyncGuaranteed = (bitField & 134217728) !== 0;

              if ((bitField & 65536) !== 0) {
                if (isPromise) promise._invokeInternalOnCancel();

                if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                  receiver.cancelPromise = promise;

                  if (tryCatch(handler).call(receiver, value) === errorObj) {
                    promise._reject(errorObj.e);
                  }
                } else if (handler === reflectHandler) {
                  promise._fulfill(reflectHandler.call(receiver));
                } else if (receiver instanceof Proxyable) {
                  receiver._promiseCancelled(promise);
                } else if (isPromise || promise instanceof PromiseArray) {
                  promise._cancel();
                } else {
                  receiver.cancel();
                }
              } else if (typeof handler === "function") {
                if (!isPromise) {
                  handler.call(receiver, value, promise);
                } else {
                  if (asyncGuaranteed) promise._setAsyncGuaranteed();

                  this._settlePromiseFromHandler(handler, receiver, value, promise);
                }
              } else if (receiver instanceof Proxyable) {
                if (!receiver._isResolved()) {
                  if ((bitField & 33554432) !== 0) {
                    receiver._promiseFulfilled(value, promise);
                  } else {
                    receiver._promiseRejected(value, promise);
                  }
                }
              } else if (isPromise) {
                if (asyncGuaranteed) promise._setAsyncGuaranteed();

                if ((bitField & 33554432) !== 0) {
                  promise._fulfill(value);
                } else {
                  promise._reject(value);
                }
              }
            };

            Promise.prototype._settlePromiseLateCancellationObserver = function (ctx) {
              var handler = ctx.handler;
              var promise = ctx.promise;
              var receiver = ctx.receiver;
              var value = ctx.value;

              if (typeof handler === "function") {
                if (!(promise instanceof Promise)) {
                  handler.call(receiver, value, promise);
                } else {
                  this._settlePromiseFromHandler(handler, receiver, value, promise);
                }
              } else if (promise instanceof Promise) {
                promise._reject(value);
              }
            };

            Promise.prototype._settlePromiseCtx = function (ctx) {
              this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
            };

            Promise.prototype._settlePromise0 = function (handler, value, bitField) {
              var promise = this._promise0;

              var receiver = this._receiverAt(0);

              this._promise0 = undefined;
              this._receiver0 = undefined;

              this._settlePromise(promise, handler, receiver, value);
            };

            Promise.prototype._clearCallbackDataAtIndex = function (index) {
              var base = index * 4 - 4;
              this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
            };

            Promise.prototype._fulfill = function (value) {
              var bitField = this._bitField;
              if ((bitField & 117506048) >>> 16) return;

              if (value === this) {
                var err = makeSelfResolutionError();

                this._attachExtraTrace(err);

                return this._reject(err);
              }

              this._setFulfilled();

              this._rejectionHandler0 = value;

              if ((bitField & 65535) > 0) {
                if ((bitField & 134217728) !== 0) {
                  this._settlePromises();
                } else {
                  async.settlePromises(this);
                }

                this._dereferenceTrace();
              }
            };

            Promise.prototype._reject = function (reason) {
              var bitField = this._bitField;
              if ((bitField & 117506048) >>> 16) return;

              this._setRejected();

              this._fulfillmentHandler0 = reason;

              if (this._isFinal()) {
                return async.fatalError(reason, util.isNode);
              }

              if ((bitField & 65535) > 0) {
                async.settlePromises(this);
              } else {
                this._ensurePossibleRejectionHandled();
              }
            };

            Promise.prototype._fulfillPromises = function (len, value) {
              for (var i = 1; i < len; i++) {
                var handler = this._fulfillmentHandlerAt(i);

                var promise = this._promiseAt(i);

                var receiver = this._receiverAt(i);

                this._clearCallbackDataAtIndex(i);

                this._settlePromise(promise, handler, receiver, value);
              }
            };

            Promise.prototype._rejectPromises = function (len, reason) {
              for (var i = 1; i < len; i++) {
                var handler = this._rejectionHandlerAt(i);

                var promise = this._promiseAt(i);

                var receiver = this._receiverAt(i);

                this._clearCallbackDataAtIndex(i);

                this._settlePromise(promise, handler, receiver, reason);
              }
            };

            Promise.prototype._settlePromises = function () {
              var bitField = this._bitField;
              var len = bitField & 65535;

              if (len > 0) {
                if ((bitField & 16842752) !== 0) {
                  var reason = this._fulfillmentHandler0;

                  this._settlePromise0(this._rejectionHandler0, reason, bitField);

                  this._rejectPromises(len, reason);
                } else {
                  var value = this._rejectionHandler0;

                  this._settlePromise0(this._fulfillmentHandler0, value, bitField);

                  this._fulfillPromises(len, value);
                }

                this._setLength(0);
              }

              this._clearCancellationData();
            };

            Promise.prototype._settledValue = function () {
              var bitField = this._bitField;

              if ((bitField & 33554432) !== 0) {
                return this._rejectionHandler0;
              } else if ((bitField & 16777216) !== 0) {
                return this._fulfillmentHandler0;
              }
            };

            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
              es5.defineProperty(Promise.prototype, Symbol.toStringTag, {
                get: function get() {
                  return "Object";
                }
              });
            }

            function deferResolve(v) {
              this.promise._resolveCallback(v);
            }

            function deferReject(v) {
              this.promise._rejectCallback(v, false);
            }

            Promise.defer = Promise.pending = function () {
              debug.deprecated("Promise.defer", "new Promise");
              var promise = new Promise(INTERNAL);
              return {
                promise: promise,
                resolve: deferResolve,
                reject: deferReject
              };
            };

            util.notEnumerableProp(Promise, "_makeSelfResolutionError", makeSelfResolutionError);

            _dereq_("./method")(Promise, INTERNAL, tryConvertToPromise, apiRejection, debug);

            _dereq_("./bind")(Promise, INTERNAL, tryConvertToPromise, debug);

            _dereq_("./cancel")(Promise, PromiseArray, apiRejection, debug);

            _dereq_("./direct_resolve")(Promise);

            _dereq_("./synchronous_inspection")(Promise);

            _dereq_("./join")(Promise, PromiseArray, tryConvertToPromise, INTERNAL, async);

            Promise.Promise = Promise;
            Promise.version = "3.7.2";

            _dereq_('./call_get.js')(Promise);

            _dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);

            _dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);

            _dereq_('./nodeify.js')(Promise);

            _dereq_('./promisify.js')(Promise, INTERNAL);

            _dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);

            _dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);

            _dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);

            _dereq_('./settle.js')(Promise, PromiseArray, debug);

            _dereq_('./some.js')(Promise, PromiseArray, apiRejection);

            _dereq_('./timers.js')(Promise, INTERNAL, debug);

            _dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);

            _dereq_('./any.js')(Promise);

            _dereq_('./each.js')(Promise, INTERNAL);

            _dereq_('./filter.js')(Promise, INTERNAL);

            util.toFastProperties(Promise);
            util.toFastProperties(Promise.prototype);

            function fillTypes(value) {
              var p = new Promise(INTERNAL);
              p._fulfillmentHandler0 = value;
              p._rejectionHandler0 = value;
              p._promise0 = value;
              p._receiver0 = value;
            } // Complete slack tracking, opt out of field-type tracking and           
            // stabilize map                                                         


            fillTypes({
              a: 1
            });
            fillTypes({
              b: 2
            });
            fillTypes({
              c: 3
            });
            fillTypes(1);
            fillTypes(function () {});
            fillTypes(undefined);
            fillTypes(false);
            fillTypes(new Promise(INTERNAL));
            debug.setBounds(Async.firstLineError, util.lastLineError);
            return Promise;
          };
        }, {
          "./any.js": 1,
          "./async": 2,
          "./bind": 3,
          "./call_get.js": 5,
          "./cancel": 6,
          "./catch_filter": 7,
          "./context": 8,
          "./debuggability": 9,
          "./direct_resolve": 10,
          "./each.js": 11,
          "./errors": 12,
          "./es5": 13,
          "./filter.js": 14,
          "./finally": 15,
          "./generators.js": 16,
          "./join": 17,
          "./map.js": 18,
          "./method": 19,
          "./nodeback": 20,
          "./nodeify.js": 21,
          "./promise_array": 23,
          "./promisify.js": 24,
          "./props.js": 25,
          "./race.js": 27,
          "./reduce.js": 28,
          "./settle.js": 30,
          "./some.js": 31,
          "./synchronous_inspection": 32,
          "./thenables": 33,
          "./timers.js": 34,
          "./using.js": 35,
          "./util": 36,
          "async_hooks": undefined
        }],
        23: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
            var util = _dereq_("./util");

            var isArray = util.isArray;

            function toResolutionValue(val) {
              switch (val) {
                case -2:
                  return [];

                case -3:
                  return {};

                case -6:
                  return new Map();
              }
            }

            function PromiseArray(values) {
              var promise = this._promise = new Promise(INTERNAL);

              if (values instanceof Promise) {
                promise._propagateFrom(values, 3);

                values.suppressUnhandledRejections();
              }

              promise._setOnCancel(this);

              this._values = values;
              this._length = 0;
              this._totalResolved = 0;

              this._init(undefined, -2);
            }

            util.inherits(PromiseArray, Proxyable);

            PromiseArray.prototype.length = function () {
              return this._length;
            };

            PromiseArray.prototype.promise = function () {
              return this._promise;
            };

            PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
              var values = tryConvertToPromise(this._values, this._promise);

              if (values instanceof Promise) {
                values = values._target();
                var bitField = values._bitField;
                ;
                this._values = values;

                if ((bitField & 50397184) === 0) {
                  this._promise._setAsyncGuaranteed();

                  return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                } else if ((bitField & 33554432) !== 0) {
                  values = values._value();
                } else if ((bitField & 16777216) !== 0) {
                  return this._reject(values._reason());
                } else {
                  return this._cancel();
                }
              }

              values = util.asArray(values);

              if (values === null) {
                var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();

                this._promise._rejectCallback(err, false);

                return;
              }

              if (values.length === 0) {
                if (resolveValueIfEmpty === -5) {
                  this._resolveEmptyArray();
                } else {
                  this._resolve(toResolutionValue(resolveValueIfEmpty));
                }

                return;
              }

              this._iterate(values);
            };

            PromiseArray.prototype._iterate = function (values) {
              var len = this.getActualLength(values.length);
              this._length = len;
              this._values = this.shouldCopyValues() ? new Array(len) : this._values;
              var result = this._promise;
              var isResolved = false;
              var bitField = null;

              for (var i = 0; i < len; ++i) {
                var maybePromise = tryConvertToPromise(values[i], result);

                if (maybePromise instanceof Promise) {
                  maybePromise = maybePromise._target();
                  bitField = maybePromise._bitField;
                } else {
                  bitField = null;
                }

                if (isResolved) {
                  if (bitField !== null) {
                    maybePromise.suppressUnhandledRejections();
                  }
                } else if (bitField !== null) {
                  if ((bitField & 50397184) === 0) {
                    maybePromise._proxy(this, i);

                    this._values[i] = maybePromise;
                  } else if ((bitField & 33554432) !== 0) {
                    isResolved = this._promiseFulfilled(maybePromise._value(), i);
                  } else if ((bitField & 16777216) !== 0) {
                    isResolved = this._promiseRejected(maybePromise._reason(), i);
                  } else {
                    isResolved = this._promiseCancelled(i);
                  }
                } else {
                  isResolved = this._promiseFulfilled(maybePromise, i);
                }
              }

              if (!isResolved) result._setAsyncGuaranteed();
            };

            PromiseArray.prototype._isResolved = function () {
              return this._values === null;
            };

            PromiseArray.prototype._resolve = function (value) {
              this._values = null;

              this._promise._fulfill(value);
            };

            PromiseArray.prototype._cancel = function () {
              if (this._isResolved() || !this._promise._isCancellable()) return;
              this._values = null;

              this._promise._cancel();
            };

            PromiseArray.prototype._reject = function (reason) {
              this._values = null;

              this._promise._rejectCallback(reason, false);
            };

            PromiseArray.prototype._promiseFulfilled = function (value, index) {
              this._values[index] = value;
              var totalResolved = ++this._totalResolved;

              if (totalResolved >= this._length) {
                this._resolve(this._values);

                return true;
              }

              return false;
            };

            PromiseArray.prototype._promiseCancelled = function () {
              this._cancel();

              return true;
            };

            PromiseArray.prototype._promiseRejected = function (reason) {
              this._totalResolved++;

              this._reject(reason);

              return true;
            };

            PromiseArray.prototype._resultCancelled = function () {
              if (this._isResolved()) return;
              var values = this._values;

              this._cancel();

              if (values instanceof Promise) {
                values.cancel();
              } else {
                for (var i = 0; i < values.length; ++i) {
                  if (values[i] instanceof Promise) {
                    values[i].cancel();
                  }
                }
              }
            };

            PromiseArray.prototype.shouldCopyValues = function () {
              return true;
            };

            PromiseArray.prototype.getActualLength = function (len) {
              return len;
            };

            return PromiseArray;
          };
        }, {
          "./util": 36
        }],
        24: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL) {
            var THIS = {};

            var util = _dereq_("./util");

            var nodebackForPromise = _dereq_("./nodeback");

            var withAppended = util.withAppended;
            var maybeWrapAsError = util.maybeWrapAsError;
            var canEvaluate = util.canEvaluate;

            var TypeError = _dereq_("./errors").TypeError;

            var defaultSuffix = "Async";
            var defaultPromisified = {
              __isPromisified__: true
            };
            var noCopyProps = ["arity", "length", "name", "arguments", "caller", "callee", "prototype", "__isPromisified__"];
            var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");

            var defaultFilter = function defaultFilter(name) {
              return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
            };

            function propsFilter(key) {
              return !noCopyPropsPattern.test(key);
            }

            function isPromisified(fn) {
              try {
                return fn.__isPromisified__ === true;
              } catch (e) {
                return false;
              }
            }

            function hasPromisified(obj, key, suffix) {
              var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
              return val ? isPromisified(val) : false;
            }

            function checkValid(ret, suffix, suffixRegexp) {
              for (var i = 0; i < ret.length; i += 2) {
                var key = ret[i];

                if (suffixRegexp.test(key)) {
                  var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");

                  for (var j = 0; j < ret.length; j += 2) {
                    if (ret[j] === keyWithoutAsyncSuffix) {
                      throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s", suffix));
                    }
                  }
                }
              }
            }

            function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
              var keys = util.inheritedDataKeys(obj);
              var ret = [];

              for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                var value = obj[key];
                var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);

                if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) {
                  ret.push(key, value);
                }
              }

              checkValid(ret, suffix, suffixRegexp);
              return ret;
            }

            var escapeIdentRegex = function escapeIdentRegex(str) {
              return str.replace(/([$])/, "\\$");
            };

            var makeNodePromisifiedEval;

            if (false) {
              var switchCaseArgumentOrder = function switchCaseArgumentOrder(likelyArgumentCount) {
                var ret = [likelyArgumentCount];
                var min = Math.max(0, likelyArgumentCount - 1 - 3);

                for (var i = likelyArgumentCount - 1; i >= min; --i) {
                  ret.push(i);
                }

                for (var i = likelyArgumentCount + 1; i <= 3; ++i) {
                  ret.push(i);
                }

                return ret;
              };

              var argumentSequence = function argumentSequence(argumentCount) {
                return util.filledRange(argumentCount, "_arg", "");
              };

              var parameterDeclaration = function parameterDeclaration(parameterCount) {
                return util.filledRange(Math.max(parameterCount, 3), "_arg", "");
              };

              var parameterCount = function parameterCount(fn) {
                if (typeof fn.length === "number") {
                  return Math.max(Math.min(fn.length, 1023 + 1), 0);
                }

                return 0;
              };

              makeNodePromisifiedEval = function makeNodePromisifiedEval(callback, receiver, originalName, fn, _, multiArgs) {
                var newParameterCount = Math.max(0, parameterCount(fn) - 1);
                var argumentOrder = switchCaseArgumentOrder(newParameterCount);
                var shouldProxyThis = typeof callback === "string" || receiver === THIS;

                function generateCallForArgumentCount(count) {
                  var args = argumentSequence(count).join(", ");
                  var comma = count > 0 ? ", " : "";
                  var ret;

                  if (shouldProxyThis) {
                    ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
                  } else {
                    ret = receiver === undefined ? "ret = callback({{args}}, nodeback); break;\n" : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
                  }

                  return ret.replace("{{args}}", args).replace(", ", comma);
                }

                function generateArgumentSwitchCase() {
                  var ret = "";

                  for (var i = 0; i < argumentOrder.length; ++i) {
                    ret += "case " + argumentOrder[i] + ":" + generateCallForArgumentCount(argumentOrder[i]);
                  }

                  ret += "                                                             \n\
        default:                                                             \n\
            var args = new Array(len + 1);                                   \n\
            var i = 0;                                                       \n\
            for (var i = 0; i < len; ++i) {                                  \n\
               args[i] = arguments[i];                                       \n\
            }                                                                \n\
            args[i] = nodeback;                                              \n\
            [CodeForCall]                                                    \n\
            break;                                                           \n\
        ".replace("[CodeForCall]", shouldProxyThis ? "ret = callback.apply(this, args);\n" : "ret = callback.apply(receiver, args);\n");
                  return ret;
                }

                var getFunctionCode = typeof callback === "string" ? "this != null ? this['" + callback + "'] : fn" : "fn";
                var body = "'use strict';                                                \n\
        var ret = function (Parameters) {                                    \n\
            'use strict';                                                    \n\
            var len = arguments.length;                                      \n\
            var promise = new Promise(INTERNAL);                             \n\
            promise._captureStackTrace();                                    \n\
            var nodeback = nodebackForPromise(promise, " + multiArgs + ");   \n\
            var ret;                                                         \n\
            var callback = tryCatch([GetFunctionCode]);                      \n\
            switch(len) {                                                    \n\
                [CodeForSwitchCase]                                          \n\
            }                                                                \n\
            if (ret === errorObj) {                                          \n\
                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
            }                                                                \n\
            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();     \n\
            return promise;                                                  \n\
        };                                                                   \n\
        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
        return ret;                                                          \n\
    ".replace("[CodeForSwitchCase]", generateArgumentSwitchCase()).replace("[GetFunctionCode]", getFunctionCode);
                body = body.replace("Parameters", parameterDeclaration(newParameterCount));
                return new Function("Promise", "fn", "receiver", "withAppended", "maybeWrapAsError", "nodebackForPromise", "tryCatch", "errorObj", "notEnumerableProp", "INTERNAL", body)(Promise, fn, receiver, withAppended, maybeWrapAsError, nodebackForPromise, util.tryCatch, util.errorObj, util.notEnumerableProp, INTERNAL);
              };
            }

            function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
              var defaultThis = function () {
                return this;
              }();

              var method = callback;

              if (typeof method === "string") {
                callback = fn;
              }

              function promisified() {
                var _receiver = receiver;
                if (receiver === THIS) _receiver = this;
                var promise = new Promise(INTERNAL);

                promise._captureStackTrace();

                var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                var fn = nodebackForPromise(promise, multiArgs);

                try {
                  cb.apply(_receiver, withAppended(arguments, fn));
                } catch (e) {
                  promise._rejectCallback(maybeWrapAsError(e), true, true);
                }

                if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                return promise;
              }

              util.notEnumerableProp(promisified, "__isPromisified__", true);
              return promisified;
            }

            var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;

            function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
              var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
              var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);

              for (var i = 0, len = methods.length; i < len; i += 2) {
                var key = methods[i];
                var fn = methods[i + 1];
                var promisifiedKey = key + suffix;

                if (promisifier === makeNodePromisified) {
                  obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                } else {
                  var promisified = promisifier(fn, function () {
                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                  });
                  util.notEnumerableProp(promisified, "__isPromisified__", true);
                  obj[promisifiedKey] = promisified;
                }
              }

              util.toFastProperties(obj);
              return obj;
            }

            function promisify(callback, receiver, multiArgs) {
              return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
            }

            Promise.promisify = function (fn, options) {
              if (typeof fn !== "function") {
                throw new TypeError("expecting a function but got " + util.classString(fn));
              }

              if (isPromisified(fn)) {
                return fn;
              }

              options = Object(options);
              var receiver = options.context === undefined ? THIS : options.context;
              var multiArgs = !!options.multiArgs;
              var ret = promisify(fn, receiver, multiArgs);
              util.copyDescriptors(fn, ret, propsFilter);
              return ret;
            };

            Promise.promisifyAll = function (target, options) {
              if (typeof target !== "function" && typeof target !== "object") {
                throw new TypeError("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");
              }

              options = Object(options);
              var multiArgs = !!options.multiArgs;
              var suffix = options.suffix;
              if (typeof suffix !== "string") suffix = defaultSuffix;
              var filter = options.filter;
              if (typeof filter !== "function") filter = defaultFilter;
              var promisifier = options.promisifier;
              if (typeof promisifier !== "function") promisifier = makeNodePromisified;

              if (!util.isIdentifier(suffix)) {
                throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");
              }

              var keys = util.inheritedDataKeys(target);

              for (var i = 0; i < keys.length; ++i) {
                var value = target[keys[i]];

                if (keys[i] !== "constructor" && util.isClass(value)) {
                  promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                  promisifyAll(value, suffix, filter, promisifier, multiArgs);
                }
              }

              return promisifyAll(target, suffix, filter, promisifier, multiArgs);
            };
          };
        }, {
          "./errors": 12,
          "./nodeback": 20,
          "./util": 36
        }],
        25: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, tryConvertToPromise, apiRejection) {
            var util = _dereq_("./util");

            var isObject = util.isObject;

            var es5 = _dereq_("./es5");

            var Es6Map;
            if (typeof Map === "function") Es6Map = Map;

            var mapToEntries = function () {
              var index = 0;
              var size = 0;

              function extractEntry(value, key) {
                this[index] = value;
                this[index + size] = key;
                index++;
              }

              return function mapToEntries(map) {
                size = map.size;
                index = 0;
                var ret = new Array(map.size * 2);
                map.forEach(extractEntry, ret);
                return ret;
              };
            }();

            var entriesToMap = function entriesToMap(entries) {
              var ret = new Es6Map();
              var length = entries.length / 2 | 0;

              for (var i = 0; i < length; ++i) {
                var key = entries[length + i];
                var value = entries[i];
                ret.set(key, value);
              }

              return ret;
            };

            function PropertiesPromiseArray(obj) {
              var isMap = false;
              var entries;

              if (Es6Map !== undefined && obj instanceof Es6Map) {
                entries = mapToEntries(obj);
                isMap = true;
              } else {
                var keys = es5.keys(obj);
                var len = keys.length;
                entries = new Array(len * 2);

                for (var i = 0; i < len; ++i) {
                  var key = keys[i];
                  entries[i] = obj[key];
                  entries[i + len] = key;
                }
              }

              this.constructor$(entries);
              this._isMap = isMap;

              this._init$(undefined, isMap ? -6 : -3);
            }

            util.inherits(PropertiesPromiseArray, PromiseArray);

            PropertiesPromiseArray.prototype._init = function () {};

            PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
              this._values[index] = value;
              var totalResolved = ++this._totalResolved;

              if (totalResolved >= this._length) {
                var val;

                if (this._isMap) {
                  val = entriesToMap(this._values);
                } else {
                  val = {};
                  var keyOffset = this.length();

                  for (var i = 0, len = this.length(); i < len; ++i) {
                    val[this._values[i + keyOffset]] = this._values[i];
                  }
                }

                this._resolve(val);

                return true;
              }

              return false;
            };

            PropertiesPromiseArray.prototype.shouldCopyValues = function () {
              return false;
            };

            PropertiesPromiseArray.prototype.getActualLength = function (len) {
              return len >> 1;
            };

            function props(promises) {
              var ret;
              var castValue = tryConvertToPromise(promises);

              if (!isObject(castValue)) {
                return apiRejection("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n");
              } else if (castValue instanceof Promise) {
                ret = castValue._then(Promise.props, undefined, undefined, undefined, undefined);
              } else {
                ret = new PropertiesPromiseArray(castValue).promise();
              }

              if (castValue instanceof Promise) {
                ret._propagateFrom(castValue, 2);
              }

              return ret;
            }

            Promise.prototype.props = function () {
              return props(this);
            };

            Promise.props = function (promises) {
              return props(promises);
            };
          };
        }, {
          "./es5": 13,
          "./util": 36
        }],
        26: [function (_dereq_, module, exports) {
          "use strict";

          function arrayMove(src, srcIndex, dst, dstIndex, len) {
            for (var j = 0; j < len; ++j) {
              dst[j + dstIndex] = src[j + srcIndex];
              src[j + srcIndex] = void 0;
            }
          }

          function Queue(capacity) {
            this._capacity = capacity;
            this._length = 0;
            this._front = 0;
          }

          Queue.prototype._willBeOverCapacity = function (size) {
            return this._capacity < size;
          };

          Queue.prototype._pushOne = function (arg) {
            var length = this.length();

            this._checkCapacity(length + 1);

            var i = this._front + length & this._capacity - 1;
            this[i] = arg;
            this._length = length + 1;
          };

          Queue.prototype.push = function (fn, receiver, arg) {
            var length = this.length() + 3;

            if (this._willBeOverCapacity(length)) {
              this._pushOne(fn);

              this._pushOne(receiver);

              this._pushOne(arg);

              return;
            }

            var j = this._front + length - 3;

            this._checkCapacity(length);

            var wrapMask = this._capacity - 1;
            this[j + 0 & wrapMask] = fn;
            this[j + 1 & wrapMask] = receiver;
            this[j + 2 & wrapMask] = arg;
            this._length = length;
          };

          Queue.prototype.shift = function () {
            var front = this._front,
                ret = this[front];
            this[front] = undefined;
            this._front = front + 1 & this._capacity - 1;
            this._length--;
            return ret;
          };

          Queue.prototype.length = function () {
            return this._length;
          };

          Queue.prototype._checkCapacity = function (size) {
            if (this._capacity < size) {
              this._resizeTo(this._capacity << 1);
            }
          };

          Queue.prototype._resizeTo = function (capacity) {
            var oldCapacity = this._capacity;
            this._capacity = capacity;
            var front = this._front;
            var length = this._length;
            var moveItemsCount = front + length & oldCapacity - 1;
            arrayMove(this, 0, this, oldCapacity, moveItemsCount);
          };

          module.exports = Queue;
        }, {}],
        27: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL, tryConvertToPromise, apiRejection) {
            var util = _dereq_("./util");

            var raceLater = function raceLater(promise) {
              return promise.then(function (array) {
                return race(array, promise);
              });
            };

            function race(promises, parent) {
              var maybePromise = tryConvertToPromise(promises);

              if (maybePromise instanceof Promise) {
                return raceLater(maybePromise);
              } else {
                promises = util.asArray(promises);
                if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
              }

              var ret = new Promise(INTERNAL);

              if (parent !== undefined) {
                ret._propagateFrom(parent, 3);
              }

              var fulfill = ret._fulfill;
              var reject = ret._reject;

              for (var i = 0, len = promises.length; i < len; ++i) {
                var val = promises[i];

                if (val === undefined && !(i in promises)) {
                  continue;
                }

                Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
              }

              return ret;
            }

            Promise.race = function (promises) {
              return race(promises, undefined);
            };

            Promise.prototype.race = function () {
              return race(this, undefined);
            };
          };
        }, {
          "./util": 36
        }],
        28: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
            var util = _dereq_("./util");

            var tryCatch = util.tryCatch;

            function ReductionPromiseArray(promises, fn, initialValue, _each) {
              this.constructor$(promises);

              var context = Promise._getContext();

              this._fn = util.contextBind(context, fn);

              if (initialValue !== undefined) {
                initialValue = Promise.resolve(initialValue);

                initialValue._attachCancellationCallback(this);
              }

              this._initialValue = initialValue;
              this._currentCancellable = null;

              if (_each === INTERNAL) {
                this._eachValues = Array(this._length);
              } else if (_each === 0) {
                this._eachValues = null;
              } else {
                this._eachValues = undefined;
              }

              this._promise._captureStackTrace();

              this._init$(undefined, -5);
            }

            util.inherits(ReductionPromiseArray, PromiseArray);

            ReductionPromiseArray.prototype._gotAccum = function (accum) {
              if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) {
                this._eachValues.push(accum);
              }
            };

            ReductionPromiseArray.prototype._eachComplete = function (value) {
              if (this._eachValues !== null) {
                this._eachValues.push(value);
              }

              return this._eachValues;
            };

            ReductionPromiseArray.prototype._init = function () {};

            ReductionPromiseArray.prototype._resolveEmptyArray = function () {
              this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
            };

            ReductionPromiseArray.prototype.shouldCopyValues = function () {
              return false;
            };

            ReductionPromiseArray.prototype._resolve = function (value) {
              this._promise._resolveCallback(value);

              this._values = null;
            };

            ReductionPromiseArray.prototype._resultCancelled = function (sender) {
              if (sender === this._initialValue) return this._cancel();
              if (this._isResolved()) return;

              this._resultCancelled$();

              if (this._currentCancellable instanceof Promise) {
                this._currentCancellable.cancel();
              }

              if (this._initialValue instanceof Promise) {
                this._initialValue.cancel();
              }
            };

            ReductionPromiseArray.prototype._iterate = function (values) {
              this._values = values;
              var value;
              var i;
              var length = values.length;

              if (this._initialValue !== undefined) {
                value = this._initialValue;
                i = 0;
              } else {
                value = Promise.resolve(values[0]);
                i = 1;
              }

              this._currentCancellable = value;

              for (var j = i; j < length; ++j) {
                var maybePromise = values[j];

                if (maybePromise instanceof Promise) {
                  maybePromise.suppressUnhandledRejections();
                }
              }

              if (!value.isRejected()) {
                for (; i < length; ++i) {
                  var ctx = {
                    accum: null,
                    value: values[i],
                    index: i,
                    length: length,
                    array: this
                  };
                  value = value._then(gotAccum, undefined, undefined, ctx, undefined);

                  if ((i & 127) === 0) {
                    value._setNoAsyncGuarantee();
                  }
                }
              }

              if (this._eachValues !== undefined) {
                value = value._then(this._eachComplete, undefined, undefined, this, undefined);
              }

              value._then(completed, completed, undefined, value, this);
            };

            Promise.prototype.reduce = function (fn, initialValue) {
              return reduce(this, fn, initialValue, null);
            };

            Promise.reduce = function (promises, fn, initialValue, _each) {
              return reduce(promises, fn, initialValue, _each);
            };

            function completed(valueOrReason, array) {
              if (this.isFulfilled()) {
                array._resolve(valueOrReason);
              } else {
                array._reject(valueOrReason);
              }
            }

            function reduce(promises, fn, initialValue, _each) {
              if (typeof fn !== "function") {
                return apiRejection("expecting a function but got " + util.classString(fn));
              }

              var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
              return array.promise();
            }

            function gotAccum(accum) {
              this.accum = accum;

              this.array._gotAccum(accum);

              var value = tryConvertToPromise(this.value, this.array._promise);

              if (value instanceof Promise) {
                this.array._currentCancellable = value;
                return value._then(gotValue, undefined, undefined, this, undefined);
              } else {
                return gotValue.call(this, value);
              }
            }

            function gotValue(value) {
              var array = this.array;
              var promise = array._promise;
              var fn = tryCatch(array._fn);

              promise._pushContext();

              var ret;

              if (array._eachValues !== undefined) {
                ret = fn.call(promise._boundValue(), value, this.index, this.length);
              } else {
                ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
              }

              if (ret instanceof Promise) {
                array._currentCancellable = ret;
              }

              var promiseCreated = promise._popContext();

              debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
              return ret;
            }
          };
        }, {
          "./util": 36
        }],
        29: [function (_dereq_, module, exports) {
          "use strict";

          var util = _dereq_("./util");

          var schedule;

          var noAsyncScheduler = function noAsyncScheduler() {
            throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n");
          };

          var NativePromise = util.getNativePromise();

          if (util.isNode && typeof MutationObserver === "undefined") {
            var GlobalSetImmediate = global.setImmediate;
            var ProcessNextTick = process.nextTick;
            schedule = util.isRecentNode ? function (fn) {
              GlobalSetImmediate.call(global, fn);
            } : function (fn) {
              ProcessNextTick.call(process, fn);
            };
          } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
            var nativePromise = NativePromise.resolve();

            schedule = function schedule(fn) {
              nativePromise.then(fn);
            };
          } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) {
            schedule = function () {
              var div = document.createElement("div");
              var opts = {
                attributes: true
              };
              var toggleScheduled = false;
              var div2 = document.createElement("div");
              var o2 = new MutationObserver(function () {
                div.classList.toggle("foo");
                toggleScheduled = false;
              });
              o2.observe(div2, opts);

              var scheduleToggle = function scheduleToggle() {
                if (toggleScheduled) return;
                toggleScheduled = true;
                div2.classList.toggle("foo");
              };

              return function schedule(fn) {
                var o = new MutationObserver(function () {
                  o.disconnect();
                  fn();
                });
                o.observe(div, opts);
                scheduleToggle();
              };
            }();
          } else if (typeof setImmediate !== "undefined") {
            schedule = function schedule(fn) {
              setImmediate(fn);
            };
          } else if (typeof setTimeout !== "undefined") {
            schedule = function schedule(fn) {
              setTimeout(fn, 0);
            };
          } else {
            schedule = noAsyncScheduler;
          }

          module.exports = schedule;
        }, {
          "./util": 36
        }],
        30: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, debug) {
            var PromiseInspection = Promise.PromiseInspection;

            var util = _dereq_("./util");

            function SettledPromiseArray(values) {
              this.constructor$(values);
            }

            util.inherits(SettledPromiseArray, PromiseArray);

            SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
              this._values[index] = inspection;
              var totalResolved = ++this._totalResolved;

              if (totalResolved >= this._length) {
                this._resolve(this._values);

                return true;
              }

              return false;
            };

            SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
              var ret = new PromiseInspection();
              ret._bitField = 33554432;
              ret._settledValueField = value;
              return this._promiseResolved(index, ret);
            };

            SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
              var ret = new PromiseInspection();
              ret._bitField = 16777216;
              ret._settledValueField = reason;
              return this._promiseResolved(index, ret);
            };

            Promise.settle = function (promises) {
              debug.deprecated(".settle()", ".reflect()");
              return new SettledPromiseArray(promises).promise();
            };

            Promise.allSettled = function (promises) {
              return new SettledPromiseArray(promises).promise();
            };

            Promise.prototype.settle = function () {
              return Promise.settle(this);
            };
          };
        }, {
          "./util": 36
        }],
        31: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, PromiseArray, apiRejection) {
            var util = _dereq_("./util");

            var RangeError = _dereq_("./errors").RangeError;

            var AggregateError = _dereq_("./errors").AggregateError;

            var isArray = util.isArray;
            var CANCELLATION = {};

            function SomePromiseArray(values) {
              this.constructor$(values);
              this._howMany = 0;
              this._unwrap = false;
              this._initialized = false;
            }

            util.inherits(SomePromiseArray, PromiseArray);

            SomePromiseArray.prototype._init = function () {
              if (!this._initialized) {
                return;
              }

              if (this._howMany === 0) {
                this._resolve([]);

                return;
              }

              this._init$(undefined, -5);

              var isArrayResolved = isArray(this._values);

              if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) {
                this._reject(this._getRangeError(this.length()));
              }
            };

            SomePromiseArray.prototype.init = function () {
              this._initialized = true;

              this._init();
            };

            SomePromiseArray.prototype.setUnwrap = function () {
              this._unwrap = true;
            };

            SomePromiseArray.prototype.howMany = function () {
              return this._howMany;
            };

            SomePromiseArray.prototype.setHowMany = function (count) {
              this._howMany = count;
            };

            SomePromiseArray.prototype._promiseFulfilled = function (value) {
              this._addFulfilled(value);

              if (this._fulfilled() === this.howMany()) {
                this._values.length = this.howMany();

                if (this.howMany() === 1 && this._unwrap) {
                  this._resolve(this._values[0]);
                } else {
                  this._resolve(this._values);
                }

                return true;
              }

              return false;
            };

            SomePromiseArray.prototype._promiseRejected = function (reason) {
              this._addRejected(reason);

              return this._checkOutcome();
            };

            SomePromiseArray.prototype._promiseCancelled = function () {
              if (this._values instanceof Promise || this._values == null) {
                return this._cancel();
              }

              this._addRejected(CANCELLATION);

              return this._checkOutcome();
            };

            SomePromiseArray.prototype._checkOutcome = function () {
              if (this.howMany() > this._canPossiblyFulfill()) {
                var e = new AggregateError();

                for (var i = this.length(); i < this._values.length; ++i) {
                  if (this._values[i] !== CANCELLATION) {
                    e.push(this._values[i]);
                  }
                }

                if (e.length > 0) {
                  this._reject(e);
                } else {
                  this._cancel();
                }

                return true;
              }

              return false;
            };

            SomePromiseArray.prototype._fulfilled = function () {
              return this._totalResolved;
            };

            SomePromiseArray.prototype._rejected = function () {
              return this._values.length - this.length();
            };

            SomePromiseArray.prototype._addRejected = function (reason) {
              this._values.push(reason);
            };

            SomePromiseArray.prototype._addFulfilled = function (value) {
              this._values[this._totalResolved++] = value;
            };

            SomePromiseArray.prototype._canPossiblyFulfill = function () {
              return this.length() - this._rejected();
            };

            SomePromiseArray.prototype._getRangeError = function (count) {
              var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
              return new RangeError(message);
            };

            SomePromiseArray.prototype._resolveEmptyArray = function () {
              this._reject(this._getRangeError(0));
            };

            function some(promises, howMany) {
              if ((howMany | 0) !== howMany || howMany < 0) {
                return apiRejection("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");
              }

              var ret = new SomePromiseArray(promises);
              var promise = ret.promise();
              ret.setHowMany(howMany);
              ret.init();
              return promise;
            }

            Promise.some = function (promises, howMany) {
              return some(promises, howMany);
            };

            Promise.prototype.some = function (howMany) {
              return some(this, howMany);
            };

            Promise._SomePromiseArray = SomePromiseArray;
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        32: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise) {
            function PromiseInspection(promise) {
              if (promise !== undefined) {
                promise = promise._target();
                this._bitField = promise._bitField;
                this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
              } else {
                this._bitField = 0;
                this._settledValueField = undefined;
              }
            }

            PromiseInspection.prototype._settledValue = function () {
              return this._settledValueField;
            };

            var value = PromiseInspection.prototype.value = function () {
              if (!this.isFulfilled()) {
                throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");
              }

              return this._settledValue();
            };

            var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function () {
              if (!this.isRejected()) {
                throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");
              }

              return this._settledValue();
            };

            var isFulfilled = PromiseInspection.prototype.isFulfilled = function () {
              return (this._bitField & 33554432) !== 0;
            };

            var isRejected = PromiseInspection.prototype.isRejected = function () {
              return (this._bitField & 16777216) !== 0;
            };

            var isPending = PromiseInspection.prototype.isPending = function () {
              return (this._bitField & 50397184) === 0;
            };

            var isResolved = PromiseInspection.prototype.isResolved = function () {
              return (this._bitField & 50331648) !== 0;
            };

            PromiseInspection.prototype.isCancelled = function () {
              return (this._bitField & 8454144) !== 0;
            };

            Promise.prototype.__isCancelled = function () {
              return (this._bitField & 65536) === 65536;
            };

            Promise.prototype._isCancelled = function () {
              return this._target().__isCancelled();
            };

            Promise.prototype.isCancelled = function () {
              return (this._target()._bitField & 8454144) !== 0;
            };

            Promise.prototype.isPending = function () {
              return isPending.call(this._target());
            };

            Promise.prototype.isRejected = function () {
              return isRejected.call(this._target());
            };

            Promise.prototype.isFulfilled = function () {
              return isFulfilled.call(this._target());
            };

            Promise.prototype.isResolved = function () {
              return isResolved.call(this._target());
            };

            Promise.prototype.value = function () {
              return value.call(this._target());
            };

            Promise.prototype.reason = function () {
              var target = this._target();

              target._unsetRejectionIsUnhandled();

              return reason.call(target);
            };

            Promise.prototype._value = function () {
              return this._settledValue();
            };

            Promise.prototype._reason = function () {
              this._unsetRejectionIsUnhandled();

              return this._settledValue();
            };

            Promise.PromiseInspection = PromiseInspection;
          };
        }, {}],
        33: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL) {
            var util = _dereq_("./util");

            var errorObj = util.errorObj;
            var isObject = util.isObject;

            function tryConvertToPromise(obj, context) {
              if (isObject(obj)) {
                if (obj instanceof Promise) return obj;
                var then = getThen(obj);

                if (then === errorObj) {
                  if (context) context._pushContext();
                  var ret = Promise.reject(then.e);
                  if (context) context._popContext();
                  return ret;
                } else if (typeof then === "function") {
                  if (isAnyBluebirdPromise(obj)) {
                    var ret = new Promise(INTERNAL);

                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);

                    return ret;
                  }

                  return doThenable(obj, then, context);
                }
              }

              return obj;
            }

            function doGetThen(obj) {
              return obj.then;
            }

            function getThen(obj) {
              try {
                return doGetThen(obj);
              } catch (e) {
                errorObj.e = e;
                return errorObj;
              }
            }

            var hasProp = {}.hasOwnProperty;

            function isAnyBluebirdPromise(obj) {
              try {
                return hasProp.call(obj, "_promise0");
              } catch (e) {
                return false;
              }
            }

            function doThenable(x, then, context) {
              var promise = new Promise(INTERNAL);
              var ret = promise;
              if (context) context._pushContext();

              promise._captureStackTrace();

              if (context) context._popContext();
              var synchronous = true;
              var result = util.tryCatch(then).call(x, resolve, reject);
              synchronous = false;

              if (promise && result === errorObj) {
                promise._rejectCallback(result.e, true, true);

                promise = null;
              }

              function resolve(value) {
                if (!promise) return;

                promise._resolveCallback(value);

                promise = null;
              }

              function reject(reason) {
                if (!promise) return;

                promise._rejectCallback(reason, synchronous, true);

                promise = null;
              }

              return ret;
            }

            return tryConvertToPromise;
          };
        }, {
          "./util": 36
        }],
        34: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, INTERNAL, debug) {
            var util = _dereq_("./util");

            var TimeoutError = Promise.TimeoutError;

            function HandleWrapper(handle) {
              this.handle = handle;
            }

            HandleWrapper.prototype._resultCancelled = function () {
              clearTimeout(this.handle);
            };

            var afterValue = function afterValue(value) {
              return delay(+this).thenReturn(value);
            };

            var delay = Promise.delay = function (ms, value) {
              var ret;
              var handle;

              if (value !== undefined) {
                ret = Promise.resolve(value)._then(afterValue, null, null, ms, undefined);

                if (debug.cancellation() && value instanceof Promise) {
                  ret._setOnCancel(value);
                }
              } else {
                ret = new Promise(INTERNAL);
                handle = setTimeout(function () {
                  ret._fulfill();
                }, +ms);

                if (debug.cancellation()) {
                  ret._setOnCancel(new HandleWrapper(handle));
                }

                ret._captureStackTrace();
              }

              ret._setAsyncGuaranteed();

              return ret;
            };

            Promise.prototype.delay = function (ms) {
              return delay(ms, this);
            };

            var afterTimeout = function afterTimeout(promise, message, parent) {
              var err;

              if (typeof message !== "string") {
                if (message instanceof Error) {
                  err = message;
                } else {
                  err = new TimeoutError("operation timed out");
                }
              } else {
                err = new TimeoutError(message);
              }

              util.markAsOriginatingFromRejection(err);

              promise._attachExtraTrace(err);

              promise._reject(err);

              if (parent != null) {
                parent.cancel();
              }
            };

            function successClear(value) {
              clearTimeout(this.handle);
              return value;
            }

            function failureClear(reason) {
              clearTimeout(this.handle);
              throw reason;
            }

            Promise.prototype.timeout = function (ms, message) {
              ms = +ms;
              var ret, parent;
              var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                if (ret.isPending()) {
                  afterTimeout(ret, message, parent);
                }
              }, ms));

              if (debug.cancellation()) {
                parent = this.then();
                ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);

                ret._setOnCancel(handleWrapper);
              } else {
                ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
              }

              return ret;
            };
          };
        }, {
          "./util": 36
        }],
        35: [function (_dereq_, module, exports) {
          "use strict";

          module.exports = function (Promise, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
            var util = _dereq_("./util");

            var TypeError = _dereq_("./errors").TypeError;

            var inherits = _dereq_("./util").inherits;

            var errorObj = util.errorObj;
            var tryCatch = util.tryCatch;
            var NULL = {};

            function thrower(e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }

            function castPreservingDisposable(thenable) {
              var maybePromise = tryConvertToPromise(thenable);

              if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) {
                maybePromise._setDisposable(thenable._getDisposer());
              }

              return maybePromise;
            }

            function dispose(resources, inspection) {
              var i = 0;
              var len = resources.length;
              var ret = new Promise(INTERNAL);

              function iterator() {
                if (i >= len) return ret._fulfill();
                var maybePromise = castPreservingDisposable(resources[i++]);

                if (maybePromise instanceof Promise && maybePromise._isDisposable()) {
                  try {
                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                  } catch (e) {
                    return thrower(e);
                  }

                  if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower, null, null, null);
                  }
                }

                iterator();
              }

              iterator();
              return ret;
            }

            function Disposer(data, promise, context) {
              this._data = data;
              this._promise = promise;
              this._context = context;
            }

            Disposer.prototype.data = function () {
              return this._data;
            };

            Disposer.prototype.promise = function () {
              return this._promise;
            };

            Disposer.prototype.resource = function () {
              if (this.promise().isFulfilled()) {
                return this.promise().value();
              }

              return NULL;
            };

            Disposer.prototype.tryDispose = function (inspection) {
              var resource = this.resource();
              var context = this._context;
              if (context !== undefined) context._pushContext();
              var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
              if (context !== undefined) context._popContext();

              this._promise._unsetDisposable();

              this._data = null;
              return ret;
            };

            Disposer.isDisposer = function (d) {
              return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
            };

            function FunctionDisposer(fn, promise, context) {
              this.constructor$(fn, promise, context);
            }

            inherits(FunctionDisposer, Disposer);

            FunctionDisposer.prototype.doDispose = function (resource, inspection) {
              var fn = this.data();
              return fn.call(resource, resource, inspection);
            };

            function maybeUnwrapDisposer(value) {
              if (Disposer.isDisposer(value)) {
                this.resources[this.index]._setDisposable(value);

                return value.promise();
              }

              return value;
            }

            function ResourceList(length) {
              this.length = length;
              this.promise = null;
              this[length - 1] = null;
            }

            ResourceList.prototype._resultCancelled = function () {
              var len = this.length;

              for (var i = 0; i < len; ++i) {
                var item = this[i];

                if (item instanceof Promise) {
                  item.cancel();
                }
              }
            };

            Promise.using = function () {
              var len = arguments.length;
              if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
              var fn = arguments[len - 1];

              if (typeof fn !== "function") {
                return apiRejection("expecting a function but got " + util.classString(fn));
              }

              var input;
              var spreadArgs = true;

              if (len === 2 && Array.isArray(arguments[0])) {
                input = arguments[0];
                len = input.length;
                spreadArgs = false;
              } else {
                input = arguments;
                len--;
              }

              var resources = new ResourceList(len);

              for (var i = 0; i < len; ++i) {
                var resource = input[i];

                if (Disposer.isDisposer(resource)) {
                  var disposer = resource;
                  resource = resource.promise();

                  resource._setDisposable(disposer);
                } else {
                  var maybePromise = tryConvertToPromise(resource);

                  if (maybePromise instanceof Promise) {
                    resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                      resources: resources,
                      index: i
                    }, undefined);
                  }
                }

                resources[i] = resource;
              }

              var reflectedResources = new Array(resources.length);

              for (var i = 0; i < reflectedResources.length; ++i) {
                reflectedResources[i] = Promise.resolve(resources[i]).reflect();
              }

              var resultPromise = Promise.all(reflectedResources).then(function (inspections) {
                for (var i = 0; i < inspections.length; ++i) {
                  var inspection = inspections[i];

                  if (inspection.isRejected()) {
                    errorObj.e = inspection.error();
                    return errorObj;
                  } else if (!inspection.isFulfilled()) {
                    resultPromise.cancel();
                    return;
                  }

                  inspections[i] = inspection.value();
                }

                promise._pushContext();

                fn = tryCatch(fn);
                var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);

                var promiseCreated = promise._popContext();

                debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                return ret;
              });
              var promise = resultPromise.lastly(function () {
                var inspection = new Promise.PromiseInspection(resultPromise);
                return dispose(resources, inspection);
              });
              resources.promise = promise;

              promise._setOnCancel(resources);

              return promise;
            };

            Promise.prototype._setDisposable = function (disposer) {
              this._bitField = this._bitField | 131072;
              this._disposer = disposer;
            };

            Promise.prototype._isDisposable = function () {
              return (this._bitField & 131072) > 0;
            };

            Promise.prototype._getDisposer = function () {
              return this._disposer;
            };

            Promise.prototype._unsetDisposable = function () {
              this._bitField = this._bitField & ~131072;
              this._disposer = undefined;
            };

            Promise.prototype.disposer = function (fn) {
              if (typeof fn === "function") {
                return new FunctionDisposer(fn, this, createContext());
              }

              throw new TypeError();
            };
          };
        }, {
          "./errors": 12,
          "./util": 36
        }],
        36: [function (_dereq_, module, exports) {
          "use strict";

          var es5 = _dereq_("./es5");

          var canEvaluate = typeof navigator == "undefined";
          var errorObj = {
            e: {}
          };
          var tryCatchTarget;
          var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : this !== undefined ? this : null;

          function tryCatcher() {
            try {
              var target = tryCatchTarget;
              tryCatchTarget = null;
              return target.apply(this, arguments);
            } catch (e) {
              errorObj.e = e;
              return errorObj;
            }
          }

          function tryCatch(fn) {
            tryCatchTarget = fn;
            return tryCatcher;
          }

          var inherits = function inherits(Child, Parent) {
            var hasProp = {}.hasOwnProperty;

            function T() {
              this.constructor = Child;
              this.constructor$ = Parent;

              for (var propertyName in Parent.prototype) {
                if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") {
                  this[propertyName + "$"] = Parent.prototype[propertyName];
                }
              }
            }

            T.prototype = Parent.prototype;
            Child.prototype = new T();
            return Child.prototype;
          };

          function isPrimitive(val) {
            return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
          }

          function isObject(value) {
            return typeof value === "function" || typeof value === "object" && value !== null;
          }

          function maybeWrapAsError(maybeError) {
            if (!isPrimitive(maybeError)) return maybeError;
            return new Error(safeToString(maybeError));
          }

          function withAppended(target, appendee) {
            var len = target.length;
            var ret = new Array(len + 1);
            var i;

            for (i = 0; i < len; ++i) {
              ret[i] = target[i];
            }

            ret[i] = appendee;
            return ret;
          }

          function getDataPropertyOrDefault(obj, key, defaultValue) {
            if (es5.isES5) {
              var desc = Object.getOwnPropertyDescriptor(obj, key);

              if (desc != null) {
                return desc.get == null && desc.set == null ? desc.value : defaultValue;
              }
            } else {
              return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
            }
          }

          function notEnumerableProp(obj, name, value) {
            if (isPrimitive(obj)) return obj;
            var descriptor = {
              value: value,
              configurable: true,
              enumerable: false,
              writable: true
            };
            es5.defineProperty(obj, name, descriptor);
            return obj;
          }

          function thrower(r) {
            throw r;
          }

          var inheritedDataKeys = function () {
            var excludedPrototypes = [Array.prototype, Object.prototype, Function.prototype];

            var isExcludedProto = function isExcludedProto(val) {
              for (var i = 0; i < excludedPrototypes.length; ++i) {
                if (excludedPrototypes[i] === val) {
                  return true;
                }
              }

              return false;
            };

            if (es5.isES5) {
              var getKeys = Object.getOwnPropertyNames;
              return function (obj) {
                var ret = [];
                var visitedKeys = Object.create(null);

                while (obj != null && !isExcludedProto(obj)) {
                  var keys;

                  try {
                    keys = getKeys(obj);
                  } catch (e) {
                    return ret;
                  }

                  for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);

                    if (desc != null && desc.get == null && desc.set == null) {
                      ret.push(key);
                    }
                  }

                  obj = es5.getPrototypeOf(obj);
                }

                return ret;
              };
            } else {
              var hasProp = {}.hasOwnProperty;
              return function (obj) {
                if (isExcludedProto(obj)) return [];
                var ret = [];
                /*jshint forin:false */

                enumeration: for (var key in obj) {
                  if (hasProp.call(obj, key)) {
                    ret.push(key);
                  } else {
                    for (var i = 0; i < excludedPrototypes.length; ++i) {
                      if (hasProp.call(excludedPrototypes[i], key)) {
                        continue enumeration;
                      }
                    }

                    ret.push(key);
                  }
                }

                return ret;
              };
            }
          }();

          var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;

          function isClass(fn) {
            try {
              if (typeof fn === "function") {
                var keys = es5.names(fn.prototype);
                var hasMethods = es5.isES5 && keys.length > 1;
                var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;

                if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) {
                  return true;
                }
              }

              return false;
            } catch (e) {
              return false;
            }
          }

          function toFastProperties(obj) {
            /*jshint -W027,-W055,-W031*/
            function FakeConstructor() {}

            FakeConstructor.prototype = obj;
            var receiver = new FakeConstructor();

            function ic() {
              return typeof receiver.foo;
            }

            ic();
            ic();
            return obj;
            eval(obj);
          }

          var rident = /^[a-z$_][a-z$_0-9]*$/i;

          function isIdentifier(str) {
            return rident.test(str);
          }

          function filledRange(count, prefix, suffix) {
            var ret = new Array(count);

            for (var i = 0; i < count; ++i) {
              ret[i] = prefix + i + suffix;
            }

            return ret;
          }

          function safeToString(obj) {
            try {
              return obj + "";
            } catch (e) {
              return "[no string representation]";
            }
          }

          function isError(obj) {
            return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
          }

          function markAsOriginatingFromRejection(e) {
            try {
              notEnumerableProp(e, "isOperational", true);
            } catch (ignore) {}
          }

          function originatesFromRejection(e) {
            if (e == null) return false;
            return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
          }

          function canAttachTrace(obj) {
            return isError(obj) && es5.propertyIsWritable(obj, "stack");
          }

          var ensureErrorObject = function () {
            if (!("stack" in new Error())) {
              return function (value) {
                if (canAttachTrace(value)) return value;

                try {
                  throw new Error(safeToString(value));
                } catch (err) {
                  return err;
                }
              };
            } else {
              return function (value) {
                if (canAttachTrace(value)) return value;
                return new Error(safeToString(value));
              };
            }
          }();

          function classString(obj) {
            return {}.toString.call(obj);
          }

          function copyDescriptors(from, to, filter) {
            var keys = es5.names(from);

            for (var i = 0; i < keys.length; ++i) {
              var key = keys[i];

              if (filter(key)) {
                try {
                  es5.defineProperty(to, key, es5.getDescriptor(from, key));
                } catch (ignore) {}
              }
            }
          }

          var asArray = function asArray(v) {
            if (es5.isArray(v)) {
              return v;
            }

            return null;
          };

          if (typeof Symbol !== "undefined" && Symbol.iterator) {
            var ArrayFrom = typeof Array.from === "function" ? function (v) {
              return Array.from(v);
            } : function (v) {
              var ret = [];
              var it = v[Symbol.iterator]();
              var itResult;

              while (!(itResult = it.next()).done) {
                ret.push(itResult.value);
              }

              return ret;
            };

            asArray = function asArray(v) {
              if (es5.isArray(v)) {
                return v;
              } else if (v != null && typeof v[Symbol.iterator] === "function") {
                return ArrayFrom(v);
              }

              return null;
            };
          }

          var isNode = typeof process !== "undefined" && classString(process).toLowerCase() === "[object process]";
          var hasEnvVariables = typeof process !== "undefined" && typeof process.env !== "undefined";

          function env(key) {
            return hasEnvVariables ? process.env[key] : undefined;
          }

          function getNativePromise() {
            if (typeof Promise === "function") {
              try {
                var promise = new Promise(function () {});

                if (classString(promise) === "[object Promise]") {
                  return Promise;
                }
              } catch (e) {}
            }
          }

          var reflectHandler;

          function contextBind(ctx, cb) {
            if (ctx === null || typeof cb !== "function" || cb === reflectHandler) {
              return cb;
            }

            if (ctx.domain !== null) {
              cb = ctx.domain.bind(cb);
            }

            var async = ctx.async;

            if (async !== null) {
              var old = cb;

              cb = function cb() {
                var args = new Array(2).concat([].slice.call(arguments));
                ;
                args[0] = old;
                args[1] = this;
                return async.runInAsyncScope.apply(async, args);
              };
            }

            return cb;
          }

          var ret = {
            setReflectHandler: function setReflectHandler(fn) {
              reflectHandler = fn;
            },
            isClass: isClass,
            isIdentifier: isIdentifier,
            inheritedDataKeys: inheritedDataKeys,
            getDataPropertyOrDefault: getDataPropertyOrDefault,
            thrower: thrower,
            isArray: es5.isArray,
            asArray: asArray,
            notEnumerableProp: notEnumerableProp,
            isPrimitive: isPrimitive,
            isObject: isObject,
            isError: isError,
            canEvaluate: canEvaluate,
            errorObj: errorObj,
            tryCatch: tryCatch,
            inherits: inherits,
            withAppended: withAppended,
            maybeWrapAsError: maybeWrapAsError,
            toFastProperties: toFastProperties,
            filledRange: filledRange,
            toString: safeToString,
            canAttachTrace: canAttachTrace,
            ensureErrorObject: ensureErrorObject,
            originatesFromRejection: originatesFromRejection,
            markAsOriginatingFromRejection: markAsOriginatingFromRejection,
            classString: classString,
            copyDescriptors: copyDescriptors,
            isNode: isNode,
            hasEnvVariables: hasEnvVariables,
            env: env,
            global: globalObject,
            getNativePromise: getNativePromise,
            contextBind: contextBind
          };

          ret.isRecentNode = ret.isNode && function () {
            var version;

            if (process.versions && process.versions.node) {
              version = process.versions.node.split(".").map(Number);
            } else if (process.version) {
              version = process.version.split(".").map(Number);
            }

            return version[0] === 0 && version[1] > 10 || version[0] > 0;
          }();

          ret.nodeSupportsAsyncResource = ret.isNode && function () {
            var supportsAsync = false;

            try {
              var res = _dereq_("async_hooks").AsyncResource;

              supportsAsync = typeof res.prototype.runInAsyncScope === "function";
            } catch (e) {
              supportsAsync = false;
            }

            return supportsAsync;
          }();

          if (ret.isNode) ret.toFastProperties(process);

          try {
            throw new Error();
          } catch (e) {
            ret.lastLineError = e;
          }

          module.exports = ret;
        }, {
          "./es5": 13,
          "async_hooks": undefined
        }]
      }, {}, [4])(4);
    });
    ;

    if (typeof window !== 'undefined' && window !== null) {
      window.P = window.Promise;
    } else if (typeof self !== 'undefined' && self !== null) {
      self.P = self.Promise;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(23), __webpack_require__(25), __webpack_require__(14).setImmediate);
  /***/
},
/* 7 */

/***/
function (module, exports, __webpack_require__) {
  var toPropertyKey = __webpack_require__(17);

  function _defineProperty(obj, key, value) {
    key = toPropertyKey(key);

    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 8 */

/***/
function (module, exports, __webpack_require__) {
  var superPropBase = __webpack_require__(31);

  function _get() {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      module.exports = _get = Reflect.get.bind(), module.exports.__esModule = true, module.exports["default"] = module.exports;
    } else {
      module.exports = _get = function _get(target, property, receiver) {
        var base = superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(arguments.length < 3 ? target : receiver);
        }

        return desc.value;
      }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    }

    return _get.apply(this, arguments);
  }

  module.exports = _get, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 9 */

/***/
function (module, exports) {
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 10 */

/***/
function (module, exports) {
  function _typeof(o) {
    "@babel/helpers - typeof";

    return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
  }

  module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 11 */

/***/
function (module, exports, __webpack_require__) {
  var _interopRequireDefault = __webpack_require__(9);

  var _Promise = _interopRequireDefault(__webpack_require__(6))["default"];

  exports.sleep = function () {
    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    return function (value) {
      return new _Promise(function (resolve) {
        return setTimeout(function () {
          return resolve(value);
        }, t);
      });
    };
  };

  exports.socket;

  try {
    exports.socket = __webpack_require__(53);
  } catch (e) {
    exports.socket = null;
  }
  /***/

},
/* 12 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var implementation = __webpack_require__(42);

  module.exports = Function.prototype.bind || implementation;
  /***/
},
/* 13 */

/***/
function (module, exports) {
  "use strict";
  'use strict';

  var replace = String.prototype.replace;
  var percentTwenties = /%20/g;
  var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
  };
  module.exports = {
    'default': Format.RFC3986,
    formatters: {
      RFC1738: function RFC1738(value) {
        return replace.call(value, percentTwenties, '+');
      },
      RFC3986: function RFC3986(value) {
        return String(value);
      }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
  };
  /***/
},
/* 14 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (setImmediate, clearImmediate) {
    var nextTick = __webpack_require__(23).nextTick;

    var apply = Function.prototype.apply;
    var slice = Array.prototype.slice;
    var immediateIds = {};
    var nextImmediateId = 0; // DOM APIs, for completeness

    exports.setTimeout = function () {
      return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
    };

    exports.setInterval = function () {
      return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
    };

    exports.clearTimeout = exports.clearInterval = function (timeout) {
      timeout.close();
    };

    function Timeout(id, clearFn) {
      this._id = id;
      this._clearFn = clearFn;
    }

    Timeout.prototype.unref = Timeout.prototype.ref = function () {};

    Timeout.prototype.close = function () {
      this._clearFn.call(window, this._id);
    }; // Does not start the time, just sets up the members needed.


    exports.enroll = function (item, msecs) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = msecs;
    };

    exports.unenroll = function (item) {
      clearTimeout(item._idleTimeoutId);
      item._idleTimeout = -1;
    };

    exports._unrefActive = exports.active = function (item) {
      clearTimeout(item._idleTimeoutId);
      var msecs = item._idleTimeout;

      if (msecs >= 0) {
        item._idleTimeoutId = setTimeout(function onTimeout() {
          if (item._onTimeout) item._onTimeout();
        }, msecs);
      }
    }; // That's not how node.js implements it but the exposed api is the same.


    exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function (fn) {
      var id = nextImmediateId++;
      var args = arguments.length < 2 ? false : slice.call(arguments, 1);
      immediateIds[id] = true;
      nextTick(function onNextTick() {
        if (immediateIds[id]) {
          // fn.call() is faster so we optimize for the common use-case
          // @see http://jsperf.com/call-apply-segu
          if (args) {
            fn.apply(null, args);
          } else {
            fn.call(null);
          } // Prevent ids from leaking


          exports.clearImmediate(id);
        }
      });
      return id;
    };
    exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function (id) {
      delete immediateIds[id];
    };
    /* WEBPACK VAR INJECTION */
  }).call(exports, __webpack_require__(14).setImmediate, __webpack_require__(14).clearImmediate);
  /***/
},
/* 15 */

/***/
function (module, exports) {
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }

  module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 16 */

/***/
function (module, exports) {
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 17 */

/***/
function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(10)["default"];

  var toPrimitive = __webpack_require__(33);

  function toPropertyKey(t) {
    var i = toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
  }

  module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 18 */

/***/
function (module, exports, __webpack_require__) {
  /*!
   * Define SDK v0.2.0-alpha.1
   * (c) 2016-2016 Shopper Concepts B.V.
   * Released under the MIT License
   */
  (function (global, factory) {
    true ? factory(exports, __webpack_require__(54), __webpack_require__(48)) : typeof define === 'function' && define.amd ? define(['exports', 'superagent', 'qs'], factory) : factory(global.defineSdk = global.defineSdk || {}, global.superAgent, global.qs);
  })(this, function (exports, superAgent, qs) {
    'use strict';

    superAgent = 'default' in superAgent ? superAgent['default'] : superAgent;
    qs = 'default' in qs ? qs['default'] : qs;

    var newObj = function newObj() {
      return {};
    };

    var set = function set(obj, path, value) {
      var parts = path.split('.');
      var last = parts.pop();
      var target = obj;

      while (parts.length) {
        var part = parts.shift();
        if (!target[part]) target[part] = newObj();
        target = target[part];
      }

      target[last] = value;
    };

    var has = function has(obj, path) {
      var parts = path.split('.');
      var last = parts.pop();
      var target = obj;

      while (parts.length) {
        var part = parts.shift();
        if (!target[part]) return false;
        target = target[part];
      }

      return target.hasOwnProperty(last);
    };

    var classCallCheck = function classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    };

    var createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var set$1 = function set$1(object, property, value, receiver) {
      var desc = Object.getOwnPropertyDescriptor(object, property);

      if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);

        if (parent !== null) {
          set$1(parent, property, value, receiver);
        }
      } else if ("value" in desc && desc.writable) {
        desc.value = value;
      } else {
        var setter = desc.set;

        if (setter !== undefined) {
          setter.call(receiver, value);
        }
      }

      return value;
    };

    var toConsumableArray = function toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      } else {
        return Array.from(arr);
      }
    };

    var WRITE_METHODS = ['PATCH', 'PUT', 'POST'];

    var Client = function () {
      function Client(opts) {
        var _this = this;

        classCallCheck(this, Client);
        var resources = opts.resources || {};
        this.config = {
          protocol: opts.protocol,
          domain: opts.domain
        };
        Object.keys(resources).forEach(function (name) {
          var resource = resources[name];
          name = name.replace(/-/g, '.');
          if (has(_this, name)) return;
          set(_this, name, new _this.Resource(_this, resource));
        });
      }

      createClass(Client, [{
        key: 'callRest',
        value: function callRest(method, resource, id, data, opts) {
          var _this2 = this;

          id = id || '';
          opts = opts || {};
          return new Promise(function (resolve, reject) {
            var _config = _this2.config;
            var config = _config === undefined ? {} : _config;
            var optsHeaders = opts.headers || {};
            var search = [resource, opts.prefix, id, opts.modifier].reduce(function (result, part) {
              return part ? result.concat(part) : result;
            }, []).join('/');
            var uri = config.protocol + '://' + config.domain + '/' + search;
            var uriLength = uri.length;
            if (uri[uriLength - 1] === '/') uri = uri.slice(0, uriLength - 1);
            var headers = {};
            if (opts.suffix) uri += opts.suffix;
            var isWrite = WRITE_METHODS.indexOf(method.toUpperCase()) > -1;

            if (!isWrite) {
              uri += '?' + qs.stringify(data);
            }

            var req = superAgent(method, uri);
            WRITE_METHODS.indexOf(method.toUpperCase()) > -1 && req.send(data);
            if (opts.auth) req.auth.apply(req, toConsumableArray(opts.auth));
            req.set(_extends({}, headers, optsHeaders));
            req.end(function (err, res) {
              if (err) reject(err);else if (!res.ok) reject(res.body || res.text);else resolve(res.body);
            });
          });
        }
      }, {
        key: 'Client',
        get: function get() {
          return Client;
        }
      }, {
        key: 'Resource',
        get: function get() {
          return Resource;
        }
      }]);
      return Client;
    }();

    var Resource = function () {
      function Resource(api) {
        var _this3 = this;

        var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
        classCallCheck(this, Resource);
        if (!(api && api.callRest && typeof api.callRest === 'function')) throw new TypeError('"api" param is mandatory and needs to have a callable "callRest" method.');
        this.api = api;
        this.resource = opts.resource;
        var _opts$resources = opts.resources;
        var resources = _opts$resources === undefined ? {} : _opts$resources;
        var _opts$actions = opts.actions;
        var actions = _opts$actions === undefined ? {} : _opts$actions;
        var _opts$pick = opts.pick;
        var pick = _opts$pick === undefined ? Object.keys(this.apiCalls) : _opts$pick;
        var _opts$omit = opts.omit;
        var omit = _opts$omit === undefined ? [] : _opts$omit;
        var proto = this;

        for (var i = 0, len = pick.length; i < len; i++) {
          var endpoint = pick[i];
          if (omit.indexOf(endpoint) > -1) continue;
          var endpointKeyPath = endpoint.replace('-', '.');
          if (this.apiCalls[endpoint]) set(proto, endpointKeyPath, this.apiCalls[endpoint]);
        }

        if (proto.read && proto.readOne) proto.read.one = proto.readOne;
        var Constructor = this.constructor;
        Object.keys(resources).forEach(function (name) {
          var resource = resources[name];
          name = name.replace(/-/g, '.');
          if (has(proto, name)) return;
          set(proto, name, new Constructor(_this3.api, _extends({}, resource, {
            resource: _this3.resource + '/' + (resource.name || name)
          })));
        });
        Object.keys(actions).forEach(function (name) {
          var _actions$name = actions[name];
          var _actions$name$method = _actions$name.method;
          var method = _actions$name$method === undefined ? 'GET' : _actions$name$method;
          var _actions$name$opts = _actions$name.opts;
          var actionOpts = _actions$name$opts === undefined ? {} : _actions$name$opts;
          var _actions$name$id = _actions$name.id;
          var hasId = _actions$name$id === undefined ? false : _actions$name$id;
          name = name.replace(/-/g, '.');
          if (has(proto, name)) return;
          set(proto, name, function () {
            var id = void 0,
                data = void 0,
                opts = void 0;

            if (hasId) {
              id = (arguments.length <= 0 ? undefined : arguments[0]) || null;
              data = (arguments.length <= 1 ? undefined : arguments[1]) || {};
              opts = (arguments.length <= 2 ? undefined : arguments[2]) || {};
              if (!id) throw new Error('id is missing');
            } else {
              data = (arguments.length <= 0 ? undefined : arguments[0]) || {};
              opts = (arguments.length <= 1 ? undefined : arguments[1]) || {};
            }

            return _this3.api.callRest(method, _this3.resource, id, data, _extends({}, opts, actionOpts, {
              headers: _extends({}, opts.headers || {}, actionOpts.headers || {})
            }));
          });
        });
      }

      createClass(Resource, [{
        key: 'apiCalls',
        get: function get() {
          return {
            create: function create() {
              var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
              var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              return this.api.callRest('POST', this.resource, undefined, data, opts);
            },
            read: function read(data) {
              var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              return this.api.callRest('GET', this.resource, undefined, data, opts);
            },
            readOne: function readOne(id) {
              var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              var opts = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
              return this.api.callRest('GET', this.resource, id, data, opts);
            },
            update: function update(id) {
              var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              var opts = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
              return this.api.callRest('PATCH', this.resource, id, data, opts);
            },
            delete: function _delete(id) {
              var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              return this.api.callRest('DELETE', this.resource, id, undefined, opts);
            },
            count: function count() {
              var data = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
              var opts = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
              return this.api.callRest('GET', this.resource + '/count', undefined, data, opts);
            }
          };
        }
      }]);
      return Resource;
    }();

    exports.Client = Client;
    exports.Resource = Resource;
    Object.defineProperty(exports, '__esModule', {
      value: true
    });
  });
  /***/

},
/* 19 */

/***/
function (module, exports, __webpack_require__) {
  var _interopRequireDefault = __webpack_require__(9);

  var _Promise2 = _interopRequireDefault(__webpack_require__(6))["default"];

  var _defineProperty = __webpack_require__(7);

  var _Promise = _interopRequireDefault(__webpack_require__(6))["default"];

  var _classCallCheck = __webpack_require__(1);

  var _createClass = __webpack_require__(2);

  var _possibleConstructorReturn = __webpack_require__(5);

  var _get = __webpack_require__(8);

  var _getPrototypeOf = __webpack_require__(3);

  var _inherits = __webpack_require__(4);

  function ownKeys(e, r) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }

    return t;
  }

  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }

    return e;
  }

  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }

  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}

    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
      return !!t;
    })();
  }

  var _require = __webpack_require__(18),
      Client = _require.Client;

  var EventEmitter = __webpack_require__(41);

  var Scheduler = __webpack_require__(35);

  var resources = __webpack_require__(37);

  var _require2 = __webpack_require__(11),
      sleep = _require2.sleep;

  var ClientMaster = /*#__PURE__*/function (_Client) {
    "use strict";

    _inherits(ClientMaster, _Client);

    function ClientMaster(token, client) {
      var _this;

      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      _classCallCheck(this, ClientMaster);

      var domain = opts.staging ? 'api-test.buzzoek.rest/v2' : opts.local ? 'localhost:3050/v2' : 'api.buzzoek.rest/v2'; // resource definition

      _this = _callSuper(this, ClientMaster, [{
        protocol: opts.local ? 'http' : 'https',
        domain: domain,
        resources: resources
      }]);
      _this.timeGap = opts.timeGap || 0;
      _this.version = '0.1.4';
      _this.config.version = 'v2';

      _this.setToken(token);

      _this.setClient(client);

      _this.scheduler = new Scheduler();
      _this.emitter = new EventEmitter();
      return _this;
    }

    _createClass(ClientMaster, [{
      key: "emit",
      value: function emit() {
        var _this$emitter;

        return (_this$emitter = this.emitter).emit.apply(_this$emitter, arguments);
      }
    }, {
      key: "on",
      value: function on() {
        var _this$emitter2;

        return (_this$emitter2 = this.emitter).on.apply(_this$emitter2, arguments);
      }
    }, {
      key: "once",
      value: function once() {
        var _this$emitter3;

        return (_this$emitter3 = this.emitter).once.apply(_this$emitter3, arguments);
      }
    }, {
      key: "off",
      value: function off() {
        var _this$emitter4;

        return (_this$emitter4 = this.emitter).off.apply(_this$emitter4, arguments);
      }
    }, {
      key: "safeSleep",
      get: function get() {
        return sleep(this.timeGap);
      }
    }, {
      key: "_callRest",
      value: function _callRest() {
        var _get2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_get2 = _get(_getPrototypeOf(ClientMaster.prototype), "callRest", this)).call.apply(_get2, [this].concat(args));
      }
    }, {
      key: "callRest",
      value: function callRest(method, resource, id) {
        var _this2 = this;

        var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
        return new _Promise(function (resolve, reject) {
          var fun = _this2.wrapper(function (method, resource, id) {
            var data = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
            var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
            var context = _this2.parent ? _this2.parent : _this2;
            opts.headers = _objectSpread(_objectSpread({
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            }, opts.headers || {}), {}, {
              'Authorization': "Bearer ".concat(context.config.key)
            });

            if (method.toLowerCase() === 'patch') {
              opts.headers['HTTP-Method-Override'] = method;
              method = 'POST';
            }

            return _this2._callRest(method, resource, id, data, opts);
          });

          var args = [method, resource, id, data, opts];

          var wrappedResolve = function wrappedResolve(result) {
            return _this2.safeSleep().then(function () {
              return resolve(result);
            });
          };

          var wrappedReject = function wrappedReject(err) {
            if (err.response) {
              var status = err.response.statusCode;
              err = err.response.body;
              err.status = status;
            }

            return reject(err);
          };

          _this2.scheduler.add(fun, args, wrappedResolve, wrappedReject);
        });
      }
    }, {
      key: "wrapper",
      value: function wrapper(fun) {
        var _this3 = this;

        var context = this.parent ? this.parent : this;
        return function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return new _Promise2(function (resolve, reject) {
            fun.apply(void 0, args).then(resolve, function (firstError) {
              var error = firstError.error;

              if (!error) {
                var _firstError$body = firstError.body,
                    body = _firstError$body === void 0 ? {} : _firstError$body,
                    _firstError$response = firstError.response,
                    response = _firstError$response === void 0 ? {} : _firstError$response;
                error = body.error || (response.body || {}).error;
              }

              switch (true) {
                case error === 'invalid_token':
                  context.emit("invalid_token", error);

                  if (context.config.refresh) {
                    return _this3.refresh().then(function () {
                      return fun.apply(void 0, args);
                    }).then(resolve, reject);
                  }

                default:
                  return reject(firstError);
              }
            });
          });
        };
      }
    }, {
      key: "register",
      value: function register(username, password) {
        var _this4 = this;

        var context = this.parent ? this.parent : this;
        return this.oauth.token.create({
          username: username,
          password: password,
          client_id: context.config.client_id,
          client_secret: context.config.client_secret,
          grant_type: 'password'
        }).then(function (result) {
          _this4.setToken(result);

          context.emit('registered', result);
          return _this4.me.read().then(function (user) {
            context.emit('identify', result, user);
            return user;
          });
        });
      }
    }, {
      key: "reset",
      value: function reset() {
        var _this5 = this;

        var context = this.parent ? this.parent : this;
        return this.oauth.token["delete"]().then(function () {
          _this5.setToken();

          context.emit('reset');

          _this5.scheduler.reset();

          return;
        });
      }
    }, {
      key: "authorize",
      value: function authorize() {
        var context = this.parent ? this.parent : this;
        return this.oauth.authorize({
          refresh_token: context.config.refresh,
          client_id: context.config.client_id,
          client_secret: context.config.client_secret,
          grant_type: 'authorization_code'
        });
      }
    }, {
      key: "refresh",
      value: function refresh() {
        var _this6 = this;

        var context = this.parent ? this.parent : this;
        return _get(_getPrototypeOf(ClientMaster.prototype), "callRest", this).call(this, 'POST', 'oauth/refresh', undefined, {
          refresh_token: context.config.refresh,
          client_id: context.config.client_id,
          client_secret: context.config.client_secret,
          grant_type: 'refresh_token'
        }, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': "Bearer ".concat(context.config.key)
          }
        }).then(function (result) {
          _this6.setToken(result);

          context.emit('refreshed', result);
        })["catch"](function (error) {
          context.emit('refresh_error', error);
        });
      }
    }, {
      key: "setToken",
      value: function setToken() {
        var token = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.config.key = token.access_token;
        this.config.refresh = token.refresh_token;
      }
    }, {
      key: "setClient",
      value: function setClient() {
        var client = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.config.client_id = client.client_id;
        this.config.client_secret = client.client_secret;
      }
    }, {
      key: "Client",
      get: function get() {
        return ClientMaster;
      }
    }]);

    return ClientMaster;
  }(Client);

  module.exports = ClientMaster;
  /***/
},
/* 20 */

/***/
function (module, exports, __webpack_require__) {
  var _defineProperty = __webpack_require__(7);

  var _classCallCheck = __webpack_require__(1);

  var _createClass = __webpack_require__(2);

  var _possibleConstructorReturn = __webpack_require__(5);

  var _get = __webpack_require__(8);

  var _getPrototypeOf = __webpack_require__(3);

  var _inherits = __webpack_require__(4);

  function ownKeys(e, r) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }

    return t;
  }

  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }

    return e;
  }

  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }

  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}

    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
      return !!t;
    })();
  }

  var _require = __webpack_require__(18),
      SuperResource = _require.Resource;

  module.exports = /*#__PURE__*/function (_SuperResource) {
    "use strict";

    _inherits(Resource, _SuperResource);

    function Resource() {
      var _this;

      _classCallCheck(this, Resource);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _callSuper(this, Resource, [].concat(args));
      if (_this.read && _this.count) _this.paginate = function () {
        var currentPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var pages = opts.pages,
            _opts$content = opts.content,
            content = _opts$content === void 0 ? [] : _opts$content;
        if (typeof pages === 'undefined') return _this.count().then(function (count) {
          opts.pages = Math.ceil(count / 250) || 1;
          return _this.paginate(currentPage, opts);
        });
        return _this.read({
          limit: 250,
          skip: currentPage * 250
        }).then(function (result) {
          content = content.concat(result);
          return currentPage === pages - 1 ? content : _this.paginate(currentPage + 1, {
            pages: pages,
            content: content
          });
        });
      };
      return _this;
    }

    _createClass(Resource, [{
      key: "apiCalls",
      get: function get() {
        var ctx = this;
        return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(Resource.prototype), "apiCalls", this)), {}, {
          'search': function search() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return ctx.api.callRest('GET', ctx.resource, undefined, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'search'
            }));
          },
          'read-simple': function readSimple() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return ctx.api.callRest('GET', ctx.resource, undefined, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'simple'
            }));
          },
          'read-detailed': function readDetailed() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return ctx.api.callRest('GET', ctx.resource, undefined, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'detailed'
            }));
          },
          'read-options': function readOptions() {
            var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return ctx.api.callRest('GET', ctx.resource, undefined, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'options'
            }));
          },
          'readOne-simple': function readOneSimple(id) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return ctx.api.callRest('GET', ctx.resource, id, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'simple'
            }));
          },
          'readOne-detailed': function readOneDetailed(id) {
            var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return ctx.api.callRest('GET', ctx.resource, id, data, _objectSpread(_objectSpread({}, opts), {}, {
              modifier: 'detailed'
            }));
          }
        });
      }
    }]);

    return Resource;
  }(SuperResource);
  /***/

},
/* 21 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var GetIntrinsic = __webpack_require__(0);

  var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);

  if ($gOPD) {
    try {
      $gOPD([], 'length');
    } catch (e) {
      // IE 8 has a broken gOPD
      $gOPD = null;
    }
  }

  module.exports = $gOPD;
  /***/
},
/* 22 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var GetIntrinsic = __webpack_require__(0);

  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);

  var hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($defineProperty) {
      try {
        $defineProperty({}, 'a', {
          value: 1
        });
        return true;
      } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
      }
    }

    return false;
  };

  hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!hasPropertyDescriptors()) {
      return null;
    }

    try {
      return $defineProperty([], 'length', {
        value: 1
      }).length !== 1;
    } catch (e) {
      // In Firefox 4-22, defining length on an array throws an exception.
      return true;
    }
  };

  module.exports = hasPropertyDescriptors;
  /***/
},
/* 23 */

/***/
function (module, exports) {
  // shim for using process in browser
  var process = module.exports = {}; // cached from whatever global is present so that test runners that stub it
  // don't break things.  But we need to wrap it in a try catch in case it is
  // wrapped in strict mode code which doesn't define any globals.  It's inside a
  // function because try/catches deoptimize in certain engines.

  var cachedSetTimeout;
  var cachedClearTimeout;

  function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
  }

  function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
  }

  (function () {
    try {
      if (typeof setTimeout === 'function') {
        cachedSetTimeout = setTimeout;
      } else {
        cachedSetTimeout = defaultSetTimout;
      }
    } catch (e) {
      cachedSetTimeout = defaultSetTimout;
    }

    try {
      if (typeof clearTimeout === 'function') {
        cachedClearTimeout = clearTimeout;
      } else {
        cachedClearTimeout = defaultClearTimeout;
      }
    } catch (e) {
      cachedClearTimeout = defaultClearTimeout;
    }
  })();

  function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
      //normal enviroments in sane situations
      return setTimeout(fun, 0);
    } // if setTimeout wasn't available but was latter defined


    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
      cachedSetTimeout = setTimeout;
      return setTimeout(fun, 0);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedSetTimeout(fun, 0);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
        return cachedSetTimeout.call(null, fun, 0);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
        return cachedSetTimeout.call(this, fun, 0);
      }
    }
  }

  function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
      //normal enviroments in sane situations
      return clearTimeout(marker);
    } // if clearTimeout wasn't available but was latter defined


    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
      cachedClearTimeout = clearTimeout;
      return clearTimeout(marker);
    }

    try {
      // when when somebody has screwed with setTimeout but no I.E. maddness
      return cachedClearTimeout(marker);
    } catch (e) {
      try {
        // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
        return cachedClearTimeout.call(null, marker);
      } catch (e) {
        // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
        // Some versions of I.E. have different rules for clearTimeout vs setTimeout
        return cachedClearTimeout.call(this, marker);
      }
    }
  }

  var queue = [];
  var draining = false;
  var currentQueue;
  var queueIndex = -1;

  function cleanUpNextTick() {
    if (!draining || !currentQueue) {
      return;
    }

    draining = false;

    if (currentQueue.length) {
      queue = currentQueue.concat(queue);
    } else {
      queueIndex = -1;
    }

    if (queue.length) {
      drainQueue();
    }
  }

  function drainQueue() {
    if (draining) {
      return;
    }

    var timeout = runTimeout(cleanUpNextTick);
    draining = true;
    var len = queue.length;

    while (len) {
      currentQueue = queue;
      queue = [];

      while (++queueIndex < len) {
        if (currentQueue) {
          currentQueue[queueIndex].run();
        }
      }

      queueIndex = -1;
      len = queue.length;
    }

    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
  }

  process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);

    if (arguments.length > 1) {
      for (var i = 1; i < arguments.length; i++) {
        args[i - 1] = arguments[i];
      }
    }

    queue.push(new Item(fun, args));

    if (queue.length === 1 && !draining) {
      runTimeout(drainQueue);
    }
  }; // v8 likes predictible objects


  function Item(fun, array) {
    this.fun = fun;
    this.array = array;
  }

  Item.prototype.run = function () {
    this.fun.apply(null, this.array);
  };

  process.title = 'browser';
  process.browser = true;
  process.env = {};
  process.argv = [];
  process.version = ''; // empty string to avoid regexp issues

  process.versions = {};

  function noop() {}

  process.on = noop;
  process.addListener = noop;
  process.once = noop;
  process.off = noop;
  process.removeListener = noop;
  process.removeAllListeners = noop;
  process.emit = noop;
  process.prependListener = noop;
  process.prependOnceListener = noop;

  process.listeners = function (name) {
    return [];
  };

  process.binding = function (name) {
    throw new Error('process.binding is not supported');
  };

  process.cwd = function () {
    return '/';
  };

  process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
  };

  process.umask = function () {
    return 0;
  };
  /***/

},
/* 24 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var formats = __webpack_require__(13);

  var has = Object.prototype.hasOwnProperty;
  var isArray = Array.isArray;

  var hexTable = function () {
    var array = [];

    for (var i = 0; i < 256; ++i) {
      array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
  }();

  var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
      var item = queue.pop();
      var obj = item.obj[item.prop];

      if (isArray(obj)) {
        var compacted = [];

        for (var j = 0; j < obj.length; ++j) {
          if (typeof obj[j] !== 'undefined') {
            compacted.push(obj[j]);
          }
        }

        item.obj[item.prop] = compacted;
      }
    }
  };

  var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};

    for (var i = 0; i < source.length; ++i) {
      if (typeof source[i] !== 'undefined') {
        obj[i] = source[i];
      }
    }

    return obj;
  };

  var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
      return target;
    }

    if (typeof source !== 'object') {
      if (isArray(target)) {
        target.push(source);
      } else if (target && typeof target === 'object') {
        if (options && (options.plainObjects || options.allowPrototypes) || !has.call(Object.prototype, source)) {
          target[source] = true;
        }
      } else {
        return [target, source];
      }

      return target;
    }

    if (!target || typeof target !== 'object') {
      return [target].concat(source);
    }

    var mergeTarget = target;

    if (isArray(target) && !isArray(source)) {
      mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
      source.forEach(function (item, i) {
        if (has.call(target, i)) {
          var targetItem = target[i];

          if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
            target[i] = merge(targetItem, item, options);
          } else {
            target.push(item);
          }
        } else {
          target[i] = item;
        }
      });
      return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
      var value = source[key];

      if (has.call(acc, key)) {
        acc[key] = merge(acc[key], value, options);
      } else {
        acc[key] = value;
      }

      return acc;
    }, mergeTarget);
  };

  var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
      acc[key] = source[key];
      return acc;
    }, target);
  };

  var decode = function decode(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');

    if (charset === 'iso-8859-1') {
      // unescape never throws, no try...catch needed:
      return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    } // utf-8


    try {
      return decodeURIComponent(strWithoutPlus);
    } catch (e) {
      return strWithoutPlus;
    }
  };

  var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
      return str;
    }

    var string = str;

    if (typeof str === 'symbol') {
      string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
      string = String(str);
    }

    if (charset === 'iso-8859-1') {
      return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
      });
    }

    var out = '';

    for (var i = 0; i < string.length; ++i) {
      var c = string.charCodeAt(i);

      if (c === 0x2D // -
      || c === 0x2E // .
      || c === 0x5F // _
      || c === 0x7E // ~
      || c >= 0x30 && c <= 0x39 // 0-9
      || c >= 0x41 && c <= 0x5A // a-z
      || c >= 0x61 && c <= 0x7A // A-Z
      || format === formats.RFC1738 && (c === 0x28 || c === 0x29) // ( )
      ) {
          out += string.charAt(i);
          continue;
        }

      if (c < 0x80) {
        out = out + hexTable[c];
        continue;
      }

      if (c < 0x800) {
        out = out + (hexTable[0xC0 | c >> 6] + hexTable[0x80 | c & 0x3F]);
        continue;
      }

      if (c < 0xD800 || c >= 0xE000) {
        out = out + (hexTable[0xE0 | c >> 12] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F]);
        continue;
      }

      i += 1;
      c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
      /* eslint operator-linebreak: [2, "before"] */

      out += hexTable[0xF0 | c >> 18] + hexTable[0x80 | c >> 12 & 0x3F] + hexTable[0x80 | c >> 6 & 0x3F] + hexTable[0x80 | c & 0x3F];
    }

    return out;
  };

  var compact = function compact(value) {
    var queue = [{
      obj: {
        o: value
      },
      prop: 'o'
    }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
      var item = queue[i];
      var obj = item.obj[item.prop];
      var keys = Object.keys(obj);

      for (var j = 0; j < keys.length; ++j) {
        var key = keys[j];
        var val = obj[key];

        if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
          queue.push({
            obj: obj,
            prop: key
          });
          refs.push(val);
        }
      }
    }

    compactQueue(queue);
    return value;
  };

  var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
  };

  var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
      return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
  };

  var combine = function combine(a, b) {
    return [].concat(a, b);
  };

  var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
      var mapped = [];

      for (var i = 0; i < val.length; i += 1) {
        mapped.push(fn(val[i]));
      }

      return mapped;
    }

    return fn(val);
  };

  module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
  };
  /***/
},
/* 25 */

/***/
function (module, exports) {
  var g; // This works in non-strict mode

  g = function () {
    return this;
  }();

  try {
    // This works if eval is allowed (see CSP)
    g = g || Function("return this")() || (1, eval)("this");
  } catch (e) {
    // This works if the window reference is available
    if (typeof window === "object") g = window;
  } // g can still be undefined, but nothing to do about it...
  // We return undefined, instead of nothing here, so it's
  // easier to handle this case. if(!global) { ...}


  module.exports = g;
  /***/
},
/* 26 */

/***/
function (module, exports, __webpack_require__) {
  var _classCallCheck = __webpack_require__(1);

  var _createClass = __webpack_require__(2);

  var _possibleConstructorReturn = __webpack_require__(5);

  var _getPrototypeOf = __webpack_require__(3);

  var _assertThisInitialized = __webpack_require__(16);

  var _inherits = __webpack_require__(4);

  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }

  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}

    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
      return !!t;
    })();
  }

  var ClientMaster = __webpack_require__(19);

  var Resource = __webpack_require__(20);

  var Ws = __webpack_require__(36);

  var _require = __webpack_require__(11),
      socket = _require.socket;

  var Api = /*#__PURE__*/function (_ClientMaster) {
    "use strict";

    _inherits(Api, _ClientMaster);

    function Api() {
      var _this;

      _classCallCheck(this, Api);

      var _ref = arguments.length <= 0 ? undefined : arguments[0],
          token = _ref.token,
          client = _ref.client,
          opts = _ref.opts; // resource definition


      _this = _callSuper(this, Api, [token || {}, client || {}, opts || {}]);

      if (opts.enableSocket && socket) {
        _this.ws = new Ws(_assertThisInitialized(_this), token || {}, client || {}, opts || {});
      }

      return _this;
    }

    _createClass(Api, [{
      key: "caller",
      get: function get() {
        if (this.ws && this.ws.socket && this.ws.socket.connected && !this.ws.socket.disconnected) {
          return this.ws;
        } else {
          return this;
        }
      }
    }, {
      key: "Client",
      get: function get() {
        return Api;
      }
    }, {
      key: "Resource",
      get: function get() {
        return Resource;
      }
    }]);

    return Api;
  }(ClientMaster);

  module.exports = Api;
  /***/
},
/* 27 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(15);

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return arrayLikeToArray(arr);
  }

  module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 28 */

/***/
function (module, exports) {
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 29 */

/***/
function (module, exports) {
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 30 */

/***/
function (module, exports) {
  function _setPrototypeOf(o, p) {
    module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return _setPrototypeOf(o, p);
  }

  module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 31 */

/***/
function (module, exports, __webpack_require__) {
  var getPrototypeOf = __webpack_require__(3);

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  module.exports = _superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 32 */

/***/
function (module, exports, __webpack_require__) {
  var arrayWithoutHoles = __webpack_require__(27);

  var iterableToArray = __webpack_require__(28);

  var unsupportedIterableToArray = __webpack_require__(34);

  var nonIterableSpread = __webpack_require__(29);

  function _toConsumableArray(arr) {
    return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
  }

  module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 33 */

/***/
function (module, exports, __webpack_require__) {
  var _typeof = __webpack_require__(10)["default"];

  function toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];

    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != _typeof(i)) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }

    return ("string" === r ? String : Number)(t);
  }

  module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 34 */

/***/
function (module, exports, __webpack_require__) {
  var arrayLikeToArray = __webpack_require__(15);

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
  }

  module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;
  /***/
},
/* 35 */

/***/
function (module, exports, __webpack_require__) {
  var _classCallCheck = __webpack_require__(1);

  var _createClass = __webpack_require__(2);

  var _toConsumableArray = __webpack_require__(32);

  var run = function run(ctx) {
    if (!ctx.list.length) {
      ctx.isRunning = false;
      return;
    }

    ctx.isRunning = true;

    var _ctx$list$shift = ctx.list.shift(),
        member = _ctx$list$shift.member,
        args = _ctx$list$shift.args,
        resolve = _ctx$list$shift.resolve,
        reject = _ctx$list$shift.reject;

    return member.apply(void 0, _toConsumableArray(args)).then(resolve, reject).then(function () {
      return run(ctx);
    });
  };

  module.exports = /*#__PURE__*/function () {
    "use strict";

    function Scheduler() {
      _classCallCheck(this, Scheduler);

      this.isRunning = false;
      this.list = [];
    }

    _createClass(Scheduler, [{
      key: "add",
      value: function add(member, args, resolve, reject) {
        this.list.push({
          args: args,
          member: member,
          resolve: resolve,
          reject: reject
        });

        if (!this.isRunning) {
          run(this);
        }
      }
    }, {
      key: "reset",
      value: function reset() {
        this.list = [];

        if (this.isRunning) {
          this.isRunning = false;
        }
      }
    }]);

    return Scheduler;
  }();
  /***/

},
/* 36 */

/***/
function (module, exports, __webpack_require__) {
  var _interopRequireDefault = __webpack_require__(9);

  var _defineProperty = __webpack_require__(7);

  var _Promise = _interopRequireDefault(__webpack_require__(6))["default"];

  var _classCallCheck = __webpack_require__(1);

  var _createClass = __webpack_require__(2);

  var _possibleConstructorReturn = __webpack_require__(5);

  var _get = __webpack_require__(8);

  var _getPrototypeOf = __webpack_require__(3);

  var _inherits = __webpack_require__(4);

  function ownKeys(e, r) {
    var t = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }

    return t;
  }

  function _objectSpread(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }

    return e;
  }

  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }

  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}

    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
      return !!t;
    })();
  } // const Q = require('q')


  var ClientMaster = __webpack_require__(19);

  var Resource = __webpack_require__(20);

  var WRITE_METHODS = ['PATCH', 'PUT', 'POST'];

  var _require = __webpack_require__(11),
      socket = _require.socket;

  var Ws = /*#__PURE__*/function (_ClientMaster) {
    "use strict";

    _inherits(Ws, _ClientMaster);

    function Ws(ctx, token, client) {
      var _this;

      var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      _classCallCheck(this, Ws); // resource definition


      _this = _callSuper(this, Ws, [token, client, opts]);
      _this.parent = ctx;
      _this.scheduler = _this.parent.scheduler;

      if (!socket) {
        return _possibleConstructorReturn(_this);
      }

      var parentConfig = _this.parent.config;
      _this.socket = socket.connect("".concat(parentConfig.protocol, "://").concat(parentConfig.domain.split('/').shift()), {
        transports: ['websocket']
      });

      _this.emitterOn('registered', function (token) {
        _this.setToken(token);
      });

      _this.emitterOn('identify', function (user) {
        _this.identify(user._id);
      });

      _this.emitterOn('refreshed', function (result) {
        _this.setToken(result);
      });

      _this.emitterOn('reset', function () {
        _this.setToken();

        _this.scheduler.reset();
      });

      return _this;
    }

    _createClass(Ws, [{
      key: "emitterOn",
      value: function emitterOn() {
        var _this$parent, _get2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_this$parent = this.parent).on.apply(_this$parent, args);

        return (_get2 = _get(_getPrototypeOf(Ws.prototype), "on", this)).call.apply(_get2, [this].concat(args));
      }
    }, {
      key: "emitterOnce",
      value: function emitterOnce() {
        var _this$parent2, _get3;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        (_this$parent2 = this.parent).once.apply(_this$parent2, args);

        return (_get3 = _get(_getPrototypeOf(Ws.prototype), "once", this)).call.apply(_get3, [this].concat(args));
      }
    }, {
      key: "emitterOff",
      value: function emitterOff() {
        var _this$parent3, _get4;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        (_this$parent3 = this.parent).off.apply(_this$parent3, args);

        return (_get4 = _get(_getPrototypeOf(Ws.prototype), "off", this)).call.apply(_get4, [this].concat(args));
      }
    }, {
      key: "emit",
      value: function emit() {
        var _this$socket;

        return (_this$socket = this.socket).emit.apply(_this$socket, arguments);
      }
    }, {
      key: "on",
      value: function on() {
        var _this$socket2;

        return (_this$socket2 = this.socket).on.apply(_this$socket2, arguments);
      }
    }, {
      key: "once",
      value: function once() {
        var _this$socket3;

        return (_this$socket3 = this.socket).once.apply(_this$socket3, arguments);
      }
    }, {
      key: "off",
      value: function off() {
        var _this$socket4;

        return (_this$socket4 = this.socket).off.apply(_this$socket4, arguments);
      }
    }, {
      key: "_callRest",
      value: function _callRest(method, resource, id, data, opts) {
        var _this2 = this;

        return new _Promise(function (resolve, reject) {
          var optsHeaders = opts.headers || {};
          var search = [resource, opts.prefix, id, opts.modifier].reduce(function (result, part) {
            return part ? result.concat(part) : result;
          }, []).join('/');
          var path = "/".concat(search);
          var uriLength = path.length;
          if (path[uriLength - 1] === '/') path = path.slice(0, uriLength - 1);
          var headers = {};
          if (opts.suffix) path += opts.suffix;
          var isWrite = WRITE_METHODS.indexOf(method.toUpperCase()) > -1;
          method = method.toLowerCase();

          _this2.emit('api', {
            path: path,
            method: method,
            headers: _objectSpread(_objectSpread({}, headers), optsHeaders),
            query: !isWrite ? data : undefined,
            body: isWrite ? data : undefined
          }, function (raw) {
            if (!raw.success) {
              return reject(raw.response);
            } else {
              return resolve(raw.response);
            }
          });
        });
      }
    }, {
      key: "identify",
      value: function identify() {
        var _console;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        (_console = console).log.apply(_console, ['identify'].concat(args));
      }
    }, {
      key: "setToken",
      value: function setToken(token) {
        _get(_getPrototypeOf(Ws.prototype), "setToken", this).call(this, token);

        if (this.parent) {
          this.parent.setToken(token);
        }
      }
    }, {
      key: "setClient",
      value: function setClient(client) {
        _get(_getPrototypeOf(Ws.prototype), "setClient", this).call(this, client);

        if (this.parent) {
          this.parent.setClient(client);
        }
      }
    }, {
      key: "Client",
      get: function get() {
        return Ws;
      }
    }, {
      key: "Resource",
      get: function get() {
        return Resource;
      }
    }]);

    return Ws;
  }(ClientMaster);

  module.exports = Ws;
  /***/
},
/* 37 */

/***/
function (module, exports) {
  exports.applications = {
    resource: 'applications',
    pick: ['read', 'readOne', 'count']
  };
  exports.a = {
    resource: 'a',
    pick: ['create'],
    actions: {
      alias: {
        method: 'POST',
        opts: {
          modifier: 'a'
        }
      },
      ev: {
        method: 'POST',
        opts: {
          modifier: 'ev'
        }
      },
      bulk: {
        method: 'POST',
        opts: {
          modifier: 'ev/bulk'
        }
      }
    }
  };
  exports.carts = {
    resource: 'carts',
    omit: ['read-simple', 'read-detailed', 'readOne-simple', 'readOne-detailed'],
    actions: {
      close: {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'close'
        }
      },
      addProducts: {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'products'
        }
      },
      removeProducts: {
        id: true,
        method: 'DELETE',
        opts: {
          modifier: 'products'
        }
      },
      updateProduct: {
        id: true,
        method: 'PATCH',
        opts: {
          modifier: 'products/:productId'
        }
      },
      'readOne-addCode': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'code'
        }
      },
      'readOne-removeCode': {
        id: true,
        method: 'DELETE',
        opts: {
          modifier: 'code'
        }
      },
      'readOne-startPayment': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'startpayment'
        }
      }
    }
  };
  exports.customers = {
    resource: 'customers',
    pick: ['create', 'update']
  };
  exports.devices = {
    resource: 'devices',
    actions: {
      'readOne-notify': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'notify'
        }
      },
      'readOne-stamp': {
        id: true,
        method: 'GET',
        opts: {
          modifier: 'stamp'
        }
      }
    }
  };
  exports.e = {
    resource: 'e',
    pick: ['create']
  };
  exports.extensions = {
    resource: 'extensions',
    pick: ['read', 'read-simple', 'read-options', 'count', 'readOne']
  };
  exports.loyaltyCards = {
    resource: 'loyaltycards',
    pick: ['create', 'read', 'count', 'last', 'readOne', 'update']
  };
  exports.loyaltySchemes = {
    resource: 'loyaltyschemes'
  };
  exports.me = {
    resource: 'me',
    pick: ['read'],
    resources: {
      subscriptions: {
        resource: 'subscriptions',
        pick: ['read', 'readOne'],
        actions: {
          add: {
            id: true,
            method: 'POST',
            opts: {
              modifier: 'add'
            }
          },
          remove: {
            id: true,
            opts: {
              modifier: 'remove'
            }
          }
        }
      },
      extensions: {
        pick: ['read'],
        resource: 'extensions',
        actions: {
          has: {
            id: true,
            opts: {
              prefix: 'has'
            }
          }
        }
      },
      invoices: {
        resource: 'invoices',
        pick: ['read', 'readOne', 'count', 'delete'],
        actions: {
          awaiting: {
            opts: {
              prefix: 'awaiting'
            }
          },
          pay: {
            id: true,
            opts: {
              modifier: 'pay'
            }
          }
        }
      }
    },
    actions: {
      update: {
        method: 'PATCH'
      },
      notify: {
        method: 'POST',
        opts: {
          modifier: 'notify'
        }
      },
      'readOne-send': {
        method: 'POST',
        opts: {
          modifier: 'send'
        }
      },
      testReceipt: {
        method: 'POST',
        opts: {
          modifier: 'test-receipt'
        }
      },
      email: {
        method: 'PUT',
        opts: {
          prefix: 'email'
        }
      },
      'email-valiadte': {
        method: 'POST',
        opts: {
          prefix: 'email',
          modifier: 'validate'
        }
      },
      password: {
        method: 'PUT',
        opts: {
          prefix: 'password'
        }
      },
      send: {
        method: 'POST',
        opts: {
          prefix: 'send'
        }
      },
      integration: {
        method: 'PUT',
        opts: {
          prefix: 'integration'
        }
      }
    }
  };
  exports.merchants = {
    resource: 'merchants',
    pick: ['create']
  };
  exports.multi = {
    resource: 'multi',
    pick: ['read']
  };
  exports.oauth = {
    resource: 'oauth',
    pick: [],
    actions: {
      authorize: {
        method: 'POST',
        opts: {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          modifier: 'authorize'
        }
      }
    },
    resources: {
      token: {
        resource: 'token',
        pick: ['delete'],
        actions: {
          create: {
            method: 'POST',
            opts: {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          },
          refresh: {
            method: 'POST',
            opts: {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          },
          authorize: {
            method: 'POST',
            opts: {
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            }
          }
        }
      }
    }
  };
  exports.refunds = {
    resource: 'refunds',
    omit: ['delete'],
    actions: {
      search: {
        opts: {
          modifier: 'search'
        }
      },
      'readOne-send': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'send'
        }
      },
      'readOne-sync': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'sync'
        }
      }
    }
  };
  exports.stores = {
    resource: 'stores',
    omit: ['delete'],
    actions: {
      'readOne-addons': {
        id: true,
        opts: {
          modifier: 'addons'
        }
      },
      'readOne-addons-count': {
        id: true,
        opts: {
          modifier: 'addons/count'
        }
      },
      'readOne-addons-search': {
        id: true,
        opts: {
          modifier: 'addons/search'
        }
      },
      'readOne-addons-delta': {
        id: true,
        opts: {
          modifier: 'addons/delta'
        }
      },
      'readOne-addons-delta-count': {
        id: true,
        opts: {
          modifier: 'addons/delta/count'
        }
      },
      'readOne-categories': {
        id: true,
        opts: {
          modifier: 'categories'
        }
      },
      'readOne-categories-count': {
        id: true,
        opts: {
          modifier: 'categories/count'
        }
      },
      'readOne-categories-search': {
        id: true,
        opts: {
          modifier: 'categories/search'
        }
      },
      'readOne-categories-delta': {
        id: true,
        opts: {
          modifier: 'categories/delta'
        }
      },
      'readOne-categories-delta-count': {
        id: true,
        opts: {
          modifier: 'categories/delta/count'
        }
      },
      'readOne-products': {
        id: true,
        opts: {
          modifier: 'products'
        }
      },
      'readOne-products-count': {
        id: true,
        opts: {
          modifier: 'products/count'
        }
      },
      'readOne-products-search': {
        id: true,
        opts: {
          modifier: 'products/search'
        }
      },
      'readOne-products-delta': {
        id: true,
        opts: {
          modifier: 'products/delta'
        }
      },
      'readOne-products-delta-count': {
        id: true,
        opts: {
          modifier: 'products/delta/count'
        }
      },
      'readOne-products-checkStock': {
        id: true,
        opts: {
          modifier: 'products/:productId/stock/:variantId'
        }
      },
      'readOne-rules': {
        id: true,
        opts: {
          modifier: 'rules'
        }
      },
      'readOne-taxes': {
        id: true,
        opts: {
          modifier: 'taxes'
        }
      },
      'readOne-taxes-count': {
        id: true,
        opts: {
          modifier: 'taxes/count'
        }
      },
      'readOne-taxes-search': {
        id: true,
        opts: {
          modifier: 'taxes/search'
        }
      },
      'readOne-taxes-delta': {
        id: true,
        opts: {
          modifier: 'taxes/delta'
        }
      },
      'readOne-taxes-delta-count': {
        id: true,
        opts: {
          modifier: 'taxes/delta/count'
        }
      },
      'readOne-transactions-delta': {
        id: true,
        opts: {
          modifier: 'transactions/delta'
        }
      },
      'readOne-transactions-delta-count': {
        id: true,
        opts: {
          modifier: 'transactions/delta/count'
        }
      },
      'readOne-refunds-delta': {
        id: true,
        opts: {
          modifier: 'refunds/delta'
        }
      },
      'readOne-refunds-delta-count': {
        id: true,
        opts: {
          modifier: 'refunds/delta/count'
        }
      },
      'readOne-notify': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'notify'
        }
      }
    }
  };
  exports.transactions = {
    resource: 'transactions',
    omit: ['delete'],
    actions: {
      search: {
        opts: {
          modifier: 'search'
        }
      },
      'readOne-send': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'send'
        }
      },
      'readOne-sync': {
        id: true,
        method: 'POST',
        opts: {
          modifier: 'sync'
        }
      }
    }
  };
  exports.webhooks = {
    resource: 'webhooks',
    omit: ['read-simple', 'read-options', 'readOne-simple', 'search']
  };
  /***/
},
/* 38 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var GetIntrinsic = __webpack_require__(0);

  var callBind = __webpack_require__(39);

  var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));

  module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = GetIntrinsic(name, !!allowMissing);

    if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
      return callBind(intrinsic);
    }

    return intrinsic;
  };
  /***/

},
/* 39 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var bind = __webpack_require__(12);

  var GetIntrinsic = __webpack_require__(0);

  var setFunctionLength = __webpack_require__(51);

  var $TypeError = GetIntrinsic('%TypeError%');
  var $apply = GetIntrinsic('%Function.prototype.apply%');
  var $call = GetIntrinsic('%Function.prototype.call%');
  var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
  var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
  var $max = GetIntrinsic('%Math.max%');

  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', {
        value: 1
      });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = null;
    }
  }

  module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== 'function') {
      throw new $TypeError('a function is required');
    }

    var func = $reflectApply(bind, $call, arguments);
    return setFunctionLength(func, 1 + $max(0, originalFunction.length - (arguments.length - 1)), true);
  };

  var applyBind = function applyBind() {
    return $reflectApply(bind, $apply, arguments);
  };

  if ($defineProperty) {
    $defineProperty(module.exports, 'apply', {
      value: applyBind
    });
  } else {
    module.exports.apply = applyBind;
  }
  /***/

},
/* 40 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var hasPropertyDescriptors = __webpack_require__(22)();

  var GetIntrinsic = __webpack_require__(0);

  var $defineProperty = hasPropertyDescriptors && GetIntrinsic('%Object.defineProperty%', true);

  if ($defineProperty) {
    try {
      $defineProperty({}, 'a', {
        value: 1
      });
    } catch (e) {
      // IE 8 has a broken defineProperty
      $defineProperty = false;
    }
  }

  var $SyntaxError = GetIntrinsic('%SyntaxError%');
  var $TypeError = GetIntrinsic('%TypeError%');

  var gopd = __webpack_require__(21);
  /** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */


  module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') {
      throw new $TypeError('`obj` must be an object or a function`');
    }

    if (typeof property !== 'string' && typeof property !== 'symbol') {
      throw new $TypeError('`property` must be a string or a symbol`');
    }

    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
      throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
    }

    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
      throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
    }

    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
      throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
    }

    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
      throw new $TypeError('`loose`, if provided, must be a boolean');
    }

    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */

    var desc = !!gopd && gopd(obj, property);

    if ($defineProperty) {
      $defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
      });
    } else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) {
      // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
      obj[property] = value; // eslint-disable-line no-param-reassign
    } else {
      throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
    }
  };
  /***/

},
/* 41 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var has = Object.prototype.hasOwnProperty,
      prefix = '~';
  /**
   * Constructor to create a storage for our `EE` objects.
   * An `Events` instance is a plain object whose properties are event names.
   *
   * @constructor
   * @api private
   */

  function Events() {} //
  // We try to not inherit from `Object.prototype`. In some engines creating an
  // instance in this way is faster than calling `Object.create(null)` directly.
  // If `Object.create(null)` is not supported we prefix the event names with a
  // character to make sure that the built-in object properties are not
  // overridden or used as an attack vector.
  //


  if (Object.create) {
    Events.prototype = Object.create(null); //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //

    if (!new Events().__proto__) prefix = false;
  }
  /**
   * Representation of a single event listener.
   *
   * @param {Function} fn The listener function.
   * @param {Mixed} context The context to invoke the listener with.
   * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
   * @constructor
   * @api private
   */


  function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
  }
  /**
   * Minimal `EventEmitter` interface that is molded against the Node.js
   * `EventEmitter` interface.
   *
   * @constructor
   * @api public
   */


  function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
  }
  /**
   * Return an array listing the events for which the emitter has registered
   * listeners.
   *
   * @returns {Array}
   * @api public
   */


  EventEmitter.prototype.eventNames = function eventNames() {
    var names = [],
        events,
        name;
    if (this._eventsCount === 0) return names;

    for (name in events = this._events) {
      if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    }

    if (Object.getOwnPropertySymbols) {
      return names.concat(Object.getOwnPropertySymbols(events));
    }

    return names;
  };
  /**
   * Return the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Boolean} exists Only check if there are listeners.
   * @returns {Array|Boolean}
   * @api public
   */


  EventEmitter.prototype.listeners = function listeners(event, exists) {
    var evt = prefix ? prefix + event : event,
        available = this._events[evt];
    if (exists) return !!available;
    if (!available) return [];
    if (available.fn) return [available.fn];

    for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
      ee[i] = available[i].fn;
    }

    return ee;
  };
  /**
   * Calls each of the listeners registered for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @returns {Boolean} `true` if the event had listeners, else `false`.
   * @api public
   */


  EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt],
        len = arguments.length,
        args,
        i;

    if (listeners.fn) {
      if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

      switch (len) {
        case 1:
          return listeners.fn.call(listeners.context), true;

        case 2:
          return listeners.fn.call(listeners.context, a1), true;

        case 3:
          return listeners.fn.call(listeners.context, a1, a2), true;

        case 4:
          return listeners.fn.call(listeners.context, a1, a2, a3), true;

        case 5:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;

        case 6:
          return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
      }

      for (i = 1, args = new Array(len - 1); i < len; i++) {
        args[i - 1] = arguments[i];
      }

      listeners.fn.apply(listeners.context, args);
    } else {
      var length = listeners.length,
          j;

      for (i = 0; i < length; i++) {
        if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

        switch (len) {
          case 1:
            listeners[i].fn.call(listeners[i].context);
            break;

          case 2:
            listeners[i].fn.call(listeners[i].context, a1);
            break;

          case 3:
            listeners[i].fn.call(listeners[i].context, a1, a2);
            break;

          case 4:
            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
            break;

          default:
            if (!args) for (j = 1, args = new Array(len - 1); j < len; j++) {
              args[j - 1] = arguments[j];
            }
            listeners[i].fn.apply(listeners[i].context, args);
        }
      }
    }

    return true;
  };
  /**
   * Add a listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */


  EventEmitter.prototype.on = function on(event, fn, context) {
    var listener = new EE(fn, context || this),
        evt = prefix ? prefix + event : event;
    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
    return this;
  };
  /**
   * Add a one-time listener for a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn The listener function.
   * @param {Mixed} [context=this] The context to invoke the listener with.
   * @returns {EventEmitter} `this`.
   * @api public
   */


  EventEmitter.prototype.once = function once(event, fn, context) {
    var listener = new EE(fn, context || this, true),
        evt = prefix ? prefix + event : event;
    if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;else if (!this._events[evt].fn) this._events[evt].push(listener);else this._events[evt] = [this._events[evt], listener];
    return this;
  };
  /**
   * Remove the listeners of a given event.
   *
   * @param {String|Symbol} event The event name.
   * @param {Function} fn Only remove the listeners that match this function.
   * @param {Mixed} context Only remove the listeners that have this context.
   * @param {Boolean} once Only remove one-time listeners.
   * @returns {EventEmitter} `this`.
   * @api public
   */


  EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;

    if (!fn) {
      if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      return this;
    }

    var listeners = this._events[evt];

    if (listeners.fn) {
      if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) {
        if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      }
    } else {
      for (var i = 0, events = [], length = listeners.length; i < length; i++) {
        if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) {
          events.push(listeners[i]);
        }
      } //
      // Reset the array, or remove it completely if we have no more listeners.
      //


      if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;else if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
    }

    return this;
  };
  /**
   * Remove all listeners, or those of the specified event.
   *
   * @param {String|Symbol} [event] The event name.
   * @returns {EventEmitter} `this`.
   * @api public
   */


  EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;

    if (event) {
      evt = prefix ? prefix + event : event;

      if (this._events[evt]) {
        if (--this._eventsCount === 0) this._events = new Events();else delete this._events[evt];
      }
    } else {
      this._events = new Events();
      this._eventsCount = 0;
    }

    return this;
  }; //
  // Alias methods names because people roll like that.
  //


  EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
  EventEmitter.prototype.addListener = EventEmitter.prototype.on; //
  // This function doesn't apply anymore.
  //

  EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
    return this;
  }; //
  // Expose the prefix.
  //


  EventEmitter.prefixed = prefix; //
  // Allow `EventEmitter` to be imported as module namespace.
  //

  EventEmitter.EventEmitter = EventEmitter; //
  // Expose the module.
  //

  if (true) {
    module.exports = EventEmitter;
  }
  /***/

},
/* 42 */

/***/
function (module, exports) {
  "use strict";
  'use strict';
  /* eslint no-invalid-this: 1 */

  var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
  var toStr = Object.prototype.toString;
  var max = Math.max;
  var funcType = '[object Function]';

  var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
      arr[i] = a[i];
    }

    for (var j = 0; j < b.length; j += 1) {
      arr[j + a.length] = b[j];
    }

    return arr;
  };

  var slicy = function slicy(arrLike, offset) {
    var arr = [];

    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
      arr[j] = arrLike[i];
    }

    return arr;
  };

  var joiny = function joiny(arr, joiner) {
    var str = '';

    for (var i = 0; i < arr.length; i += 1) {
      str += arr[i];

      if (i + 1 < arr.length) {
        str += joiner;
      }
    }

    return str;
  };

  module.exports = function bind(that) {
    var target = this;

    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
      throw new TypeError(ERROR_MESSAGE + target);
    }

    var args = slicy(arguments, 1);
    var bound;

    var binder = function binder() {
      if (this instanceof bound) {
        var result = target.apply(this, concatty(args, arguments));

        if (Object(result) === result) {
          return result;
        }

        return this;
      }

      return target.apply(that, concatty(args, arguments));
    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];

    for (var i = 0; i < boundLength; i++) {
      boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
      var Empty = function Empty() {};

      Empty.prototype = target.prototype;
      bound.prototype = new Empty();
      Empty.prototype = null;
    }

    return bound;
  };
  /***/

},
/* 43 */

/***/
function (module, exports) {
  "use strict";
  'use strict';

  var test = {
    foo: {}
  };
  var $Object = Object;

  module.exports = function hasProto() {
    return {
      __proto__: test
    }.foo === test.foo && !({
      __proto__: null
    } instanceof $Object);
  };
  /***/

},
/* 44 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var origSymbol = typeof Symbol !== 'undefined' && Symbol;

  var hasSymbolSham = __webpack_require__(45);

  module.exports = function hasNativeSymbols() {
    if (typeof origSymbol !== 'function') {
      return false;
    }

    if (typeof Symbol !== 'function') {
      return false;
    }

    if (typeof origSymbol('foo') !== 'symbol') {
      return false;
    }

    if (typeof Symbol('bar') !== 'symbol') {
      return false;
    }

    return hasSymbolSham();
  };
  /***/

},
/* 45 */

/***/
function (module, exports) {
  "use strict";
  'use strict';
  /* eslint complexity: [2, 18], max-statements: [2, 33] */

  module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') {
      return false;
    }

    if (typeof Symbol.iterator === 'symbol') {
      return true;
    }

    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);

    if (typeof sym === 'string') {
      return false;
    }

    if (Object.prototype.toString.call(sym) !== '[object Symbol]') {
      return false;
    }

    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') {
      return false;
    } // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }


    var symVal = 42;
    obj[sym] = symVal;

    for (sym in obj) {
      return false;
    } // eslint-disable-line no-restricted-syntax, no-unreachable-loop


    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) {
      return false;
    }

    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) {
      return false;
    }

    var syms = Object.getOwnPropertySymbols(obj);

    if (syms.length !== 1 || syms[0] !== sym) {
      return false;
    }

    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) {
      return false;
    }

    if (typeof Object.getOwnPropertyDescriptor === 'function') {
      var descriptor = Object.getOwnPropertyDescriptor(obj, sym);

      if (descriptor.value !== symVal || descriptor.enumerable !== true) {
        return false;
      }
    }

    return true;
  };
  /***/

},
/* 46 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var call = Function.prototype.call;
  var $hasOwn = Object.prototype.hasOwnProperty;

  var bind = __webpack_require__(12);
  /** @type {(o: {}, p: PropertyKey) => p is keyof o} */


  module.exports = bind.call(call, $hasOwn);
  /***/
},
/* 47 */

/***/
function (module, exports, __webpack_require__) {
  /* WEBPACK VAR INJECTION */
  (function (global) {
    var hasMap = typeof Map === 'function' && Map.prototype;
    var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
    var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
    var mapForEach = hasMap && Map.prototype.forEach;
    var hasSet = typeof Set === 'function' && Set.prototype;
    var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
    var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
    var setForEach = hasSet && Set.prototype.forEach;
    var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
    var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
    var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
    var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
    var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
    var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
    var booleanValueOf = Boolean.prototype.valueOf;
    var objectToString = Object.prototype.toString;
    var functionToString = Function.prototype.toString;
    var $match = String.prototype.match;
    var $slice = String.prototype.slice;
    var $replace = String.prototype.replace;
    var $toUpperCase = String.prototype.toUpperCase;
    var $toLowerCase = String.prototype.toLowerCase;
    var $test = RegExp.prototype.test;
    var $concat = Array.prototype.concat;
    var $join = Array.prototype.join;
    var $arrSlice = Array.prototype.slice;
    var $floor = Math.floor;
    var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
    var gOPS = Object.getOwnPropertySymbols;
    var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
    var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object'; // ie, `has-tostringtag/shams

    var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
    var isEnumerable = Object.prototype.propertyIsEnumerable;
    var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
    ? function (O) {
      return O.__proto__; // eslint-disable-line no-proto
    } : null);

    function addNumericSeparator(num, str) {
      if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $test.call(/e/, str)) {
        return str;
      }

      var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;

      if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)

        if (int !== num) {
          var intStr = String(int);
          var dec = $slice.call(str, intStr.length + 1);
          return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
      }

      return $replace.call(str, sepRegex, '$&_');
    }

    var utilInspect = __webpack_require__(55);

    var inspectCustom = utilInspect.custom;
    var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

    module.exports = function inspect_(obj, options, depth, seen) {
      var opts = options || {};

      if (has(opts, 'quoteStyle') && opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double') {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
      }

      if (has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
      }

      var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;

      if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
      }

      if (has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
      }

      if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
      }

      var numericSeparator = opts.numericSeparator;

      if (typeof obj === 'undefined') {
        return 'undefined';
      }

      if (obj === null) {
        return 'null';
      }

      if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
      }

      if (typeof obj === 'string') {
        return inspectString(obj, opts);
      }

      if (typeof obj === 'number') {
        if (obj === 0) {
          return Infinity / obj > 0 ? '0' : '-0';
        }

        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
      }

      if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
      }

      var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;

      if (typeof depth === 'undefined') {
        depth = 0;
      }

      if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
      }

      var indent = getIndent(opts, depth);

      if (typeof seen === 'undefined') {
        seen = [];
      } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
      }

      function inspect(value, from, noIndent) {
        if (from) {
          seen = $arrSlice.call(seen);
          seen.push(from);
        }

        if (noIndent) {
          var newOpts = {
            depth: opts.depth
          };

          if (has(opts, 'quoteStyle')) {
            newOpts.quoteStyle = opts.quoteStyle;
          }

          return inspect_(value, newOpts, depth + 1, seen);
        }

        return inspect_(value, opts, depth + 1, seen);
      }

      if (typeof obj === 'function' && !isRegExp(obj)) {
        // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
      }

      if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
      }

      if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];

        for (var i = 0; i < attrs.length; i++) {
          s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }

        s += '>';

        if (obj.childNodes && obj.childNodes.length) {
          s += '...';
        }

        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
      }

      if (isArray(obj)) {
        if (obj.length === 0) {
          return '[]';
        }

        var xs = arrObjKeys(obj, inspect);

        if (indent && !singleLineValues(xs)) {
          return '[' + indentedJoin(xs, indent) + ']';
        }

        return '[ ' + $join.call(xs, ', ') + ' ]';
      }

      if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);

        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
          return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }

        if (parts.length === 0) {
          return '[' + String(obj) + ']';
        }

        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
      }

      if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
          return utilInspect(obj, {
            depth: maxDepth - depth
          });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
          return obj.inspect();
        }
      }

      if (isMap(obj)) {
        var mapParts = [];

        if (mapForEach) {
          mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
          });
        }

        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
      }

      if (isSet(obj)) {
        var setParts = [];

        if (setForEach) {
          setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
          });
        }

        return collectionOf('Set', setSize.call(obj), setParts, indent);
      }

      if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
      }

      if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
      }

      if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
      }

      if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
      }

      if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
      }

      if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
      }

      if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
      } // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other

      /* eslint-env browser */


      if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
      }

      if (obj === global) {
        return '{ [object globalThis] }';
      }

      if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');

        if (ys.length === 0) {
          return tag + '{}';
        }

        if (indent) {
          return tag + '{' + indentedJoin(ys, indent) + '}';
        }

        return tag + '{ ' + $join.call(ys, ', ') + ' }';
      }

      return String(obj);
    };

    function wrapQuotes(s, defaultStyle, opts) {
      var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
      return quoteChar + s + quoteChar;
    }

    function quote(s) {
      return $replace.call(String(s), /"/g, '&quot;');
    }

    function isArray(obj) {
      return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isDate(obj) {
      return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isRegExp(obj) {
      return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isError(obj) {
      return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isString(obj) {
      return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isNumber(obj) {
      return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    }

    function isBoolean(obj) {
      return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj));
    } // Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives


    function isSymbol(obj) {
      if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
      }

      if (typeof obj === 'symbol') {
        return true;
      }

      if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
      }

      try {
        symToString.call(obj);
        return true;
      } catch (e) {}

      return false;
    }

    function isBigInt(obj) {
      if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
      }

      try {
        bigIntValueOf.call(obj);
        return true;
      } catch (e) {}

      return false;
    }

    var hasOwn = Object.prototype.hasOwnProperty || function (key) {
      return key in this;
    };

    function has(obj, key) {
      return hasOwn.call(obj, key);
    }

    function toStr(obj) {
      return objectToString.call(obj);
    }

    function nameOf(f) {
      if (f.name) {
        return f.name;
      }

      var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);

      if (m) {
        return m[1];
      }

      return null;
    }

    function indexOf(xs, x) {
      if (xs.indexOf) {
        return xs.indexOf(x);
      }

      for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) {
          return i;
        }
      }

      return -1;
    }

    function isMap(x) {
      if (!mapSize || !x || typeof x !== 'object') {
        return false;
      }

      try {
        mapSize.call(x);

        try {
          setSize.call(x);
        } catch (s) {
          return true;
        }

        return x instanceof Map; // core-js workaround, pre-v2.5.0
      } catch (e) {}

      return false;
    }

    function isWeakMap(x) {
      if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
      }

      try {
        weakMapHas.call(x, weakMapHas);

        try {
          weakSetHas.call(x, weakSetHas);
        } catch (s) {
          return true;
        }

        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
      } catch (e) {}

      return false;
    }

    function isWeakRef(x) {
      if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
      }

      try {
        weakRefDeref.call(x);
        return true;
      } catch (e) {}

      return false;
    }

    function isSet(x) {
      if (!setSize || !x || typeof x !== 'object') {
        return false;
      }

      try {
        setSize.call(x);

        try {
          mapSize.call(x);
        } catch (m) {
          return true;
        }

        return x instanceof Set; // core-js workaround, pre-v2.5.0
      } catch (e) {}

      return false;
    }

    function isWeakSet(x) {
      if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
      }

      try {
        weakSetHas.call(x, weakSetHas);

        try {
          weakMapHas.call(x, weakMapHas);
        } catch (s) {
          return true;
        }

        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
      } catch (e) {}

      return false;
    }

    function isElement(x) {
      if (!x || typeof x !== 'object') {
        return false;
      }

      if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
      }

      return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
    }

    function inspectString(str, opts) {
      if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
      } // eslint-disable-next-line no-control-regex


      var s = $replace.call($replace.call(str, /(['\\])/g, '\\$1'), /[\x00-\x1f]/g, lowbyte);
      return wrapQuotes(s, 'single', opts);
    }

    function lowbyte(c) {
      var n = c.charCodeAt(0);
      var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
      }[n];

      if (x) {
        return '\\' + x;
      }

      return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
    }

    function markBoxed(str) {
      return 'Object(' + str + ')';
    }

    function weakCollectionOf(type) {
      return type + ' { ? }';
    }

    function collectionOf(type, size, entries, indent) {
      var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
      return type + ' (' + size + ') {' + joinedEntries + '}';
    }

    function singleLineValues(xs) {
      for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
          return false;
        }
      }

      return true;
    }

    function getIndent(opts, depth) {
      var baseIndent;

      if (opts.indent === '\t') {
        baseIndent = '\t';
      } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
      } else {
        return null;
      }

      return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
      };
    }

    function indentedJoin(xs, indent) {
      if (xs.length === 0) {
        return '';
      }

      var lineJoiner = '\n' + indent.prev + indent.base;
      return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
    }

    function arrObjKeys(obj, inspect) {
      var isArr = isArray(obj);
      var xs = [];

      if (isArr) {
        xs.length = obj.length;

        for (var i = 0; i < obj.length; i++) {
          xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
      }

      var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
      var symMap;

      if (hasShammedSymbols) {
        symMap = {};

        for (var k = 0; k < syms.length; k++) {
          symMap['$' + syms[k]] = syms[k];
        }
      }

      for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) {
          continue;
        } // eslint-disable-line no-restricted-syntax, no-continue


        if (isArr && String(Number(key)) === key && key < obj.length) {
          continue;
        } // eslint-disable-line no-restricted-syntax, no-continue


        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
          // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
          continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
          xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
          xs.push(key + ': ' + inspect(obj[key], obj));
        }
      }

      if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
          if (isEnumerable.call(obj, syms[j])) {
            xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
          }
        }
      }

      return xs;
    }
    /* WEBPACK VAR INJECTION */

  }).call(exports, __webpack_require__(25));
  /***/
},
/* 48 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var stringify = __webpack_require__(50);

  var parse = __webpack_require__(49);

  var formats = __webpack_require__(13);

  module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
  };
  /***/
},
/* 49 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var utils = __webpack_require__(24);

  var has = Object.prototype.hasOwnProperty;
  var isArray = Array.isArray;
  var defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
  };

  var interpretNumericEntities = function interpretNumericEntities(str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
      return String.fromCharCode(parseInt(numberStr, 10));
    });
  };

  var parseArrayValue = function parseArrayValue(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
      return val.split(',');
    }

    return val;
  }; // This is what browsers will submit when the ✓ character occurs in an
  // application/x-www-form-urlencoded body and the encoding of the page containing
  // the form is iso-8859-1, or when the submitted form has an accept-charset
  // attribute of iso-8859-1. Presumably also with other charsets that do not contain
  // the ✓ character, such as us-ascii.


  var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
  // These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.

  var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

  var parseValues = function parseQueryStringValues(str, options) {
    var obj = {
      __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found

    var i;
    var charset = options.charset;

    if (options.charsetSentinel) {
      for (i = 0; i < parts.length; ++i) {
        if (parts[i].indexOf('utf8=') === 0) {
          if (parts[i] === charsetSentinel) {
            charset = 'utf-8';
          } else if (parts[i] === isoSentinel) {
            charset = 'iso-8859-1';
          }

          skipIndex = i;
          i = parts.length; // The eslint settings do not allow break;
        }
      }
    }

    for (i = 0; i < parts.length; ++i) {
      if (i === skipIndex) {
        continue;
      }

      var part = parts[i];
      var bracketEqualsPos = part.indexOf(']=');
      var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
      var key, val;

      if (pos === -1) {
        key = options.decoder(part, defaults.decoder, charset, 'key');
        val = options.strictNullHandling ? null : '';
      } else {
        key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
        val = utils.maybeMap(parseArrayValue(part.slice(pos + 1), options), function (encodedVal) {
          return options.decoder(encodedVal, defaults.decoder, charset, 'value');
        });
      }

      if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
        val = interpretNumericEntities(val);
      }

      if (part.indexOf('[]=') > -1) {
        val = isArray(val) ? [val] : val;
      }

      if (has.call(obj, key)) {
        obj[key] = utils.combine(obj[key], val);
      } else {
        obj[key] = val;
      }
    }

    return obj;
  };

  var parseObject = function parseObject(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
      var obj;
      var root = chain[i];

      if (root === '[]' && options.parseArrays) {
        obj = [].concat(leaf);
      } else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
        var index = parseInt(cleanRoot, 10);

        if (!options.parseArrays && cleanRoot === '') {
          obj = {
            0: leaf
          };
        } else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
          obj = [];
          obj[index] = leaf;
        } else if (cleanRoot !== '__proto__') {
          obj[cleanRoot] = leaf;
        }
      }

      leaf = obj;
    }

    return leaf;
  };

  var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
      return;
    } // Transform dot notation to bracket notation


    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey; // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g; // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key; // Stash the parent if it exists

    var keys = [];

    if (parent) {
      // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
      if (!options.plainObjects && has.call(Object.prototype, parent)) {
        if (!options.allowPrototypes) {
          return;
        }
      }

      keys.push(parent);
    } // Loop through children appending to the array until we hit depth


    var i = 0;

    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
      i += 1;

      if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
        if (!options.allowPrototypes) {
          return;
        }
      }

      keys.push(segment[1]);
    } // If there's a remainder, just add whatever is left


    if (segment) {
      keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
  };

  var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
      return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
      throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
      throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
    return {
      allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
      allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
      allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
      arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
      charset: charset,
      charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
      comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
      decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
      delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
      // eslint-disable-next-line no-implicit-coercion, no-extra-parens
      depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : defaults.depth,
      ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
      interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
      parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
      parseArrays: opts.parseArrays !== false,
      plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
      strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
  };

  module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
      return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {}; // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];
      var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
      obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
      return obj;
    }

    return utils.compact(obj);
  };
  /***/

},
/* 50 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var getSideChannel = __webpack_require__(52);

  var utils = __webpack_require__(24);

  var formats = __webpack_require__(13);

  var has = Object.prototype.hasOwnProperty;
  var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
      return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
      return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
      return prefix;
    }
  };
  var isArray = Array.isArray;
  var push = Array.prototype.push;

  var pushToArray = function pushToArray(arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
  };

  var toISO = Date.prototype.toISOString;
  var defaultFormat = formats['default'];
  var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
      return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
  };

  var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
  };

  var sentinel = {};

  var stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;

    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
      // Where object last appeared in the ref tree
      var pos = tmpSc.get(object);
      step += 1;

      if (typeof pos !== 'undefined') {
        if (pos === step) {
          throw new RangeError('Cyclic object value');
        } else {
          findFlag = true; // Break while
        }
      }

      if (typeof tmpSc.get(sentinel) === 'undefined') {
        step = 0;
      }
    }

    if (typeof filter === 'function') {
      obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
      obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
      obj = utils.maybeMap(obj, function (value) {
        if (value instanceof Date) {
          return serializeDate(value);
        }

        return value;
      });
    }

    if (obj === null) {
      if (strictNullHandling) {
        return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
      }

      obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
      if (encoder) {
        var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
        return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
      }

      return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
      return values;
    }

    var objKeys;

    if (generateArrayPrefix === 'comma' && isArray(obj)) {
      // we need to join elements in
      if (encodeValuesOnly && encoder) {
        obj = utils.maybeMap(obj, encoder);
      }

      objKeys = [{
        value: obj.length > 0 ? obj.join(',') || null : void undefined
      }];
    } else if (isArray(filter)) {
      objKeys = filter;
    } else {
      var keys = Object.keys(obj);
      objKeys = sort ? keys.sort(sort) : keys;
    }

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;

    for (var j = 0; j < objKeys.length; ++j) {
      var key = objKeys[j];
      var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];

      if (skipNulls && value === null) {
        continue;
      }

      var keyPrefix = isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
      sideChannel.set(object, step);
      var valueSideChannel = getSideChannel();
      valueSideChannel.set(sentinel, sideChannel);
      pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }

    return values;
  };

  var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
      return defaults;
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
      throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
      throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];

    if (typeof opts.format !== 'undefined') {
      if (!has.call(formats.formatters, opts.format)) {
        throw new TypeError('Unknown format option provided.');
      }

      format = opts.format;
    }

    var formatter = formats.formatters[format];
    var filter = defaults.filter;

    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
      filter = opts.filter;
    }

    return {
      addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
      allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
      charset: charset,
      charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
      delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
      encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
      encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
      encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
      filter: filter,
      format: format,
      formatter: formatter,
      serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
      skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
      sort: typeof opts.sort === 'function' ? opts.sort : null,
      strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
  };

  module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);
    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
      filter = options.filter;
      obj = filter('', obj);
    } else if (isArray(options.filter)) {
      filter = options.filter;
      objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
      return '';
    }

    var arrayFormat;

    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
      arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
      arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
      arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
      throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;

    if (!objKeys) {
      objKeys = Object.keys(obj);
    }

    if (options.sort) {
      objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();

    for (var i = 0; i < objKeys.length; ++i) {
      var key = objKeys[i];

      if (options.skipNulls && obj[key] === null) {
        continue;
      }

      pushToArray(keys, stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
      if (options.charset === 'iso-8859-1') {
        // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
      } else {
        // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
      }
    }

    return joined.length > 0 ? prefix + joined : '';
  };
  /***/

},
/* 51 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var GetIntrinsic = __webpack_require__(0);

  var define = __webpack_require__(40);

  var hasDescriptors = __webpack_require__(22)();

  var gOPD = __webpack_require__(21);

  var $TypeError = GetIntrinsic('%TypeError%');
  var $floor = GetIntrinsic('%Math.floor%');

  module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') {
      throw new $TypeError('`fn` is not a function');
    }

    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
      throw new $TypeError('`length` must be a positive 32-bit integer');
    }

    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;

    if ('length' in fn && gOPD) {
      var desc = gOPD(fn, 'length');

      if (desc && !desc.configurable) {
        functionLengthIsConfigurable = false;
      }

      if (desc && !desc.writable) {
        functionLengthIsWritable = false;
      }
    }

    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
      if (hasDescriptors) {
        define(fn, 'length', length, true, true);
      } else {
        define(fn, 'length', length);
      }
    }

    return fn;
  };
  /***/

},
/* 52 */

/***/
function (module, exports, __webpack_require__) {
  "use strict";
  'use strict';

  var GetIntrinsic = __webpack_require__(0);

  var callBound = __webpack_require__(38);

  var inspect = __webpack_require__(47);

  var $TypeError = GetIntrinsic('%TypeError%');
  var $WeakMap = GetIntrinsic('%WeakMap%', true);
  var $Map = GetIntrinsic('%Map%', true);
  var $weakMapGet = callBound('WeakMap.prototype.get', true);
  var $weakMapSet = callBound('WeakMap.prototype.set', true);
  var $weakMapHas = callBound('WeakMap.prototype.has', true);
  var $mapGet = callBound('Map.prototype.get', true);
  var $mapSet = callBound('Map.prototype.set', true);
  var $mapHas = callBound('Map.prototype.has', true);
  /*
   * This function traverses the list returning the node corresponding to the
   * given key.
   *
   * That node is also moved to the head of the list, so that if it's accessed
   * again we don't need to traverse the whole list. By doing so, all the recently
   * used nodes can be accessed relatively quickly.
   */

  var listGetNode = function listGetNode(list, key) {
    // eslint-disable-line consistent-return
    for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
      if (curr.key === key) {
        prev.next = curr.next;
        curr.next = list.next;
        list.next = curr; // eslint-disable-line no-param-reassign

        return curr;
      }
    }
  };

  var listGet = function listGet(objects, key) {
    var node = listGetNode(objects, key);
    return node && node.value;
  };

  var listSet = function listSet(objects, key, value) {
    var node = listGetNode(objects, key);

    if (node) {
      node.value = value;
    } else {
      // Prepend the new node to the beginning of the list
      objects.next = {
        // eslint-disable-line no-param-reassign
        key: key,
        next: objects.next,
        value: value
      };
    }
  };

  var listHas = function listHas(objects, key) {
    return !!listGetNode(objects, key);
  };

  module.exports = function getSideChannel() {
    var $wm;
    var $m;
    var $o;
    var channel = {
      assert: function assert(key) {
        if (!channel.has(key)) {
          throw new $TypeError('Side channel does not contain ' + inspect(key));
        }
      },
      get: function get(key) {
        // eslint-disable-line consistent-return
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if ($wm) {
            return $weakMapGet($wm, key);
          }
        } else if ($Map) {
          if ($m) {
            return $mapGet($m, key);
          }
        } else {
          if ($o) {
            // eslint-disable-line no-lonely-if
            return listGet($o, key);
          }
        }
      },
      has: function has(key) {
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if ($wm) {
            return $weakMapHas($wm, key);
          }
        } else if ($Map) {
          if ($m) {
            return $mapHas($m, key);
          }
        } else {
          if ($o) {
            // eslint-disable-line no-lonely-if
            return listHas($o, key);
          }
        }

        return false;
      },
      set: function set(key, value) {
        if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
          if (!$wm) {
            $wm = new $WeakMap();
          }

          $weakMapSet($wm, key, value);
        } else if ($Map) {
          if (!$m) {
            $m = new $Map();
          }

          $mapSet($m, key, value);
        } else {
          if (!$o) {
            /*
             * Initialize the linked list as an empty node, so that we don't have
             * to special-case handling of the first node: we can always refer to
             * it as (previous node).next, instead of something like (list).head
             */
            $o = {
              key: {},
              next: null
            };
          }

          listSet($o, key, value);
        }
      }
    };
    return channel;
  };
  /***/

},
/* 53 */

/***/
function (module, exports) {
  module.exports = require("socket.io-client");
  /***/
},
/* 54 */

/***/
function (module, exports) {
  module.exports = require("superagent");
  /***/
},
/* 55 */

/***/
function (module, exports) {
  /* (ignored) */

  /***/
},
/* 56 */

/***/
function (module, exports, __webpack_require__) {
  module.exports = __webpack_require__(26);
  /***/
}
/******/
]);